/**
 * Generated by orval v7.7.0 🍺
 * Do not edit manually.
 * Brands Web API v2
 * OpenAPI spec version: v2
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import * as axios from 'axios';
import type {
  AxiosError,
  AxiosRequestConfig,
  AxiosResponse
} from 'axios';

import type {
  AccrualHistoryEntrySchema,
  AcknowledgeEssHrDocumentRequestSchema,
  ActivateEmployeeDocumentTypeVersionSchema,
  ActivationBgCheckStatusDtoSchema,
  AddCustomReportSchema,
  AddEmployeeAccountSchema,
  AddEmployeeDocumentTypeSchema,
  AddEmployeeIdentificationInfoBody,
  AddOnboardingEmployeeResponseSchema,
  AddOnboardingEmployeeSchema,
  ApproveCheckIssueResultSchema,
  ApproveHrDocumentRequestSchema,
  ApproveOnboardingStepSchema,
  AtsApplicantDtoSchema,
  AtsProviderConfigDtoSchema,
  AuthenticatorSetupInfoSchema,
  AuthenticatorVerifyResultSchema,
  BackgroundCheckFlowConfigDtoSchema,
  BackgroundCheckOrderDtoSchema,
  BackgroundCheckOrderGroupDtoSchema,
  BackgroundCheckPackageDtoSchema,
  BackgroundCheckProviderConfigDtoSchema,
  BackgroundCheckProviderSettingsDtoSchema,
  BannerViewSchema,
  BeginResetPasswordRequestSchema,
  ChangePasswordRequestSchema,
  CheckSchema,
  CompleteEmployeeOnboardingSystemStepParams,
  ContractorInfoSchema,
  ContractorInfoUpdateSchema,
  CreateAccrualEntryRequestSchema,
  CreateChecksPayloadSchema,
  CreatePowerGridResponseSchema,
  CreatePowerGridSchema,
  CustomReportDetailsSchema,
  CustomReportsListItemSchema,
  DeleteChecksParams,
  DivisionSchema,
  DocuSealTokenResponseSchema,
  DocumentTypeCreatedResultSchema,
  DocumentsEmployeeDocumentTypeSchema,
  DuplicateEmployeeOnboardingFlowSchema,
  EmployeeBackgroundCheckStatusDtoSchema,
  EmployeeCheckMemoSchema,
  EmployeeDeductionSchema,
  EmployeeDetailsSchema,
  EmployeeDocumentTypeVersionDetailsSchema,
  EmployeeDocumentTypeVersionSchema,
  EmployeeEarningSchema,
  EmployeeFilterCriteriaSchema,
  EmployeeFilterOptionsSchema,
  EmployeeFilterSchema,
  EmployeeIdentificationInfoSchema,
  EmployeeJobDropdownsSchema,
  EmployeeListFilterSchema,
  EmployeeListSchema,
  EmployeeMemoSchema,
  EmployeeOnboardingDocumentTemplateSchema,
  EmployeeOnboardingFieldDetailsSchema,
  EmployeeOnboardingFieldSchema,
  EmployeeOnboardingFlowDetailsSchema,
  EmployeeOnboardingFlowSchema,
  EmployeeOnboardingStatusSchema,
  EmployeeOnboardingStepDetailsSchema,
  EmployeeOnboardingTemplateFieldSchema,
  EmployeePersonalInfoOptionsSchema,
  EmployeePickerCriteriaMatchesSchema,
  EmployeePickerEmployeeSchema,
  EmployeePickerFiltersSchema,
  EmployeeRootSchema,
  EmployeeTimeAndLaborSchema,
  EmployeeWelcomeScreenSchema,
  EmployerFormSchema,
  EssHrDocumentDetailSchema,
  EssHrDocumentListItemSchema,
  EssHrDocumentSignSlugSchema,
  EssHrDocumentTemplateInfoSchema,
  FeatureFlagStateSchema,
  FlowsEmployeeOnboardingStepSchema,
  ForgotPasswordRequestSchema,
  GetActiveBannerParams,
  GetBackgroundCheckPackagesParams,
  GetDistributedPowerGridResponseSchema,
  GetDistributedPowerGridRowsParams,
  GetDocumentParams,
  GetEmployeeOnboardingDocumentAttachmentParams,
  GetEmployeeOnboardingFlowsParams,
  GetEmployerDocumentAttachmentParams,
  GetHrDocumentsParams,
  GetMatchingFlowsRequestSchema,
  GetNewPowerGridPayeeParams,
  GetOnboardingEmployeesParams,
  GetPaymentAddressesParams,
  GetRateChangesHistoryParams,
  HrDocumentAssignmentConflictSchema,
  HrDocumentAssignmentConflictsRequestSchema,
  HrDocumentAssignmentsCreateRequestSchema,
  HrDocumentAssignmentsCreateResultSchema,
  HrDocumentDetailSchema,
  HrDocumentEmployerSignSlugSchema,
  HrDocumentListItemSchema,
  HrDocumentsUploadResultSchema,
  ImpersonateUserParams,
  InsertEmployeeOnboardingFlowSchema,
  LoginRequestSchema,
  LogoutRequestSchema,
  ManualCheckDetailsSchema,
  MarkApplicantImportedRequestSchema,
  MatchingEmployeeOnboardingFlowSchema,
  NewEmployeeSchema,
  OnboardingEmployeeSchema,
  OverrideBackgroundCheckRequestSchema,
  PayCodeSchema,
  PaydeckSettingsSchema,
  PaymentAddressSchema,
  PayrollChecksColumnSettingsSchema,
  PayrollChecksSortSettingsSchema,
  PayrollEntryIssueSchema,
  PayrollSchema,
  PayrollSettingsSchema,
  PayrollStatusDataSchema,
  PowerGridAndImportSchema,
  PowerGridDataSchema,
  PowerGridRowSchema,
  PowerGridSchemaSchema,
  PowerGridsCompletionRequestSchema,
  ProblemDetailsSchema,
  ProcessPowerGridsSchema,
  ReceivePostbackParams,
  RecordCreatedResultSchema,
  RecoveryCodeLoginRequestSchema,
  RecoveryCodesResultSchema,
  RenameEmployeeDocumentTypeSchema,
  ReopenEmployeeOnboardingInfoSchema,
  ReopenEmployeeOnboardingSystemStepParams,
  ReopenHrDocumentRequestSchema,
  RequestStepUpdateSchema,
  ResendInviteEmailRequestSchema,
  ResetPasswordRequestSchema,
  ReviewEmployeeIdentificationInfoSchema,
  ReviewEmployeeOnboardingStepDetailsSchema,
  ReviewEmployeeOnboardingStepSchema,
  RunCustomReportSchema,
  SapphireSamlSsoResponseSchema,
  SecondCheckRuleOptionsSchema,
  SecondCheckRuleRequestSchema,
  SecondCheckRuleSchema,
  SendBackgroundCheckRequestSchema,
  SetUpPasswordSchema,
  SetUpTwoFactorAuthSchema,
  ShareCustomReportSchema,
  SkipTwoFactorAuthPromptRequestSchema,
  SubmitEssHrDocumentFormRequestSchema,
  SubmitHrDocumentEmployerFormRequestSchema,
  SubmitOnboardingCustomTemplateSchema,
  SubmitOnboardingSystemTemplateSchema,
  SwitchProfileRequestSchema,
  ThirdPartyIntegrationLinkSchema,
  TimePeriodRpcSchema,
  TwoFactorAuthDetailsSchema,
  TwoFactorLoginRequestSchema,
  UpdateAccrualEntryRequestSchema,
  UpdateChecksNetOverrideSchema,
  UpdateChecksSchema,
  UpdateCustomReportSchema,
  UpdateEmployeeDocuSealTemplateSchema,
  UpdateEmployeeDocumentTypeStatusSchema,
  UpdateEmployeeDocumentTypeVersionSchema,
  UpdateEmployeeFieldAttachmentBody,
  UpdateEmployeeIdDocumentsInfoResponseSchema,
  UpdateEmployeeIdDocumentsInfoSchema,
  UpdateEmployeeInfoSchema,
  UpdateEmployeeOnboardingDocumentAttachmentBody,
  UpdateEmployeeOnboardingDocumentDetailsBody,
  UpdateEmployeeOnboardingFlowSchema,
  UpdateEmployeeOnboardingFlowStatusSchema,
  UpdateEmployeeOnboardingStepConfigurationSchema,
  UpdateEmployerDocumentAttachmentBody,
  UpdateEmployerFieldAttachmentBody,
  UpdateHrDocumentEmployerFieldsRequestSchema,
  UpdateOnboardingStepDetailsSchema,
  UpdatePowerGridSchema,
  UpdateProfileRequestSchema,
  UpdateWelcomeScreenConfigSchema,
  UploadEssHrDocumentFilesBody,
  UploadHrDocumentsBody,
  UploadWelcomeScreenLogoBody,
  UpsertAtsProviderConfigRequestSchema,
  UpsertBackgroundCheckFlowConfigRequestSchema,
  UpsertBackgroundCheckProviderConfigRequestSchema,
  UpsertEmployeeDocumentTypeVersionSchema,
  UpsertEmployeeFilterSchema,
  UpsertEmployeeOnboardingFieldSchema,
  UpsertPaymentAddressSchema,
  UserAuthorizationResultsSchema,
  ValidateEmployeeNumberParams,
  VerifyCodeSchema,
  WelcomeScreenConfigSchema
} from './schemas';

import { createFormData } from '../overrides/create-form-data';

// https://stackoverflow.com/questions/49579094/typescript-conditional-types-filter-out-readonly-properties-pick-only-requir/49579497#49579497
type IfEquals<X, Y, A = X, B = never> = (<T>() => T extends X ? 1 : 2) extends <
T,
>() => T extends Y ? 1 : 2
? A
: B;

type WritableKeys<T> = {
[P in keyof T]-?: IfEquals<
  { [Q in P]: T[P] },
  { -readonly [Q in P]: T[P] },
  P
>;
}[keyof T];

type UnionToIntersection<U> =
  (U extends any ? (k: U)=>void : never) extends ((k: infer I)=>void) ? I : never;
type DistributeReadOnlyOverUnions<T> = T extends any ? NonReadonly<T> : never;

type Writable<T> = Pick<T, WritableKeys<T>>;
type NonReadonly<T> = [T] extends [UnionToIntersection<T>] ? {
  [P in keyof Writable<T>]: T[P] extends object
    ? NonReadonly<NonNullable<T[P]>>
    : T[P];
} : DistributeReadOnlyOverUnions<T>;

export const changePassword = (
    changePasswordRequestSchema: ChangePasswordRequestSchema, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<UserAuthorizationResultsSchema>> => {
    
    
    return axios.default.post(
      `/api/auth/ChangePassword`,
      changePasswordRequestSchema,options
    );
  }



export const getChangePasswordMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof changePassword>>, TError,{data: ChangePasswordRequestSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof changePassword>>, TError,{data: ChangePasswordRequestSchema}, TContext> => {
    
const mutationKey = ['changePassword'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof changePassword>>, {data: ChangePasswordRequestSchema}> = (props) => {
          const {data} = props ?? {};

          return  changePassword(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ChangePasswordMutationResult = NonNullable<Awaited<ReturnType<typeof changePassword>>>
    export type ChangePasswordMutationBody = ChangePasswordRequestSchema
    export type ChangePasswordMutationError = AxiosError<unknown>

    export const useChangePassword = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof changePassword>>, TError,{data: ChangePasswordRequestSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof changePassword>>,
        TError,
        {data: ChangePasswordRequestSchema},
        TContext
      > => {

      const mutationOptions = getChangePasswordMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const setUpPassword = (
    setUpPasswordSchema: SetUpPasswordSchema, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<UserAuthorizationResultsSchema>> => {
    
    
    return axios.default.post(
      `/api/auth/SetUpPassword`,
      setUpPasswordSchema,options
    );
  }



export const getSetUpPasswordMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setUpPassword>>, TError,{data: SetUpPasswordSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof setUpPassword>>, TError,{data: SetUpPasswordSchema}, TContext> => {
    
const mutationKey = ['setUpPassword'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setUpPassword>>, {data: SetUpPasswordSchema}> = (props) => {
          const {data} = props ?? {};

          return  setUpPassword(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SetUpPasswordMutationResult = NonNullable<Awaited<ReturnType<typeof setUpPassword>>>
    export type SetUpPasswordMutationBody = SetUpPasswordSchema
    export type SetUpPasswordMutationError = AxiosError<unknown>

    export const useSetUpPassword = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setUpPassword>>, TError,{data: SetUpPasswordSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof setUpPassword>>,
        TError,
        {data: SetUpPasswordSchema},
        TContext
      > => {

      const mutationOptions = getSetUpPasswordMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const forgotPassword = (
    forgotPasswordRequestSchema: ForgotPasswordRequestSchema, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<UserAuthorizationResultsSchema>> => {
    
    
    return axios.default.post(
      `/api/auth/ForgotPassword`,
      forgotPasswordRequestSchema,options
    );
  }



export const getForgotPasswordMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof forgotPassword>>, TError,{data: ForgotPasswordRequestSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof forgotPassword>>, TError,{data: ForgotPasswordRequestSchema}, TContext> => {
    
const mutationKey = ['forgotPassword'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof forgotPassword>>, {data: ForgotPasswordRequestSchema}> = (props) => {
          const {data} = props ?? {};

          return  forgotPassword(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ForgotPasswordMutationResult = NonNullable<Awaited<ReturnType<typeof forgotPassword>>>
    export type ForgotPasswordMutationBody = ForgotPasswordRequestSchema
    export type ForgotPasswordMutationError = AxiosError<unknown>

    export const useForgotPassword = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof forgotPassword>>, TError,{data: ForgotPasswordRequestSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof forgotPassword>>,
        TError,
        {data: ForgotPasswordRequestSchema},
        TContext
      > => {

      const mutationOptions = getForgotPasswordMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const impersonateUser = (
    userId: number,
    params?: ImpersonateUserParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<UserAuthorizationResultsSchema>> => {
    
    
    return axios.default.post(
      `/api/auth/ImpersonateUser/${userId}`,undefined,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getImpersonateUserMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof impersonateUser>>, TError,{userId: number;params?: ImpersonateUserParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof impersonateUser>>, TError,{userId: number;params?: ImpersonateUserParams}, TContext> => {
    
const mutationKey = ['impersonateUser'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof impersonateUser>>, {userId: number;params?: ImpersonateUserParams}> = (props) => {
          const {userId,params} = props ?? {};

          return  impersonateUser(userId,params,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ImpersonateUserMutationResult = NonNullable<Awaited<ReturnType<typeof impersonateUser>>>
    
    export type ImpersonateUserMutationError = AxiosError<unknown>

    export const useImpersonateUser = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof impersonateUser>>, TError,{userId: number;params?: ImpersonateUserParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof impersonateUser>>,
        TError,
        {userId: number;params?: ImpersonateUserParams},
        TContext
      > => {

      const mutationOptions = getImpersonateUserMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const login = (
    loginRequestSchema: LoginRequestSchema, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<UserAuthorizationResultsSchema>> => {
    
    
    return axios.default.post(
      `/api/auth/login`,
      loginRequestSchema,options
    );
  }



export const getLoginMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof login>>, TError,{data: LoginRequestSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof login>>, TError,{data: LoginRequestSchema}, TContext> => {
    
const mutationKey = ['login'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof login>>, {data: LoginRequestSchema}> = (props) => {
          const {data} = props ?? {};

          return  login(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type LoginMutationResult = NonNullable<Awaited<ReturnType<typeof login>>>
    export type LoginMutationBody = LoginRequestSchema
    export type LoginMutationError = AxiosError<unknown>

    export const useLogin = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof login>>, TError,{data: LoginRequestSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof login>>,
        TError,
        {data: LoginRequestSchema},
        TContext
      > => {

      const mutationOptions = getLoginMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const logoutImpersonate = (
    logoutRequestSchema: LogoutRequestSchema, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<UserAuthorizationResultsSchema>> => {
    
    
    return axios.default.post(
      `/api/auth/Logout`,
      logoutRequestSchema,options
    );
  }



export const getLogoutImpersonateMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof logoutImpersonate>>, TError,{data: LogoutRequestSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof logoutImpersonate>>, TError,{data: LogoutRequestSchema}, TContext> => {
    
const mutationKey = ['logoutImpersonate'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof logoutImpersonate>>, {data: LogoutRequestSchema}> = (props) => {
          const {data} = props ?? {};

          return  logoutImpersonate(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type LogoutImpersonateMutationResult = NonNullable<Awaited<ReturnType<typeof logoutImpersonate>>>
    export type LogoutImpersonateMutationBody = LogoutRequestSchema
    export type LogoutImpersonateMutationError = AxiosError<unknown>

    export const useLogoutImpersonate = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof logoutImpersonate>>, TError,{data: LogoutRequestSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof logoutImpersonate>>,
        TError,
        {data: LogoutRequestSchema},
        TContext
      > => {

      const mutationOptions = getLogoutImpersonateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getProfile = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<UserAuthorizationResultsSchema>> => {
    
    
    return axios.default.get(
      `/api/auth/Profile`,options
    );
  }


export const getGetProfileQueryKey = () => {
    return [`/api/auth/Profile`] as const;
    }

    
export const getGetProfileQueryOptions = <TData = Awaited<ReturnType<typeof getProfile>>, TError = AxiosError<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProfile>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProfileQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProfile>>> = ({ signal }) => getProfile({ signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProfile>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProfileQueryResult = NonNullable<Awaited<ReturnType<typeof getProfile>>>
export type GetProfileQueryError = AxiosError<unknown>


export function useGetProfile<TData = Awaited<ReturnType<typeof getProfile>>, TError = AxiosError<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProfile>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProfile>>,
          TError,
          Awaited<ReturnType<typeof getProfile>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProfile<TData = Awaited<ReturnType<typeof getProfile>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProfile>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProfile>>,
          TError,
          Awaited<ReturnType<typeof getProfile>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProfile<TData = Awaited<ReturnType<typeof getProfile>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProfile>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetProfile<TData = Awaited<ReturnType<typeof getProfile>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProfile>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProfileQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const twoFactorLoginWithRecoveryCode = (
    recoveryCodeLoginRequestSchema: RecoveryCodeLoginRequestSchema, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<UserAuthorizationResultsSchema>> => {
    
    
    return axios.default.post(
      `/api/auth/RecoveryCodes/Login`,
      recoveryCodeLoginRequestSchema,options
    );
  }



export const getTwoFactorLoginWithRecoveryCodeMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof twoFactorLoginWithRecoveryCode>>, TError,{data: RecoveryCodeLoginRequestSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof twoFactorLoginWithRecoveryCode>>, TError,{data: RecoveryCodeLoginRequestSchema}, TContext> => {
    
const mutationKey = ['twoFactorLoginWithRecoveryCode'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof twoFactorLoginWithRecoveryCode>>, {data: RecoveryCodeLoginRequestSchema}> = (props) => {
          const {data} = props ?? {};

          return  twoFactorLoginWithRecoveryCode(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type TwoFactorLoginWithRecoveryCodeMutationResult = NonNullable<Awaited<ReturnType<typeof twoFactorLoginWithRecoveryCode>>>
    export type TwoFactorLoginWithRecoveryCodeMutationBody = RecoveryCodeLoginRequestSchema
    export type TwoFactorLoginWithRecoveryCodeMutationError = AxiosError<unknown>

    export const useTwoFactorLoginWithRecoveryCode = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof twoFactorLoginWithRecoveryCode>>, TError,{data: RecoveryCodeLoginRequestSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof twoFactorLoginWithRecoveryCode>>,
        TError,
        {data: RecoveryCodeLoginRequestSchema},
        TContext
      > => {

      const mutationOptions = getTwoFactorLoginWithRecoveryCodeMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const resendInviteEmail = (
    resendInviteEmailRequestSchema: ResendInviteEmailRequestSchema, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<UserAuthorizationResultsSchema>> => {
    
    
    return axios.default.post(
      `/api/auth/ResendInviteEmail`,
      resendInviteEmailRequestSchema,options
    );
  }



export const getResendInviteEmailMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resendInviteEmail>>, TError,{data: ResendInviteEmailRequestSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof resendInviteEmail>>, TError,{data: ResendInviteEmailRequestSchema}, TContext> => {
    
const mutationKey = ['resendInviteEmail'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resendInviteEmail>>, {data: ResendInviteEmailRequestSchema}> = (props) => {
          const {data} = props ?? {};

          return  resendInviteEmail(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ResendInviteEmailMutationResult = NonNullable<Awaited<ReturnType<typeof resendInviteEmail>>>
    export type ResendInviteEmailMutationBody = ResendInviteEmailRequestSchema
    export type ResendInviteEmailMutationError = AxiosError<unknown>

    export const useResendInviteEmail = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resendInviteEmail>>, TError,{data: ResendInviteEmailRequestSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof resendInviteEmail>>,
        TError,
        {data: ResendInviteEmailRequestSchema},
        TContext
      > => {

      const mutationOptions = getResendInviteEmailMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const resetPassword = (
    resetPasswordRequestSchema: ResetPasswordRequestSchema, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<UserAuthorizationResultsSchema>> => {
    
    
    return axios.default.post(
      `/api/auth/ResetPassword`,
      resetPasswordRequestSchema,options
    );
  }



export const getResetPasswordMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetPassword>>, TError,{data: ResetPasswordRequestSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof resetPassword>>, TError,{data: ResetPasswordRequestSchema}, TContext> => {
    
const mutationKey = ['resetPassword'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resetPassword>>, {data: ResetPasswordRequestSchema}> = (props) => {
          const {data} = props ?? {};

          return  resetPassword(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ResetPasswordMutationResult = NonNullable<Awaited<ReturnType<typeof resetPassword>>>
    export type ResetPasswordMutationBody = ResetPasswordRequestSchema
    export type ResetPasswordMutationError = AxiosError<unknown>

    export const useResetPassword = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetPassword>>, TError,{data: ResetPasswordRequestSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof resetPassword>>,
        TError,
        {data: ResetPasswordRequestSchema},
        TContext
      > => {

      const mutationOptions = getResetPasswordMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const beginResetPassword = (
    beginResetPasswordRequestSchema: BeginResetPasswordRequestSchema, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<UserAuthorizationResultsSchema>> => {
    
    
    return axios.default.post(
      `/api/auth/ResetPassword/Begin`,
      beginResetPasswordRequestSchema,options
    );
  }



export const getBeginResetPasswordMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof beginResetPassword>>, TError,{data: BeginResetPasswordRequestSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof beginResetPassword>>, TError,{data: BeginResetPasswordRequestSchema}, TContext> => {
    
const mutationKey = ['beginResetPassword'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof beginResetPassword>>, {data: BeginResetPasswordRequestSchema}> = (props) => {
          const {data} = props ?? {};

          return  beginResetPassword(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type BeginResetPasswordMutationResult = NonNullable<Awaited<ReturnType<typeof beginResetPassword>>>
    export type BeginResetPasswordMutationBody = BeginResetPasswordRequestSchema
    export type BeginResetPasswordMutationError = AxiosError<unknown>

    export const useBeginResetPassword = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof beginResetPassword>>, TError,{data: BeginResetPasswordRequestSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof beginResetPassword>>,
        TError,
        {data: BeginResetPasswordRequestSchema},
        TContext
      > => {

      const mutationOptions = getBeginResetPasswordMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const skipTwoFactorAuthPrompt = (
    skipTwoFactorAuthPromptRequestSchema: SkipTwoFactorAuthPromptRequestSchema, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<UserAuthorizationResultsSchema>> => {
    
    
    return axios.default.post(
      `/api/auth/SkipTwoFactorPrompt`,
      skipTwoFactorAuthPromptRequestSchema,options
    );
  }



export const getSkipTwoFactorAuthPromptMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof skipTwoFactorAuthPrompt>>, TError,{data: SkipTwoFactorAuthPromptRequestSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof skipTwoFactorAuthPrompt>>, TError,{data: SkipTwoFactorAuthPromptRequestSchema}, TContext> => {
    
const mutationKey = ['skipTwoFactorAuthPrompt'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof skipTwoFactorAuthPrompt>>, {data: SkipTwoFactorAuthPromptRequestSchema}> = (props) => {
          const {data} = props ?? {};

          return  skipTwoFactorAuthPrompt(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SkipTwoFactorAuthPromptMutationResult = NonNullable<Awaited<ReturnType<typeof skipTwoFactorAuthPrompt>>>
    export type SkipTwoFactorAuthPromptMutationBody = SkipTwoFactorAuthPromptRequestSchema
    export type SkipTwoFactorAuthPromptMutationError = AxiosError<unknown>

    export const useSkipTwoFactorAuthPrompt = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof skipTwoFactorAuthPrompt>>, TError,{data: SkipTwoFactorAuthPromptRequestSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof skipTwoFactorAuthPrompt>>,
        TError,
        {data: SkipTwoFactorAuthPromptRequestSchema},
        TContext
      > => {

      const mutationOptions = getSkipTwoFactorAuthPromptMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const switchProfile = (
    switchProfileRequestSchema: SwitchProfileRequestSchema, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<UserAuthorizationResultsSchema>> => {
    
    
    return axios.default.post(
      `/api/auth/SwitchProfile`,
      switchProfileRequestSchema,options
    );
  }



export const getSwitchProfileMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof switchProfile>>, TError,{data: SwitchProfileRequestSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof switchProfile>>, TError,{data: SwitchProfileRequestSchema}, TContext> => {
    
const mutationKey = ['switchProfile'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof switchProfile>>, {data: SwitchProfileRequestSchema}> = (props) => {
          const {data} = props ?? {};

          return  switchProfile(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SwitchProfileMutationResult = NonNullable<Awaited<ReturnType<typeof switchProfile>>>
    export type SwitchProfileMutationBody = SwitchProfileRequestSchema
    export type SwitchProfileMutationError = AxiosError<unknown>

    export const useSwitchProfile = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof switchProfile>>, TError,{data: SwitchProfileRequestSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof switchProfile>>,
        TError,
        {data: SwitchProfileRequestSchema},
        TContext
      > => {

      const mutationOptions = getSwitchProfileMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const twoFactorLoginWithOTP = (
    twoFactorLoginRequestSchema: TwoFactorLoginRequestSchema, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<UserAuthorizationResultsSchema>> => {
    
    
    return axios.default.post(
      `/api/auth/TwoFactorLogin`,
      twoFactorLoginRequestSchema,options
    );
  }



export const getTwoFactorLoginWithOTPMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof twoFactorLoginWithOTP>>, TError,{data: TwoFactorLoginRequestSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof twoFactorLoginWithOTP>>, TError,{data: TwoFactorLoginRequestSchema}, TContext> => {
    
const mutationKey = ['twoFactorLoginWithOTP'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof twoFactorLoginWithOTP>>, {data: TwoFactorLoginRequestSchema}> = (props) => {
          const {data} = props ?? {};

          return  twoFactorLoginWithOTP(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type TwoFactorLoginWithOTPMutationResult = NonNullable<Awaited<ReturnType<typeof twoFactorLoginWithOTP>>>
    export type TwoFactorLoginWithOTPMutationBody = TwoFactorLoginRequestSchema
    export type TwoFactorLoginWithOTPMutationError = AxiosError<unknown>

    export const useTwoFactorLoginWithOTP = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof twoFactorLoginWithOTP>>, TError,{data: TwoFactorLoginRequestSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof twoFactorLoginWithOTP>>,
        TError,
        {data: TwoFactorLoginRequestSchema},
        TContext
      > => {

      const mutationOptions = getTwoFactorLoginWithOTPMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const updateUserProfile = (
    updateProfileRequestSchema: UpdateProfileRequestSchema, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<UserAuthorizationResultsSchema>> => {
    
    
    return axios.default.post(
      `/api/auth/UpdateUserProfile`,
      updateProfileRequestSchema,options
    );
  }



export const getUpdateUserProfileMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateUserProfile>>, TError,{data: UpdateProfileRequestSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof updateUserProfile>>, TError,{data: UpdateProfileRequestSchema}, TContext> => {
    
const mutationKey = ['updateUserProfile'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateUserProfile>>, {data: UpdateProfileRequestSchema}> = (props) => {
          const {data} = props ?? {};

          return  updateUserProfile(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateUserProfileMutationResult = NonNullable<Awaited<ReturnType<typeof updateUserProfile>>>
    export type UpdateUserProfileMutationBody = UpdateProfileRequestSchema
    export type UpdateUserProfileMutationError = AxiosError<unknown>

    export const useUpdateUserProfile = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateUserProfile>>, TError,{data: UpdateProfileRequestSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof updateUserProfile>>,
        TError,
        {data: UpdateProfileRequestSchema},
        TContext
      > => {

      const mutationOptions = getUpdateUserProfileMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getActiveBanner = (
    params?: GetActiveBannerParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<BannerViewSchema>> => {
    
    
    return axios.default.get(
      `/api/banner/active`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getGetActiveBannerQueryKey = (params?: GetActiveBannerParams,) => {
    return [`/api/banner/active`, ...(params ? [params]: [])] as const;
    }

    
export const getGetActiveBannerQueryOptions = <TData = Awaited<ReturnType<typeof getActiveBanner>>, TError = AxiosError<unknown>>(params?: GetActiveBannerParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActiveBanner>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetActiveBannerQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getActiveBanner>>> = ({ signal }) => getActiveBanner(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getActiveBanner>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetActiveBannerQueryResult = NonNullable<Awaited<ReturnType<typeof getActiveBanner>>>
export type GetActiveBannerQueryError = AxiosError<unknown>


export function useGetActiveBanner<TData = Awaited<ReturnType<typeof getActiveBanner>>, TError = AxiosError<unknown>>(
 params: undefined |  GetActiveBannerParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActiveBanner>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActiveBanner>>,
          TError,
          Awaited<ReturnType<typeof getActiveBanner>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetActiveBanner<TData = Awaited<ReturnType<typeof getActiveBanner>>, TError = AxiosError<unknown>>(
 params?: GetActiveBannerParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActiveBanner>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActiveBanner>>,
          TError,
          Awaited<ReturnType<typeof getActiveBanner>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetActiveBanner<TData = Awaited<ReturnType<typeof getActiveBanner>>, TError = AxiosError<unknown>>(
 params?: GetActiveBannerParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActiveBanner>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetActiveBanner<TData = Awaited<ReturnType<typeof getActiveBanner>>, TError = AxiosError<unknown>>(
 params?: GetActiveBannerParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActiveBanner>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetActiveBannerQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getDashboardBanner = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<BannerViewSchema>> => {
    
    
    return axios.default.get(
      `/api/banner/dashboard`,options
    );
  }


export const getGetDashboardBannerQueryKey = () => {
    return [`/api/banner/dashboard`] as const;
    }

    
export const getGetDashboardBannerQueryOptions = <TData = Awaited<ReturnType<typeof getDashboardBanner>>, TError = AxiosError<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDashboardBanner>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDashboardBannerQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDashboardBanner>>> = ({ signal }) => getDashboardBanner({ signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDashboardBanner>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDashboardBannerQueryResult = NonNullable<Awaited<ReturnType<typeof getDashboardBanner>>>
export type GetDashboardBannerQueryError = AxiosError<unknown>


export function useGetDashboardBanner<TData = Awaited<ReturnType<typeof getDashboardBanner>>, TError = AxiosError<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDashboardBanner>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDashboardBanner>>,
          TError,
          Awaited<ReturnType<typeof getDashboardBanner>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDashboardBanner<TData = Awaited<ReturnType<typeof getDashboardBanner>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDashboardBanner>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDashboardBanner>>,
          TError,
          Awaited<ReturnType<typeof getDashboardBanner>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDashboardBanner<TData = Awaited<ReturnType<typeof getDashboardBanner>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDashboardBanner>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetDashboardBanner<TData = Awaited<ReturnType<typeof getDashboardBanner>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDashboardBanner>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDashboardBannerQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getLoginBanner = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<BannerViewSchema>> => {
    
    
    return axios.default.get(
      `/api/banner/login`,options
    );
  }


export const getGetLoginBannerQueryKey = () => {
    return [`/api/banner/login`] as const;
    }

    
export const getGetLoginBannerQueryOptions = <TData = Awaited<ReturnType<typeof getLoginBanner>>, TError = AxiosError<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoginBanner>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLoginBannerQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLoginBanner>>> = ({ signal }) => getLoginBanner({ signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLoginBanner>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLoginBannerQueryResult = NonNullable<Awaited<ReturnType<typeof getLoginBanner>>>
export type GetLoginBannerQueryError = AxiosError<unknown>


export function useGetLoginBanner<TData = Awaited<ReturnType<typeof getLoginBanner>>, TError = AxiosError<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoginBanner>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLoginBanner>>,
          TError,
          Awaited<ReturnType<typeof getLoginBanner>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLoginBanner<TData = Awaited<ReturnType<typeof getLoginBanner>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoginBanner>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLoginBanner>>,
          TError,
          Awaited<ReturnType<typeof getLoginBanner>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLoginBanner<TData = Awaited<ReturnType<typeof getLoginBanner>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoginBanner>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetLoginBanner<TData = Awaited<ReturnType<typeof getLoginBanner>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoginBanner>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLoginBannerQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getAtsProviderConfig = (
    providerId: 1, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<AtsProviderConfigDtoSchema>> => {
    
    
    return axios.default.get(
      `/api/Company/Ats/${providerId}/config`,options
    );
  }


export const getGetAtsProviderConfigQueryKey = (providerId: 1,) => {
    return [`/api/Company/Ats/${providerId}/config`] as const;
    }

    
export const getGetAtsProviderConfigQueryOptions = <TData = Awaited<ReturnType<typeof getAtsProviderConfig>>, TError = AxiosError<unknown>>(providerId: 1, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAtsProviderConfig>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAtsProviderConfigQueryKey(providerId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAtsProviderConfig>>> = ({ signal }) => getAtsProviderConfig(providerId, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(providerId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAtsProviderConfig>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAtsProviderConfigQueryResult = NonNullable<Awaited<ReturnType<typeof getAtsProviderConfig>>>
export type GetAtsProviderConfigQueryError = AxiosError<unknown>


export function useGetAtsProviderConfig<TData = Awaited<ReturnType<typeof getAtsProviderConfig>>, TError = AxiosError<unknown>>(
 providerId: 1, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAtsProviderConfig>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAtsProviderConfig>>,
          TError,
          Awaited<ReturnType<typeof getAtsProviderConfig>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAtsProviderConfig<TData = Awaited<ReturnType<typeof getAtsProviderConfig>>, TError = AxiosError<unknown>>(
 providerId: 1, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAtsProviderConfig>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAtsProviderConfig>>,
          TError,
          Awaited<ReturnType<typeof getAtsProviderConfig>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAtsProviderConfig<TData = Awaited<ReturnType<typeof getAtsProviderConfig>>, TError = AxiosError<unknown>>(
 providerId: 1, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAtsProviderConfig>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAtsProviderConfig<TData = Awaited<ReturnType<typeof getAtsProviderConfig>>, TError = AxiosError<unknown>>(
 providerId: 1, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAtsProviderConfig>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAtsProviderConfigQueryOptions(providerId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const upsertAtsProviderConfig = (
    providerId: 1,
    upsertAtsProviderConfigRequestSchema: UpsertAtsProviderConfigRequestSchema, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<AtsProviderConfigDtoSchema>> => {
    
    
    return axios.default.put(
      `/api/Company/Ats/${providerId}/config`,
      upsertAtsProviderConfigRequestSchema,options
    );
  }



export const getUpsertAtsProviderConfigMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof upsertAtsProviderConfig>>, TError,{providerId: 1;data: UpsertAtsProviderConfigRequestSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof upsertAtsProviderConfig>>, TError,{providerId: 1;data: UpsertAtsProviderConfigRequestSchema}, TContext> => {
    
const mutationKey = ['upsertAtsProviderConfig'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof upsertAtsProviderConfig>>, {providerId: 1;data: UpsertAtsProviderConfigRequestSchema}> = (props) => {
          const {providerId,data} = props ?? {};

          return  upsertAtsProviderConfig(providerId,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpsertAtsProviderConfigMutationResult = NonNullable<Awaited<ReturnType<typeof upsertAtsProviderConfig>>>
    export type UpsertAtsProviderConfigMutationBody = UpsertAtsProviderConfigRequestSchema
    export type UpsertAtsProviderConfigMutationError = AxiosError<unknown>

    export const useUpsertAtsProviderConfig = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof upsertAtsProviderConfig>>, TError,{providerId: 1;data: UpsertAtsProviderConfigRequestSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof upsertAtsProviderConfig>>,
        TError,
        {providerId: 1;data: UpsertAtsProviderConfigRequestSchema},
        TContext
      > => {

      const mutationOptions = getUpsertAtsProviderConfigMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const pollAtsProvider = (
    providerId: 1, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.default.post(
      `/api/Company/Ats/${providerId}/poll`,undefined,options
    );
  }



export const getPollAtsProviderMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pollAtsProvider>>, TError,{providerId: 1}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof pollAtsProvider>>, TError,{providerId: 1}, TContext> => {
    
const mutationKey = ['pollAtsProvider'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof pollAtsProvider>>, {providerId: 1}> = (props) => {
          const {providerId} = props ?? {};

          return  pollAtsProvider(providerId,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PollAtsProviderMutationResult = NonNullable<Awaited<ReturnType<typeof pollAtsProvider>>>
    
    export type PollAtsProviderMutationError = AxiosError<unknown>

    export const usePollAtsProvider = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pollAtsProvider>>, TError,{providerId: 1}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof pollAtsProvider>>,
        TError,
        {providerId: 1},
        TContext
      > => {

      const mutationOptions = getPollAtsProviderMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const ignoreAtsApplicant = (
    applicantId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.default.post(
      `/api/Company/AtsApplicants/${applicantId}/ignore`,undefined,options
    );
  }



export const getIgnoreAtsApplicantMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof ignoreAtsApplicant>>, TError,{applicantId: number}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof ignoreAtsApplicant>>, TError,{applicantId: number}, TContext> => {
    
const mutationKey = ['ignoreAtsApplicant'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof ignoreAtsApplicant>>, {applicantId: number}> = (props) => {
          const {applicantId} = props ?? {};

          return  ignoreAtsApplicant(applicantId,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type IgnoreAtsApplicantMutationResult = NonNullable<Awaited<ReturnType<typeof ignoreAtsApplicant>>>
    
    export type IgnoreAtsApplicantMutationError = AxiosError<unknown>

    export const useIgnoreAtsApplicant = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof ignoreAtsApplicant>>, TError,{applicantId: number}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof ignoreAtsApplicant>>,
        TError,
        {applicantId: number},
        TContext
      > => {

      const mutationOptions = getIgnoreAtsApplicantMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const markAtsApplicantImported = (
    applicantId: number,
    markApplicantImportedRequestSchema: MarkApplicantImportedRequestSchema, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.default.post(
      `/api/Company/AtsApplicants/${applicantId}/mark-imported`,
      markApplicantImportedRequestSchema,options
    );
  }



export const getMarkAtsApplicantImportedMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markAtsApplicantImported>>, TError,{applicantId: number;data: MarkApplicantImportedRequestSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof markAtsApplicantImported>>, TError,{applicantId: number;data: MarkApplicantImportedRequestSchema}, TContext> => {
    
const mutationKey = ['markAtsApplicantImported'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof markAtsApplicantImported>>, {applicantId: number;data: MarkApplicantImportedRequestSchema}> = (props) => {
          const {applicantId,data} = props ?? {};

          return  markAtsApplicantImported(applicantId,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type MarkAtsApplicantImportedMutationResult = NonNullable<Awaited<ReturnType<typeof markAtsApplicantImported>>>
    export type MarkAtsApplicantImportedMutationBody = MarkApplicantImportedRequestSchema
    export type MarkAtsApplicantImportedMutationError = AxiosError<unknown>

    export const useMarkAtsApplicantImported = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markAtsApplicantImported>>, TError,{applicantId: number;data: MarkApplicantImportedRequestSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof markAtsApplicantImported>>,
        TError,
        {applicantId: number;data: MarkApplicantImportedRequestSchema},
        TContext
      > => {

      const mutationOptions = getMarkAtsApplicantImportedMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getAtsApplicantHistory = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<AtsApplicantDtoSchema[]>> => {
    
    
    return axios.default.get(
      `/api/Company/AtsApplicants/history`,options
    );
  }


export const getGetAtsApplicantHistoryQueryKey = () => {
    return [`/api/Company/AtsApplicants/history`] as const;
    }

    
export const getGetAtsApplicantHistoryQueryOptions = <TData = Awaited<ReturnType<typeof getAtsApplicantHistory>>, TError = AxiosError<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAtsApplicantHistory>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAtsApplicantHistoryQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAtsApplicantHistory>>> = ({ signal }) => getAtsApplicantHistory({ signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAtsApplicantHistory>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAtsApplicantHistoryQueryResult = NonNullable<Awaited<ReturnType<typeof getAtsApplicantHistory>>>
export type GetAtsApplicantHistoryQueryError = AxiosError<unknown>


export function useGetAtsApplicantHistory<TData = Awaited<ReturnType<typeof getAtsApplicantHistory>>, TError = AxiosError<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAtsApplicantHistory>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAtsApplicantHistory>>,
          TError,
          Awaited<ReturnType<typeof getAtsApplicantHistory>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAtsApplicantHistory<TData = Awaited<ReturnType<typeof getAtsApplicantHistory>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAtsApplicantHistory>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAtsApplicantHistory>>,
          TError,
          Awaited<ReturnType<typeof getAtsApplicantHistory>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAtsApplicantHistory<TData = Awaited<ReturnType<typeof getAtsApplicantHistory>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAtsApplicantHistory>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAtsApplicantHistory<TData = Awaited<ReturnType<typeof getAtsApplicantHistory>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAtsApplicantHistory>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAtsApplicantHistoryQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getPendingAtsApplicants = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<AtsApplicantDtoSchema[]>> => {
    
    
    return axios.default.get(
      `/api/Company/AtsApplicants/pending`,options
    );
  }


export const getGetPendingAtsApplicantsQueryKey = () => {
    return [`/api/Company/AtsApplicants/pending`] as const;
    }

    
export const getGetPendingAtsApplicantsQueryOptions = <TData = Awaited<ReturnType<typeof getPendingAtsApplicants>>, TError = AxiosError<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPendingAtsApplicants>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPendingAtsApplicantsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPendingAtsApplicants>>> = ({ signal }) => getPendingAtsApplicants({ signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPendingAtsApplicants>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPendingAtsApplicantsQueryResult = NonNullable<Awaited<ReturnType<typeof getPendingAtsApplicants>>>
export type GetPendingAtsApplicantsQueryError = AxiosError<unknown>


export function useGetPendingAtsApplicants<TData = Awaited<ReturnType<typeof getPendingAtsApplicants>>, TError = AxiosError<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPendingAtsApplicants>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPendingAtsApplicants>>,
          TError,
          Awaited<ReturnType<typeof getPendingAtsApplicants>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPendingAtsApplicants<TData = Awaited<ReturnType<typeof getPendingAtsApplicants>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPendingAtsApplicants>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPendingAtsApplicants>>,
          TError,
          Awaited<ReturnType<typeof getPendingAtsApplicants>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPendingAtsApplicants<TData = Awaited<ReturnType<typeof getPendingAtsApplicants>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPendingAtsApplicants>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPendingAtsApplicants<TData = Awaited<ReturnType<typeof getPendingAtsApplicants>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPendingAtsApplicants>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPendingAtsApplicantsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getPendingAtsApplicantCount = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<number>> => {
    
    
    return axios.default.get(
      `/api/Company/AtsApplicants/pending/count`,options
    );
  }


export const getGetPendingAtsApplicantCountQueryKey = () => {
    return [`/api/Company/AtsApplicants/pending/count`] as const;
    }

    
export const getGetPendingAtsApplicantCountQueryOptions = <TData = Awaited<ReturnType<typeof getPendingAtsApplicantCount>>, TError = AxiosError<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPendingAtsApplicantCount>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPendingAtsApplicantCountQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPendingAtsApplicantCount>>> = ({ signal }) => getPendingAtsApplicantCount({ signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPendingAtsApplicantCount>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPendingAtsApplicantCountQueryResult = NonNullable<Awaited<ReturnType<typeof getPendingAtsApplicantCount>>>
export type GetPendingAtsApplicantCountQueryError = AxiosError<unknown>


export function useGetPendingAtsApplicantCount<TData = Awaited<ReturnType<typeof getPendingAtsApplicantCount>>, TError = AxiosError<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPendingAtsApplicantCount>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPendingAtsApplicantCount>>,
          TError,
          Awaited<ReturnType<typeof getPendingAtsApplicantCount>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPendingAtsApplicantCount<TData = Awaited<ReturnType<typeof getPendingAtsApplicantCount>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPendingAtsApplicantCount>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPendingAtsApplicantCount>>,
          TError,
          Awaited<ReturnType<typeof getPendingAtsApplicantCount>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPendingAtsApplicantCount<TData = Awaited<ReturnType<typeof getPendingAtsApplicantCount>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPendingAtsApplicantCount>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPendingAtsApplicantCount<TData = Awaited<ReturnType<typeof getPendingAtsApplicantCount>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPendingAtsApplicantCount>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPendingAtsApplicantCountQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getBackgroundCheckConfig = (
    providerId: 1, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<BackgroundCheckProviderConfigDtoSchema>> => {
    
    
    return axios.default.get(
      `/api/Company/BackgroundCheck/${providerId}/config`,options
    );
  }


export const getGetBackgroundCheckConfigQueryKey = (providerId: 1,) => {
    return [`/api/Company/BackgroundCheck/${providerId}/config`] as const;
    }

    
export const getGetBackgroundCheckConfigQueryOptions = <TData = Awaited<ReturnType<typeof getBackgroundCheckConfig>>, TError = AxiosError<unknown>>(providerId: 1, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBackgroundCheckConfig>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBackgroundCheckConfigQueryKey(providerId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBackgroundCheckConfig>>> = ({ signal }) => getBackgroundCheckConfig(providerId, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(providerId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBackgroundCheckConfig>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBackgroundCheckConfigQueryResult = NonNullable<Awaited<ReturnType<typeof getBackgroundCheckConfig>>>
export type GetBackgroundCheckConfigQueryError = AxiosError<unknown>


export function useGetBackgroundCheckConfig<TData = Awaited<ReturnType<typeof getBackgroundCheckConfig>>, TError = AxiosError<unknown>>(
 providerId: 1, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBackgroundCheckConfig>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBackgroundCheckConfig>>,
          TError,
          Awaited<ReturnType<typeof getBackgroundCheckConfig>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBackgroundCheckConfig<TData = Awaited<ReturnType<typeof getBackgroundCheckConfig>>, TError = AxiosError<unknown>>(
 providerId: 1, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBackgroundCheckConfig>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBackgroundCheckConfig>>,
          TError,
          Awaited<ReturnType<typeof getBackgroundCheckConfig>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBackgroundCheckConfig<TData = Awaited<ReturnType<typeof getBackgroundCheckConfig>>, TError = AxiosError<unknown>>(
 providerId: 1, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBackgroundCheckConfig>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetBackgroundCheckConfig<TData = Awaited<ReturnType<typeof getBackgroundCheckConfig>>, TError = AxiosError<unknown>>(
 providerId: 1, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBackgroundCheckConfig>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBackgroundCheckConfigQueryOptions(providerId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const upsertBackgroundCheckConfig = (
    providerId: 1,
    upsertBackgroundCheckProviderConfigRequestSchema: UpsertBackgroundCheckProviderConfigRequestSchema, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<BackgroundCheckProviderConfigDtoSchema>> => {
    
    
    return axios.default.put(
      `/api/Company/BackgroundCheck/${providerId}/config`,
      upsertBackgroundCheckProviderConfigRequestSchema,options
    );
  }



export const getUpsertBackgroundCheckConfigMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof upsertBackgroundCheckConfig>>, TError,{providerId: 1;data: UpsertBackgroundCheckProviderConfigRequestSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof upsertBackgroundCheckConfig>>, TError,{providerId: 1;data: UpsertBackgroundCheckProviderConfigRequestSchema}, TContext> => {
    
const mutationKey = ['upsertBackgroundCheckConfig'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof upsertBackgroundCheckConfig>>, {providerId: 1;data: UpsertBackgroundCheckProviderConfigRequestSchema}> = (props) => {
          const {providerId,data} = props ?? {};

          return  upsertBackgroundCheckConfig(providerId,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpsertBackgroundCheckConfigMutationResult = NonNullable<Awaited<ReturnType<typeof upsertBackgroundCheckConfig>>>
    export type UpsertBackgroundCheckConfigMutationBody = UpsertBackgroundCheckProviderConfigRequestSchema
    export type UpsertBackgroundCheckConfigMutationError = AxiosError<unknown>

    export const useUpsertBackgroundCheckConfig = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof upsertBackgroundCheckConfig>>, TError,{providerId: 1;data: UpsertBackgroundCheckProviderConfigRequestSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof upsertBackgroundCheckConfig>>,
        TError,
        {providerId: 1;data: UpsertBackgroundCheckProviderConfigRequestSchema},
        TContext
      > => {

      const mutationOptions = getUpsertBackgroundCheckConfigMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getBackgroundCheckPackages = (
    providerId: 1,
    params?: GetBackgroundCheckPackagesParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<BackgroundCheckPackageDtoSchema[]>> => {
    
    
    return axios.default.get(
      `/api/Company/BackgroundCheck/${providerId}/packages`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getGetBackgroundCheckPackagesQueryKey = (providerId: 1,
    params?: GetBackgroundCheckPackagesParams,) => {
    return [`/api/Company/BackgroundCheck/${providerId}/packages`, ...(params ? [params]: [])] as const;
    }

    
export const getGetBackgroundCheckPackagesQueryOptions = <TData = Awaited<ReturnType<typeof getBackgroundCheckPackages>>, TError = AxiosError<unknown>>(providerId: 1,
    params?: GetBackgroundCheckPackagesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBackgroundCheckPackages>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBackgroundCheckPackagesQueryKey(providerId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBackgroundCheckPackages>>> = ({ signal }) => getBackgroundCheckPackages(providerId,params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(providerId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBackgroundCheckPackages>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBackgroundCheckPackagesQueryResult = NonNullable<Awaited<ReturnType<typeof getBackgroundCheckPackages>>>
export type GetBackgroundCheckPackagesQueryError = AxiosError<unknown>


export function useGetBackgroundCheckPackages<TData = Awaited<ReturnType<typeof getBackgroundCheckPackages>>, TError = AxiosError<unknown>>(
 providerId: 1,
    params: undefined |  GetBackgroundCheckPackagesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBackgroundCheckPackages>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBackgroundCheckPackages>>,
          TError,
          Awaited<ReturnType<typeof getBackgroundCheckPackages>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBackgroundCheckPackages<TData = Awaited<ReturnType<typeof getBackgroundCheckPackages>>, TError = AxiosError<unknown>>(
 providerId: 1,
    params?: GetBackgroundCheckPackagesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBackgroundCheckPackages>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBackgroundCheckPackages>>,
          TError,
          Awaited<ReturnType<typeof getBackgroundCheckPackages>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBackgroundCheckPackages<TData = Awaited<ReturnType<typeof getBackgroundCheckPackages>>, TError = AxiosError<unknown>>(
 providerId: 1,
    params?: GetBackgroundCheckPackagesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBackgroundCheckPackages>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetBackgroundCheckPackages<TData = Awaited<ReturnType<typeof getBackgroundCheckPackages>>, TError = AxiosError<unknown>>(
 providerId: 1,
    params?: GetBackgroundCheckPackagesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBackgroundCheckPackages>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBackgroundCheckPackagesQueryOptions(providerId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const refreshBackgroundCheckPackages = (
    providerId: 1, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<BackgroundCheckPackageDtoSchema[]>> => {
    
    
    return axios.default.post(
      `/api/Company/BackgroundCheck/${providerId}/packages/refresh`,undefined,options
    );
  }



export const getRefreshBackgroundCheckPackagesMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof refreshBackgroundCheckPackages>>, TError,{providerId: 1}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof refreshBackgroundCheckPackages>>, TError,{providerId: 1}, TContext> => {
    
const mutationKey = ['refreshBackgroundCheckPackages'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof refreshBackgroundCheckPackages>>, {providerId: 1}> = (props) => {
          const {providerId} = props ?? {};

          return  refreshBackgroundCheckPackages(providerId,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RefreshBackgroundCheckPackagesMutationResult = NonNullable<Awaited<ReturnType<typeof refreshBackgroundCheckPackages>>>
    
    export type RefreshBackgroundCheckPackagesMutationError = AxiosError<unknown>

    export const useRefreshBackgroundCheckPackages = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof refreshBackgroundCheckPackages>>, TError,{providerId: 1}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof refreshBackgroundCheckPackages>>,
        TError,
        {providerId: 1},
        TContext
      > => {

      const mutationOptions = getRefreshBackgroundCheckPackagesMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getBackgroundCheckSettings = (
    providerId: 1, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<BackgroundCheckProviderSettingsDtoSchema>> => {
    
    
    return axios.default.get(
      `/api/Company/BackgroundCheck/${providerId}/settings`,options
    );
  }


export const getGetBackgroundCheckSettingsQueryKey = (providerId: 1,) => {
    return [`/api/Company/BackgroundCheck/${providerId}/settings`] as const;
    }

    
export const getGetBackgroundCheckSettingsQueryOptions = <TData = Awaited<ReturnType<typeof getBackgroundCheckSettings>>, TError = AxiosError<unknown>>(providerId: 1, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBackgroundCheckSettings>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBackgroundCheckSettingsQueryKey(providerId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBackgroundCheckSettings>>> = ({ signal }) => getBackgroundCheckSettings(providerId, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(providerId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBackgroundCheckSettings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBackgroundCheckSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof getBackgroundCheckSettings>>>
export type GetBackgroundCheckSettingsQueryError = AxiosError<unknown>


export function useGetBackgroundCheckSettings<TData = Awaited<ReturnType<typeof getBackgroundCheckSettings>>, TError = AxiosError<unknown>>(
 providerId: 1, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBackgroundCheckSettings>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBackgroundCheckSettings>>,
          TError,
          Awaited<ReturnType<typeof getBackgroundCheckSettings>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBackgroundCheckSettings<TData = Awaited<ReturnType<typeof getBackgroundCheckSettings>>, TError = AxiosError<unknown>>(
 providerId: 1, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBackgroundCheckSettings>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBackgroundCheckSettings>>,
          TError,
          Awaited<ReturnType<typeof getBackgroundCheckSettings>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBackgroundCheckSettings<TData = Awaited<ReturnType<typeof getBackgroundCheckSettings>>, TError = AxiosError<unknown>>(
 providerId: 1, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBackgroundCheckSettings>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetBackgroundCheckSettings<TData = Awaited<ReturnType<typeof getBackgroundCheckSettings>>, TError = AxiosError<unknown>>(
 providerId: 1, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBackgroundCheckSettings>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBackgroundCheckSettingsQueryOptions(providerId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getCompanySecondCheckRuleOptions = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<SecondCheckRuleOptionsSchema>> => {
    
    
    return axios.default.get(
      `/api/Company/SecondCheckRules/Options`,options
    );
  }


export const getGetCompanySecondCheckRuleOptionsQueryKey = () => {
    return [`/api/Company/SecondCheckRules/Options`] as const;
    }

    
export const getGetCompanySecondCheckRuleOptionsQueryOptions = <TData = Awaited<ReturnType<typeof getCompanySecondCheckRuleOptions>>, TError = AxiosError<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanySecondCheckRuleOptions>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCompanySecondCheckRuleOptionsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCompanySecondCheckRuleOptions>>> = ({ signal }) => getCompanySecondCheckRuleOptions({ signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCompanySecondCheckRuleOptions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCompanySecondCheckRuleOptionsQueryResult = NonNullable<Awaited<ReturnType<typeof getCompanySecondCheckRuleOptions>>>
export type GetCompanySecondCheckRuleOptionsQueryError = AxiosError<unknown>


export function useGetCompanySecondCheckRuleOptions<TData = Awaited<ReturnType<typeof getCompanySecondCheckRuleOptions>>, TError = AxiosError<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanySecondCheckRuleOptions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCompanySecondCheckRuleOptions>>,
          TError,
          Awaited<ReturnType<typeof getCompanySecondCheckRuleOptions>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCompanySecondCheckRuleOptions<TData = Awaited<ReturnType<typeof getCompanySecondCheckRuleOptions>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanySecondCheckRuleOptions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCompanySecondCheckRuleOptions>>,
          TError,
          Awaited<ReturnType<typeof getCompanySecondCheckRuleOptions>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCompanySecondCheckRuleOptions<TData = Awaited<ReturnType<typeof getCompanySecondCheckRuleOptions>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanySecondCheckRuleOptions>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetCompanySecondCheckRuleOptions<TData = Awaited<ReturnType<typeof getCompanySecondCheckRuleOptions>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanySecondCheckRuleOptions>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCompanySecondCheckRuleOptionsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Gets report layouts
 */
export const getCustomReports = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<CustomReportsListItemSchema[]>> => {
    
    
    return axios.default.get(
      `/api/CustomReports`,options
    );
  }


export const getGetCustomReportsQueryKey = () => {
    return [`/api/CustomReports`] as const;
    }

    
export const getGetCustomReportsQueryOptions = <TData = Awaited<ReturnType<typeof getCustomReports>>, TError = AxiosError<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomReports>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCustomReportsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCustomReports>>> = ({ signal }) => getCustomReports({ signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCustomReports>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCustomReportsQueryResult = NonNullable<Awaited<ReturnType<typeof getCustomReports>>>
export type GetCustomReportsQueryError = AxiosError<unknown>


export function useGetCustomReports<TData = Awaited<ReturnType<typeof getCustomReports>>, TError = AxiosError<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomReports>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomReports>>,
          TError,
          Awaited<ReturnType<typeof getCustomReports>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomReports<TData = Awaited<ReturnType<typeof getCustomReports>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomReports>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomReports>>,
          TError,
          Awaited<ReturnType<typeof getCustomReports>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomReports<TData = Awaited<ReturnType<typeof getCustomReports>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomReports>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Gets report layouts
 */

export function useGetCustomReports<TData = Awaited<ReturnType<typeof getCustomReports>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomReports>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCustomReportsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Adds report layout
 */
export const addCustomReport = (
    addCustomReportSchema: AddCustomReportSchema, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.default.post(
      `/api/CustomReports`,
      addCustomReportSchema,options
    );
  }



export const getAddCustomReportMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addCustomReport>>, TError,{data: AddCustomReportSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof addCustomReport>>, TError,{data: AddCustomReportSchema}, TContext> => {
    
const mutationKey = ['addCustomReport'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addCustomReport>>, {data: AddCustomReportSchema}> = (props) => {
          const {data} = props ?? {};

          return  addCustomReport(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AddCustomReportMutationResult = NonNullable<Awaited<ReturnType<typeof addCustomReport>>>
    export type AddCustomReportMutationBody = AddCustomReportSchema
    export type AddCustomReportMutationError = AxiosError<unknown>

    /**
 * @summary Adds report layout
 */
export const useAddCustomReport = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addCustomReport>>, TError,{data: AddCustomReportSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof addCustomReport>>,
        TError,
        {data: AddCustomReportSchema},
        TContext
      > => {

      const mutationOptions = getAddCustomReportMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Gets report layout by id
 */
export const getCustomReport = (
    id: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<CustomReportDetailsSchema>> => {
    
    
    return axios.default.get(
      `/api/CustomReports/${id}`,options
    );
  }


export const getGetCustomReportQueryKey = (id: number,) => {
    return [`/api/CustomReports/${id}`] as const;
    }

    
export const getGetCustomReportQueryOptions = <TData = Awaited<ReturnType<typeof getCustomReport>>, TError = AxiosError<unknown>>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomReport>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCustomReportQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCustomReport>>> = ({ signal }) => getCustomReport(id, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCustomReport>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCustomReportQueryResult = NonNullable<Awaited<ReturnType<typeof getCustomReport>>>
export type GetCustomReportQueryError = AxiosError<unknown>


export function useGetCustomReport<TData = Awaited<ReturnType<typeof getCustomReport>>, TError = AxiosError<unknown>>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomReport>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomReport>>,
          TError,
          Awaited<ReturnType<typeof getCustomReport>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomReport<TData = Awaited<ReturnType<typeof getCustomReport>>, TError = AxiosError<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomReport>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomReport>>,
          TError,
          Awaited<ReturnType<typeof getCustomReport>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomReport<TData = Awaited<ReturnType<typeof getCustomReport>>, TError = AxiosError<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomReport>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Gets report layout by id
 */

export function useGetCustomReport<TData = Awaited<ReturnType<typeof getCustomReport>>, TError = AxiosError<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomReport>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCustomReportQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Runs report layout by id
 */
export const runCustomReport = (
    id: number,
    runCustomReportSchema: RunCustomReportSchema, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<unknown[]>> => {
    
    
    return axios.default.post(
      `/api/CustomReports/${id}`,
      runCustomReportSchema,options
    );
  }



export const getRunCustomReportMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof runCustomReport>>, TError,{id: number;data: RunCustomReportSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof runCustomReport>>, TError,{id: number;data: RunCustomReportSchema}, TContext> => {
    
const mutationKey = ['runCustomReport'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof runCustomReport>>, {id: number;data: RunCustomReportSchema}> = (props) => {
          const {id,data} = props ?? {};

          return  runCustomReport(id,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RunCustomReportMutationResult = NonNullable<Awaited<ReturnType<typeof runCustomReport>>>
    export type RunCustomReportMutationBody = RunCustomReportSchema
    export type RunCustomReportMutationError = AxiosError<unknown>

    /**
 * @summary Runs report layout by id
 */
export const useRunCustomReport = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof runCustomReport>>, TError,{id: number;data: RunCustomReportSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof runCustomReport>>,
        TError,
        {id: number;data: RunCustomReportSchema},
        TContext
      > => {

      const mutationOptions = getRunCustomReportMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Updates report layout by id
 */
export const updateCustomReport = (
    id: number,
    updateCustomReportSchema: UpdateCustomReportSchema, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.default.put(
      `/api/CustomReports/${id}`,
      updateCustomReportSchema,options
    );
  }



export const getUpdateCustomReportMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCustomReport>>, TError,{id: number;data: UpdateCustomReportSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof updateCustomReport>>, TError,{id: number;data: UpdateCustomReportSchema}, TContext> => {
    
const mutationKey = ['updateCustomReport'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateCustomReport>>, {id: number;data: UpdateCustomReportSchema}> = (props) => {
          const {id,data} = props ?? {};

          return  updateCustomReport(id,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateCustomReportMutationResult = NonNullable<Awaited<ReturnType<typeof updateCustomReport>>>
    export type UpdateCustomReportMutationBody = UpdateCustomReportSchema
    export type UpdateCustomReportMutationError = AxiosError<unknown>

    /**
 * @summary Updates report layout by id
 */
export const useUpdateCustomReport = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCustomReport>>, TError,{id: number;data: UpdateCustomReportSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof updateCustomReport>>,
        TError,
        {id: number;data: UpdateCustomReportSchema},
        TContext
      > => {

      const mutationOptions = getUpdateCustomReportMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Deletes report layout by id
 */
export const deleteCustomReport = (
    id: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.default.delete(
      `/api/CustomReports/${id}`,options
    );
  }



export const getDeleteCustomReportMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCustomReport>>, TError,{id: number}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof deleteCustomReport>>, TError,{id: number}, TContext> => {
    
const mutationKey = ['deleteCustomReport'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteCustomReport>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteCustomReport(id,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteCustomReportMutationResult = NonNullable<Awaited<ReturnType<typeof deleteCustomReport>>>
    
    export type DeleteCustomReportMutationError = AxiosError<unknown>

    /**
 * @summary Deletes report layout by id
 */
export const useDeleteCustomReport = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCustomReport>>, TError,{id: number}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof deleteCustomReport>>,
        TError,
        {id: number},
        TContext
      > => {

      const mutationOptions = getDeleteCustomReportMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Gets pay codes
 */
export const getPayCodes = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PayCodeSchema[]>> => {
    
    
    return axios.default.get(
      `/api/CustomReports/PayCodes`,options
    );
  }


export const getGetPayCodesQueryKey = () => {
    return [`/api/CustomReports/PayCodes`] as const;
    }

    
export const getGetPayCodesQueryOptions = <TData = Awaited<ReturnType<typeof getPayCodes>>, TError = AxiosError<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayCodes>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPayCodesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPayCodes>>> = ({ signal }) => getPayCodes({ signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPayCodes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPayCodesQueryResult = NonNullable<Awaited<ReturnType<typeof getPayCodes>>>
export type GetPayCodesQueryError = AxiosError<unknown>


export function useGetPayCodes<TData = Awaited<ReturnType<typeof getPayCodes>>, TError = AxiosError<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayCodes>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPayCodes>>,
          TError,
          Awaited<ReturnType<typeof getPayCodes>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPayCodes<TData = Awaited<ReturnType<typeof getPayCodes>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayCodes>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPayCodes>>,
          TError,
          Awaited<ReturnType<typeof getPayCodes>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPayCodes<TData = Awaited<ReturnType<typeof getPayCodes>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayCodes>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Gets pay codes
 */

export function useGetPayCodes<TData = Awaited<ReturnType<typeof getPayCodes>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayCodes>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPayCodesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Share report layout
 */
export const shareCustomReport = (
    id: number,
    shareCustomReportSchema: ShareCustomReportSchema, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.default.post(
      `/api/CustomReports/Shared/${id}`,
      shareCustomReportSchema,options
    );
  }



export const getShareCustomReportMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof shareCustomReport>>, TError,{id: number;data: ShareCustomReportSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof shareCustomReport>>, TError,{id: number;data: ShareCustomReportSchema}, TContext> => {
    
const mutationKey = ['shareCustomReport'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof shareCustomReport>>, {id: number;data: ShareCustomReportSchema}> = (props) => {
          const {id,data} = props ?? {};

          return  shareCustomReport(id,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ShareCustomReportMutationResult = NonNullable<Awaited<ReturnType<typeof shareCustomReport>>>
    export type ShareCustomReportMutationBody = ShareCustomReportSchema
    export type ShareCustomReportMutationError = AxiosError<unknown>

    /**
 * @summary Share report layout
 */
export const useShareCustomReport = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof shareCustomReport>>, TError,{id: number;data: ShareCustomReportSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof shareCustomReport>>,
        TError,
        {id: number;data: ShareCustomReportSchema},
        TContext
      > => {

      const mutationOptions = getShareCustomReportMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Gets the authenticated employee's document list, one row per template group
 */
export const getEssHrDocuments = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<EssHrDocumentListItemSchema[]>> => {
    
    
    return axios.default.get(
      `/api/employee-deck/my/hr-documents`,options
    );
  }


export const getGetEssHrDocumentsQueryKey = () => {
    return [`/api/employee-deck/my/hr-documents`] as const;
    }

    
export const getGetEssHrDocumentsQueryOptions = <TData = Awaited<ReturnType<typeof getEssHrDocuments>>, TError = AxiosError<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEssHrDocuments>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEssHrDocumentsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEssHrDocuments>>> = ({ signal }) => getEssHrDocuments({ signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEssHrDocuments>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEssHrDocumentsQueryResult = NonNullable<Awaited<ReturnType<typeof getEssHrDocuments>>>
export type GetEssHrDocumentsQueryError = AxiosError<unknown>


export function useGetEssHrDocuments<TData = Awaited<ReturnType<typeof getEssHrDocuments>>, TError = AxiosError<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEssHrDocuments>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEssHrDocuments>>,
          TError,
          Awaited<ReturnType<typeof getEssHrDocuments>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEssHrDocuments<TData = Awaited<ReturnType<typeof getEssHrDocuments>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEssHrDocuments>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEssHrDocuments>>,
          TError,
          Awaited<ReturnType<typeof getEssHrDocuments>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEssHrDocuments<TData = Awaited<ReturnType<typeof getEssHrDocuments>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEssHrDocuments>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Gets the authenticated employee's document list, one row per template group
 */

export function useGetEssHrDocuments<TData = Awaited<ReturnType<typeof getEssHrDocuments>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEssHrDocuments>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEssHrDocumentsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Gets the employee-safe detail for one of the employee's own documents
 */
export const getEssHrDocumentDetail = (
    documentId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<EssHrDocumentDetailSchema>> => {
    
    
    return axios.default.get(
      `/api/employee-deck/my/hr-documents/${documentId}`,options
    );
  }


export const getGetEssHrDocumentDetailQueryKey = (documentId: number,) => {
    return [`/api/employee-deck/my/hr-documents/${documentId}`] as const;
    }

    
export const getGetEssHrDocumentDetailQueryOptions = <TData = Awaited<ReturnType<typeof getEssHrDocumentDetail>>, TError = AxiosError<unknown>>(documentId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEssHrDocumentDetail>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEssHrDocumentDetailQueryKey(documentId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEssHrDocumentDetail>>> = ({ signal }) => getEssHrDocumentDetail(documentId, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(documentId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEssHrDocumentDetail>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEssHrDocumentDetailQueryResult = NonNullable<Awaited<ReturnType<typeof getEssHrDocumentDetail>>>
export type GetEssHrDocumentDetailQueryError = AxiosError<unknown>


export function useGetEssHrDocumentDetail<TData = Awaited<ReturnType<typeof getEssHrDocumentDetail>>, TError = AxiosError<unknown>>(
 documentId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEssHrDocumentDetail>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEssHrDocumentDetail>>,
          TError,
          Awaited<ReturnType<typeof getEssHrDocumentDetail>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEssHrDocumentDetail<TData = Awaited<ReturnType<typeof getEssHrDocumentDetail>>, TError = AxiosError<unknown>>(
 documentId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEssHrDocumentDetail>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEssHrDocumentDetail>>,
          TError,
          Awaited<ReturnType<typeof getEssHrDocumentDetail>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEssHrDocumentDetail<TData = Awaited<ReturnType<typeof getEssHrDocumentDetail>>, TError = AxiosError<unknown>>(
 documentId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEssHrDocumentDetail>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Gets the employee-safe detail for one of the employee's own documents
 */

export function useGetEssHrDocumentDetail<TData = Awaited<ReturnType<typeof getEssHrDocumentDetail>>, TError = AxiosError<unknown>>(
 documentId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEssHrDocumentDetail>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEssHrDocumentDetailQueryOptions(documentId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Downloads the primary file of one of the employee's own documents
 */
export const downloadEssHrDocument = (
    documentId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Blob>> => {
    
    
    return axios.default.get(
      `/api/employee-deck/my/hr-documents/${documentId}/download`,{
        responseType: 'blob',
    ...options,}
    );
  }


export const getDownloadEssHrDocumentQueryKey = (documentId: number,) => {
    return [`/api/employee-deck/my/hr-documents/${documentId}/download`] as const;
    }

    
export const getDownloadEssHrDocumentQueryOptions = <TData = Awaited<ReturnType<typeof downloadEssHrDocument>>, TError = AxiosError<unknown>>(documentId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadEssHrDocument>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDownloadEssHrDocumentQueryKey(documentId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadEssHrDocument>>> = ({ signal }) => downloadEssHrDocument(documentId, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(documentId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof downloadEssHrDocument>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DownloadEssHrDocumentQueryResult = NonNullable<Awaited<ReturnType<typeof downloadEssHrDocument>>>
export type DownloadEssHrDocumentQueryError = AxiosError<unknown>


export function useDownloadEssHrDocument<TData = Awaited<ReturnType<typeof downloadEssHrDocument>>, TError = AxiosError<unknown>>(
 documentId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadEssHrDocument>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadEssHrDocument>>,
          TError,
          Awaited<ReturnType<typeof downloadEssHrDocument>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadEssHrDocument<TData = Awaited<ReturnType<typeof downloadEssHrDocument>>, TError = AxiosError<unknown>>(
 documentId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadEssHrDocument>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadEssHrDocument>>,
          TError,
          Awaited<ReturnType<typeof downloadEssHrDocument>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadEssHrDocument<TData = Awaited<ReturnType<typeof downloadEssHrDocument>>, TError = AxiosError<unknown>>(
 documentId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadEssHrDocument>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Downloads the primary file of one of the employee's own documents
 */

export function useDownloadEssHrDocument<TData = Awaited<ReturnType<typeof downloadEssHrDocument>>, TError = AxiosError<unknown>>(
 documentId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadEssHrDocument>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDownloadEssHrDocumentQueryOptions(documentId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Gets the field definitions the employee needs to complete an assigned document
 */
export const getEssHrDocumentTemplateInfo = (
    templateId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<EssHrDocumentTemplateInfoSchema>> => {
    
    
    return axios.default.get(
      `/api/employee-deck/my/hr-documents/templates/${templateId}`,options
    );
  }


export const getGetEssHrDocumentTemplateInfoQueryKey = (templateId: number,) => {
    return [`/api/employee-deck/my/hr-documents/templates/${templateId}`] as const;
    }

    
export const getGetEssHrDocumentTemplateInfoQueryOptions = <TData = Awaited<ReturnType<typeof getEssHrDocumentTemplateInfo>>, TError = AxiosError<unknown>>(templateId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEssHrDocumentTemplateInfo>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEssHrDocumentTemplateInfoQueryKey(templateId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEssHrDocumentTemplateInfo>>> = ({ signal }) => getEssHrDocumentTemplateInfo(templateId, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(templateId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEssHrDocumentTemplateInfo>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEssHrDocumentTemplateInfoQueryResult = NonNullable<Awaited<ReturnType<typeof getEssHrDocumentTemplateInfo>>>
export type GetEssHrDocumentTemplateInfoQueryError = AxiosError<unknown>


export function useGetEssHrDocumentTemplateInfo<TData = Awaited<ReturnType<typeof getEssHrDocumentTemplateInfo>>, TError = AxiosError<unknown>>(
 templateId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEssHrDocumentTemplateInfo>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEssHrDocumentTemplateInfo>>,
          TError,
          Awaited<ReturnType<typeof getEssHrDocumentTemplateInfo>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEssHrDocumentTemplateInfo<TData = Awaited<ReturnType<typeof getEssHrDocumentTemplateInfo>>, TError = AxiosError<unknown>>(
 templateId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEssHrDocumentTemplateInfo>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEssHrDocumentTemplateInfo>>,
          TError,
          Awaited<ReturnType<typeof getEssHrDocumentTemplateInfo>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEssHrDocumentTemplateInfo<TData = Awaited<ReturnType<typeof getEssHrDocumentTemplateInfo>>, TError = AxiosError<unknown>>(
 templateId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEssHrDocumentTemplateInfo>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Gets the field definitions the employee needs to complete an assigned document
 */

export function useGetEssHrDocumentTemplateInfo<TData = Awaited<ReturnType<typeof getEssHrDocumentTemplateInfo>>, TError = AxiosError<unknown>>(
 templateId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEssHrDocumentTemplateInfo>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEssHrDocumentTemplateInfoQueryOptions(templateId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Acknowledges a readonly (field-less) document the employee has reviewed, completing the assignment
 */
export const acknowledgeEssHrDocument = (
    templateId: number,
    acknowledgeEssHrDocumentRequestSchema: AcknowledgeEssHrDocumentRequestSchema, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.default.post(
      `/api/employee-deck/my/hr-documents/templates/${templateId}/acknowledge`,
      acknowledgeEssHrDocumentRequestSchema,options
    );
  }



export const getAcknowledgeEssHrDocumentMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof acknowledgeEssHrDocument>>, TError,{templateId: number;data: AcknowledgeEssHrDocumentRequestSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof acknowledgeEssHrDocument>>, TError,{templateId: number;data: AcknowledgeEssHrDocumentRequestSchema}, TContext> => {
    
const mutationKey = ['acknowledgeEssHrDocument'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof acknowledgeEssHrDocument>>, {templateId: number;data: AcknowledgeEssHrDocumentRequestSchema}> = (props) => {
          const {templateId,data} = props ?? {};

          return  acknowledgeEssHrDocument(templateId,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AcknowledgeEssHrDocumentMutationResult = NonNullable<Awaited<ReturnType<typeof acknowledgeEssHrDocument>>>
    export type AcknowledgeEssHrDocumentMutationBody = AcknowledgeEssHrDocumentRequestSchema
    export type AcknowledgeEssHrDocumentMutationError = AxiosError<unknown>

    /**
 * @summary Acknowledges a readonly (field-less) document the employee has reviewed, completing the assignment
 */
export const useAcknowledgeEssHrDocument = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof acknowledgeEssHrDocument>>, TError,{templateId: number;data: AcknowledgeEssHrDocumentRequestSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof acknowledgeEssHrDocument>>,
        TError,
        {templateId: number;data: AcknowledgeEssHrDocumentRequestSchema},
        TContext
      > => {

      const mutationOptions = getAcknowledgeEssHrDocumentMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Gets the DocuSeal submission slug for the employee to sign an assigned form document
 */
export const getEssHrDocumentSignSlug = (
    templateId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<EssHrDocumentSignSlugSchema>> => {
    
    
    return axios.default.get(
      `/api/employee-deck/my/hr-documents/templates/${templateId}/sign-slug`,options
    );
  }


export const getGetEssHrDocumentSignSlugQueryKey = (templateId: number,) => {
    return [`/api/employee-deck/my/hr-documents/templates/${templateId}/sign-slug`] as const;
    }

    
export const getGetEssHrDocumentSignSlugQueryOptions = <TData = Awaited<ReturnType<typeof getEssHrDocumentSignSlug>>, TError = AxiosError<unknown>>(templateId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEssHrDocumentSignSlug>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEssHrDocumentSignSlugQueryKey(templateId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEssHrDocumentSignSlug>>> = ({ signal }) => getEssHrDocumentSignSlug(templateId, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(templateId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEssHrDocumentSignSlug>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEssHrDocumentSignSlugQueryResult = NonNullable<Awaited<ReturnType<typeof getEssHrDocumentSignSlug>>>
export type GetEssHrDocumentSignSlugQueryError = AxiosError<unknown>


export function useGetEssHrDocumentSignSlug<TData = Awaited<ReturnType<typeof getEssHrDocumentSignSlug>>, TError = AxiosError<unknown>>(
 templateId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEssHrDocumentSignSlug>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEssHrDocumentSignSlug>>,
          TError,
          Awaited<ReturnType<typeof getEssHrDocumentSignSlug>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEssHrDocumentSignSlug<TData = Awaited<ReturnType<typeof getEssHrDocumentSignSlug>>, TError = AxiosError<unknown>>(
 templateId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEssHrDocumentSignSlug>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEssHrDocumentSignSlug>>,
          TError,
          Awaited<ReturnType<typeof getEssHrDocumentSignSlug>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEssHrDocumentSignSlug<TData = Awaited<ReturnType<typeof getEssHrDocumentSignSlug>>, TError = AxiosError<unknown>>(
 templateId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEssHrDocumentSignSlug>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Gets the DocuSeal submission slug for the employee to sign an assigned form document
 */

export function useGetEssHrDocumentSignSlug<TData = Awaited<ReturnType<typeof getEssHrDocumentSignSlug>>, TError = AxiosError<unknown>>(
 templateId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEssHrDocumentSignSlug>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEssHrDocumentSignSlugQueryOptions(templateId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Submits the employee's completed DocuSeal form for an assigned document
 */
export const submitEssHrDocumentForm = (
    templateId: number,
    submitEssHrDocumentFormRequestSchema: SubmitEssHrDocumentFormRequestSchema, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.default.post(
      `/api/employee-deck/my/hr-documents/templates/${templateId}/submit`,
      submitEssHrDocumentFormRequestSchema,options
    );
  }



export const getSubmitEssHrDocumentFormMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitEssHrDocumentForm>>, TError,{templateId: number;data: SubmitEssHrDocumentFormRequestSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof submitEssHrDocumentForm>>, TError,{templateId: number;data: SubmitEssHrDocumentFormRequestSchema}, TContext> => {
    
const mutationKey = ['submitEssHrDocumentForm'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof submitEssHrDocumentForm>>, {templateId: number;data: SubmitEssHrDocumentFormRequestSchema}> = (props) => {
          const {templateId,data} = props ?? {};

          return  submitEssHrDocumentForm(templateId,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SubmitEssHrDocumentFormMutationResult = NonNullable<Awaited<ReturnType<typeof submitEssHrDocumentForm>>>
    export type SubmitEssHrDocumentFormMutationBody = SubmitEssHrDocumentFormRequestSchema
    export type SubmitEssHrDocumentFormMutationError = AxiosError<unknown>

    /**
 * @summary Submits the employee's completed DocuSeal form for an assigned document
 */
export const useSubmitEssHrDocumentForm = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitEssHrDocumentForm>>, TError,{templateId: number;data: SubmitEssHrDocumentFormRequestSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof submitEssHrDocumentForm>>,
        TError,
        {templateId: number;data: SubmitEssHrDocumentFormRequestSchema},
        TContext
      > => {

      const mutationOptions = getSubmitEssHrDocumentFormMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Uploads the employee's file(s) for an assigned upload-type document
 */
export const uploadEssHrDocumentFiles = (
    templateId: number,
    uploadEssHrDocumentFilesBody: UploadEssHrDocumentFilesBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    const formData = createFormData(uploadEssHrDocumentFilesBody)
    return axios.default.post(
      `/api/employee-deck/my/hr-documents/templates/${templateId}/upload`,
      formData,options
    );
  }



export const getUploadEssHrDocumentFilesMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadEssHrDocumentFiles>>, TError,{templateId: number;data: UploadEssHrDocumentFilesBody}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof uploadEssHrDocumentFiles>>, TError,{templateId: number;data: UploadEssHrDocumentFilesBody}, TContext> => {
    
const mutationKey = ['uploadEssHrDocumentFiles'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof uploadEssHrDocumentFiles>>, {templateId: number;data: UploadEssHrDocumentFilesBody}> = (props) => {
          const {templateId,data} = props ?? {};

          return  uploadEssHrDocumentFiles(templateId,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UploadEssHrDocumentFilesMutationResult = NonNullable<Awaited<ReturnType<typeof uploadEssHrDocumentFiles>>>
    export type UploadEssHrDocumentFilesMutationBody = UploadEssHrDocumentFilesBody
    export type UploadEssHrDocumentFilesMutationError = AxiosError<unknown>

    /**
 * @summary Uploads the employee's file(s) for an assigned upload-type document
 */
export const useUploadEssHrDocumentFiles = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadEssHrDocumentFiles>>, TError,{templateId: number;data: UploadEssHrDocumentFilesBody}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof uploadEssHrDocumentFiles>>,
        TError,
        {templateId: number;data: UploadEssHrDocumentFilesBody},
        TContext
      > => {

      const mutationOptions = getUploadEssHrDocumentFilesMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Gets employee document types
 */
export const getEmployeeDocumentTypes = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<DocumentsEmployeeDocumentTypeSchema[]>> => {
    
    
    return axios.default.get(
      `/api/EmployeeDocumentTypes`,options
    );
  }


export const getGetEmployeeDocumentTypesQueryKey = () => {
    return [`/api/EmployeeDocumentTypes`] as const;
    }

    
export const getGetEmployeeDocumentTypesQueryOptions = <TData = Awaited<ReturnType<typeof getEmployeeDocumentTypes>>, TError = AxiosError<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeeDocumentTypes>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEmployeeDocumentTypesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEmployeeDocumentTypes>>> = ({ signal }) => getEmployeeDocumentTypes({ signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEmployeeDocumentTypes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEmployeeDocumentTypesQueryResult = NonNullable<Awaited<ReturnType<typeof getEmployeeDocumentTypes>>>
export type GetEmployeeDocumentTypesQueryError = AxiosError<unknown>


export function useGetEmployeeDocumentTypes<TData = Awaited<ReturnType<typeof getEmployeeDocumentTypes>>, TError = AxiosError<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeeDocumentTypes>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmployeeDocumentTypes>>,
          TError,
          Awaited<ReturnType<typeof getEmployeeDocumentTypes>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmployeeDocumentTypes<TData = Awaited<ReturnType<typeof getEmployeeDocumentTypes>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeeDocumentTypes>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmployeeDocumentTypes>>,
          TError,
          Awaited<ReturnType<typeof getEmployeeDocumentTypes>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmployeeDocumentTypes<TData = Awaited<ReturnType<typeof getEmployeeDocumentTypes>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeeDocumentTypes>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Gets employee document types
 */

export function useGetEmployeeDocumentTypes<TData = Awaited<ReturnType<typeof getEmployeeDocumentTypes>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeeDocumentTypes>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEmployeeDocumentTypesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Adds employee document type
 */
export const addEmployeeDocumentType = (
    addEmployeeDocumentTypeSchema: AddEmployeeDocumentTypeSchema, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<DocumentTypeCreatedResultSchema>> => {
    
    
    return axios.default.post(
      `/api/EmployeeDocumentTypes`,
      addEmployeeDocumentTypeSchema,options
    );
  }



export const getAddEmployeeDocumentTypeMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addEmployeeDocumentType>>, TError,{data: AddEmployeeDocumentTypeSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof addEmployeeDocumentType>>, TError,{data: AddEmployeeDocumentTypeSchema}, TContext> => {
    
const mutationKey = ['addEmployeeDocumentType'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addEmployeeDocumentType>>, {data: AddEmployeeDocumentTypeSchema}> = (props) => {
          const {data} = props ?? {};

          return  addEmployeeDocumentType(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AddEmployeeDocumentTypeMutationResult = NonNullable<Awaited<ReturnType<typeof addEmployeeDocumentType>>>
    export type AddEmployeeDocumentTypeMutationBody = AddEmployeeDocumentTypeSchema
    export type AddEmployeeDocumentTypeMutationError = AxiosError<unknown>

    /**
 * @summary Adds employee document type
 */
export const useAddEmployeeDocumentType = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addEmployeeDocumentType>>, TError,{data: AddEmployeeDocumentTypeSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof addEmployeeDocumentType>>,
        TError,
        {data: AddEmployeeDocumentTypeSchema},
        TContext
      > => {

      const mutationOptions = getAddEmployeeDocumentTypeMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Gets all versions for an employee document type
 */
export const getEmployeeDocumentTypeVersions = (
    documentTypeId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<EmployeeDocumentTypeVersionSchema[]>> => {
    
    
    return axios.default.get(
      `/api/EmployeeDocumentTypes/${documentTypeId}/Versions`,options
    );
  }


export const getGetEmployeeDocumentTypeVersionsQueryKey = (documentTypeId: number,) => {
    return [`/api/EmployeeDocumentTypes/${documentTypeId}/Versions`] as const;
    }

    
export const getGetEmployeeDocumentTypeVersionsQueryOptions = <TData = Awaited<ReturnType<typeof getEmployeeDocumentTypeVersions>>, TError = AxiosError<unknown>>(documentTypeId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeeDocumentTypeVersions>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEmployeeDocumentTypeVersionsQueryKey(documentTypeId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEmployeeDocumentTypeVersions>>> = ({ signal }) => getEmployeeDocumentTypeVersions(documentTypeId, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(documentTypeId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEmployeeDocumentTypeVersions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEmployeeDocumentTypeVersionsQueryResult = NonNullable<Awaited<ReturnType<typeof getEmployeeDocumentTypeVersions>>>
export type GetEmployeeDocumentTypeVersionsQueryError = AxiosError<unknown>


export function useGetEmployeeDocumentTypeVersions<TData = Awaited<ReturnType<typeof getEmployeeDocumentTypeVersions>>, TError = AxiosError<unknown>>(
 documentTypeId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeeDocumentTypeVersions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmployeeDocumentTypeVersions>>,
          TError,
          Awaited<ReturnType<typeof getEmployeeDocumentTypeVersions>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmployeeDocumentTypeVersions<TData = Awaited<ReturnType<typeof getEmployeeDocumentTypeVersions>>, TError = AxiosError<unknown>>(
 documentTypeId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeeDocumentTypeVersions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmployeeDocumentTypeVersions>>,
          TError,
          Awaited<ReturnType<typeof getEmployeeDocumentTypeVersions>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmployeeDocumentTypeVersions<TData = Awaited<ReturnType<typeof getEmployeeDocumentTypeVersions>>, TError = AxiosError<unknown>>(
 documentTypeId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeeDocumentTypeVersions>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Gets all versions for an employee document type
 */

export function useGetEmployeeDocumentTypeVersions<TData = Awaited<ReturnType<typeof getEmployeeDocumentTypeVersions>>, TError = AxiosError<unknown>>(
 documentTypeId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeeDocumentTypeVersions>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEmployeeDocumentTypeVersionsQueryOptions(documentTypeId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Creates a new draft version for an employee document type based on the current active version
 */
export const addEmployeeDocumentTypeVersion = (
    documentTypeId: number,
    upsertEmployeeDocumentTypeVersionSchema: UpsertEmployeeDocumentTypeVersionSchema, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<RecordCreatedResultSchema>> => {
    
    
    return axios.default.post(
      `/api/EmployeeDocumentTypes/${documentTypeId}/Versions`,
      upsertEmployeeDocumentTypeVersionSchema,options
    );
  }



export const getAddEmployeeDocumentTypeVersionMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addEmployeeDocumentTypeVersion>>, TError,{documentTypeId: number;data: UpsertEmployeeDocumentTypeVersionSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof addEmployeeDocumentTypeVersion>>, TError,{documentTypeId: number;data: UpsertEmployeeDocumentTypeVersionSchema}, TContext> => {
    
const mutationKey = ['addEmployeeDocumentTypeVersion'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addEmployeeDocumentTypeVersion>>, {documentTypeId: number;data: UpsertEmployeeDocumentTypeVersionSchema}> = (props) => {
          const {documentTypeId,data} = props ?? {};

          return  addEmployeeDocumentTypeVersion(documentTypeId,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AddEmployeeDocumentTypeVersionMutationResult = NonNullable<Awaited<ReturnType<typeof addEmployeeDocumentTypeVersion>>>
    export type AddEmployeeDocumentTypeVersionMutationBody = UpsertEmployeeDocumentTypeVersionSchema
    export type AddEmployeeDocumentTypeVersionMutationError = AxiosError<unknown>

    /**
 * @summary Creates a new draft version for an employee document type based on the current active version
 */
export const useAddEmployeeDocumentTypeVersion = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addEmployeeDocumentTypeVersion>>, TError,{documentTypeId: number;data: UpsertEmployeeDocumentTypeVersionSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof addEmployeeDocumentTypeVersion>>,
        TError,
        {documentTypeId: number;data: UpsertEmployeeDocumentTypeVersionSchema},
        TContext
      > => {

      const mutationOptions = getAddEmployeeDocumentTypeVersionMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Gets employee document type version details
 */
export const getEmployeeDocumentTypeVersionDetails = (
    documentTypeId: number,
    versionId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<EmployeeDocumentTypeVersionDetailsSchema>> => {
    
    
    return axios.default.get(
      `/api/EmployeeDocumentTypes/${documentTypeId}/Versions/${versionId}`,options
    );
  }


export const getGetEmployeeDocumentTypeVersionDetailsQueryKey = (documentTypeId: number,
    versionId: number,) => {
    return [`/api/EmployeeDocumentTypes/${documentTypeId}/Versions/${versionId}`] as const;
    }

    
export const getGetEmployeeDocumentTypeVersionDetailsQueryOptions = <TData = Awaited<ReturnType<typeof getEmployeeDocumentTypeVersionDetails>>, TError = AxiosError<unknown>>(documentTypeId: number,
    versionId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeeDocumentTypeVersionDetails>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEmployeeDocumentTypeVersionDetailsQueryKey(documentTypeId,versionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEmployeeDocumentTypeVersionDetails>>> = ({ signal }) => getEmployeeDocumentTypeVersionDetails(documentTypeId,versionId, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(documentTypeId && versionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEmployeeDocumentTypeVersionDetails>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEmployeeDocumentTypeVersionDetailsQueryResult = NonNullable<Awaited<ReturnType<typeof getEmployeeDocumentTypeVersionDetails>>>
export type GetEmployeeDocumentTypeVersionDetailsQueryError = AxiosError<unknown>


export function useGetEmployeeDocumentTypeVersionDetails<TData = Awaited<ReturnType<typeof getEmployeeDocumentTypeVersionDetails>>, TError = AxiosError<unknown>>(
 documentTypeId: number,
    versionId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeeDocumentTypeVersionDetails>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmployeeDocumentTypeVersionDetails>>,
          TError,
          Awaited<ReturnType<typeof getEmployeeDocumentTypeVersionDetails>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmployeeDocumentTypeVersionDetails<TData = Awaited<ReturnType<typeof getEmployeeDocumentTypeVersionDetails>>, TError = AxiosError<unknown>>(
 documentTypeId: number,
    versionId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeeDocumentTypeVersionDetails>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmployeeDocumentTypeVersionDetails>>,
          TError,
          Awaited<ReturnType<typeof getEmployeeDocumentTypeVersionDetails>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmployeeDocumentTypeVersionDetails<TData = Awaited<ReturnType<typeof getEmployeeDocumentTypeVersionDetails>>, TError = AxiosError<unknown>>(
 documentTypeId: number,
    versionId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeeDocumentTypeVersionDetails>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Gets employee document type version details
 */

export function useGetEmployeeDocumentTypeVersionDetails<TData = Awaited<ReturnType<typeof getEmployeeDocumentTypeVersionDetails>>, TError = AxiosError<unknown>>(
 documentTypeId: number,
    versionId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeeDocumentTypeVersionDetails>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEmployeeDocumentTypeVersionDetailsQueryOptions(documentTypeId,versionId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Updates an employee document type version
 */
export const updateEmployeeDocumentTypeVersion = (
    documentTypeId: number,
    versionId: number,
    updateEmployeeDocumentTypeVersionSchema: UpdateEmployeeDocumentTypeVersionSchema, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.default.put(
      `/api/EmployeeDocumentTypes/${documentTypeId}/Versions/${versionId}`,
      updateEmployeeDocumentTypeVersionSchema,options
    );
  }



export const getUpdateEmployeeDocumentTypeVersionMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateEmployeeDocumentTypeVersion>>, TError,{documentTypeId: number;versionId: number;data: UpdateEmployeeDocumentTypeVersionSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof updateEmployeeDocumentTypeVersion>>, TError,{documentTypeId: number;versionId: number;data: UpdateEmployeeDocumentTypeVersionSchema}, TContext> => {
    
const mutationKey = ['updateEmployeeDocumentTypeVersion'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateEmployeeDocumentTypeVersion>>, {documentTypeId: number;versionId: number;data: UpdateEmployeeDocumentTypeVersionSchema}> = (props) => {
          const {documentTypeId,versionId,data} = props ?? {};

          return  updateEmployeeDocumentTypeVersion(documentTypeId,versionId,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateEmployeeDocumentTypeVersionMutationResult = NonNullable<Awaited<ReturnType<typeof updateEmployeeDocumentTypeVersion>>>
    export type UpdateEmployeeDocumentTypeVersionMutationBody = UpdateEmployeeDocumentTypeVersionSchema
    export type UpdateEmployeeDocumentTypeVersionMutationError = AxiosError<unknown>

    /**
 * @summary Updates an employee document type version
 */
export const useUpdateEmployeeDocumentTypeVersion = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateEmployeeDocumentTypeVersion>>, TError,{documentTypeId: number;versionId: number;data: UpdateEmployeeDocumentTypeVersionSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof updateEmployeeDocumentTypeVersion>>,
        TError,
        {documentTypeId: number;versionId: number;data: UpdateEmployeeDocumentTypeVersionSchema},
        TContext
      > => {

      const mutationOptions = getUpdateEmployeeDocumentTypeVersionMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Duplicates an employee document type version
 */
export const duplicateEmployeeDocumentTypeVersion = (
    documentTypeId: number,
    versionId: number,
    upsertEmployeeDocumentTypeVersionSchema: UpsertEmployeeDocumentTypeVersionSchema, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<RecordCreatedResultSchema>> => {
    
    
    return axios.default.post(
      `/api/EmployeeDocumentTypes/${documentTypeId}/Versions/${versionId}`,
      upsertEmployeeDocumentTypeVersionSchema,options
    );
  }



export const getDuplicateEmployeeDocumentTypeVersionMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof duplicateEmployeeDocumentTypeVersion>>, TError,{documentTypeId: number;versionId: number;data: UpsertEmployeeDocumentTypeVersionSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof duplicateEmployeeDocumentTypeVersion>>, TError,{documentTypeId: number;versionId: number;data: UpsertEmployeeDocumentTypeVersionSchema}, TContext> => {
    
const mutationKey = ['duplicateEmployeeDocumentTypeVersion'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof duplicateEmployeeDocumentTypeVersion>>, {documentTypeId: number;versionId: number;data: UpsertEmployeeDocumentTypeVersionSchema}> = (props) => {
          const {documentTypeId,versionId,data} = props ?? {};

          return  duplicateEmployeeDocumentTypeVersion(documentTypeId,versionId,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DuplicateEmployeeDocumentTypeVersionMutationResult = NonNullable<Awaited<ReturnType<typeof duplicateEmployeeDocumentTypeVersion>>>
    export type DuplicateEmployeeDocumentTypeVersionMutationBody = UpsertEmployeeDocumentTypeVersionSchema
    export type DuplicateEmployeeDocumentTypeVersionMutationError = AxiosError<unknown>

    /**
 * @summary Duplicates an employee document type version
 */
export const useDuplicateEmployeeDocumentTypeVersion = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof duplicateEmployeeDocumentTypeVersion>>, TError,{documentTypeId: number;versionId: number;data: UpsertEmployeeDocumentTypeVersionSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof duplicateEmployeeDocumentTypeVersion>>,
        TError,
        {documentTypeId: number;versionId: number;data: UpsertEmployeeDocumentTypeVersionSchema},
        TContext
      > => {

      const mutationOptions = getDuplicateEmployeeDocumentTypeVersionMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Activates an employee document type version
 */
export const activateEmployeeDocumentTypeVersion = (
    documentTypeId: number,
    versionId: number,
    activateEmployeeDocumentTypeVersionSchema: ActivateEmployeeDocumentTypeVersionSchema, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.default.put(
      `/api/EmployeeDocumentTypes/${documentTypeId}/Versions/${versionId}/Activation`,
      activateEmployeeDocumentTypeVersionSchema,options
    );
  }



export const getActivateEmployeeDocumentTypeVersionMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activateEmployeeDocumentTypeVersion>>, TError,{documentTypeId: number;versionId: number;data: ActivateEmployeeDocumentTypeVersionSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof activateEmployeeDocumentTypeVersion>>, TError,{documentTypeId: number;versionId: number;data: ActivateEmployeeDocumentTypeVersionSchema}, TContext> => {
    
const mutationKey = ['activateEmployeeDocumentTypeVersion'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof activateEmployeeDocumentTypeVersion>>, {documentTypeId: number;versionId: number;data: ActivateEmployeeDocumentTypeVersionSchema}> = (props) => {
          const {documentTypeId,versionId,data} = props ?? {};

          return  activateEmployeeDocumentTypeVersion(documentTypeId,versionId,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ActivateEmployeeDocumentTypeVersionMutationResult = NonNullable<Awaited<ReturnType<typeof activateEmployeeDocumentTypeVersion>>>
    export type ActivateEmployeeDocumentTypeVersionMutationBody = ActivateEmployeeDocumentTypeVersionSchema
    export type ActivateEmployeeDocumentTypeVersionMutationError = AxiosError<unknown>

    /**
 * @summary Activates an employee document type version
 */
export const useActivateEmployeeDocumentTypeVersion = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activateEmployeeDocumentTypeVersion>>, TError,{documentTypeId: number;versionId: number;data: ActivateEmployeeDocumentTypeVersionSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof activateEmployeeDocumentTypeVersion>>,
        TError,
        {documentTypeId: number;versionId: number;data: ActivateEmployeeDocumentTypeVersionSchema},
        TContext
      > => {

      const mutationOptions = getActivateEmployeeDocumentTypeVersionMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Updates an employee document type version details (name and notes)
 */
export const updateEmployeeDocumentTypeVersionDetails = (
    documentTypeId: number,
    versionId: number,
    upsertEmployeeDocumentTypeVersionSchema: UpsertEmployeeDocumentTypeVersionSchema, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.default.put(
      `/api/EmployeeDocumentTypes/${documentTypeId}/Versions/${versionId}/Details`,
      upsertEmployeeDocumentTypeVersionSchema,options
    );
  }



export const getUpdateEmployeeDocumentTypeVersionDetailsMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateEmployeeDocumentTypeVersionDetails>>, TError,{documentTypeId: number;versionId: number;data: UpsertEmployeeDocumentTypeVersionSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof updateEmployeeDocumentTypeVersionDetails>>, TError,{documentTypeId: number;versionId: number;data: UpsertEmployeeDocumentTypeVersionSchema}, TContext> => {
    
const mutationKey = ['updateEmployeeDocumentTypeVersionDetails'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateEmployeeDocumentTypeVersionDetails>>, {documentTypeId: number;versionId: number;data: UpsertEmployeeDocumentTypeVersionSchema}> = (props) => {
          const {documentTypeId,versionId,data} = props ?? {};

          return  updateEmployeeDocumentTypeVersionDetails(documentTypeId,versionId,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateEmployeeDocumentTypeVersionDetailsMutationResult = NonNullable<Awaited<ReturnType<typeof updateEmployeeDocumentTypeVersionDetails>>>
    export type UpdateEmployeeDocumentTypeVersionDetailsMutationBody = UpsertEmployeeDocumentTypeVersionSchema
    export type UpdateEmployeeDocumentTypeVersionDetailsMutationError = AxiosError<unknown>

    /**
 * @summary Updates an employee document type version details (name and notes)
 */
export const useUpdateEmployeeDocumentTypeVersionDetails = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateEmployeeDocumentTypeVersionDetails>>, TError,{documentTypeId: number;versionId: number;data: UpsertEmployeeDocumentTypeVersionSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof updateEmployeeDocumentTypeVersionDetails>>,
        TError,
        {documentTypeId: number;versionId: number;data: UpsertEmployeeDocumentTypeVersionSchema},
        TContext
      > => {

      const mutationOptions = getUpdateEmployeeDocumentTypeVersionDetailsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Updates employee document type version DocuSeal template
 */
export const updateDocuSealTemplate = (
    documentTypeId: number,
    versionId: number,
    updateEmployeeDocuSealTemplateSchema: UpdateEmployeeDocuSealTemplateSchema, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.default.post(
      `/api/EmployeeDocumentTypes/${documentTypeId}/Versions/${versionId}/DocuSeal/Template`,
      updateEmployeeDocuSealTemplateSchema,options
    );
  }



export const getUpdateDocuSealTemplateMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateDocuSealTemplate>>, TError,{documentTypeId: number;versionId: number;data: UpdateEmployeeDocuSealTemplateSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof updateDocuSealTemplate>>, TError,{documentTypeId: number;versionId: number;data: UpdateEmployeeDocuSealTemplateSchema}, TContext> => {
    
const mutationKey = ['updateDocuSealTemplate'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateDocuSealTemplate>>, {documentTypeId: number;versionId: number;data: UpdateEmployeeDocuSealTemplateSchema}> = (props) => {
          const {documentTypeId,versionId,data} = props ?? {};

          return  updateDocuSealTemplate(documentTypeId,versionId,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateDocuSealTemplateMutationResult = NonNullable<Awaited<ReturnType<typeof updateDocuSealTemplate>>>
    export type UpdateDocuSealTemplateMutationBody = UpdateEmployeeDocuSealTemplateSchema
    export type UpdateDocuSealTemplateMutationError = AxiosError<unknown>

    /**
 * @summary Updates employee document type version DocuSeal template
 */
export const useUpdateDocuSealTemplate = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateDocuSealTemplate>>, TError,{documentTypeId: number;versionId: number;data: UpdateEmployeeDocuSealTemplateSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof updateDocuSealTemplate>>,
        TError,
        {documentTypeId: number;versionId: number;data: UpdateEmployeeDocuSealTemplateSchema},
        TContext
      > => {

      const mutationOptions = getUpdateDocuSealTemplateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Gets employee document type version DocuSeal builder token
 */
export const getDocuSealBuilderToken = (
    documentTypeId: number,
    versionId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<DocuSealTokenResponseSchema>> => {
    
    
    return axios.default.get(
      `/api/EmployeeDocumentTypes/${documentTypeId}/Versions/${versionId}/DocuSeal/Token`,options
    );
  }


export const getGetDocuSealBuilderTokenQueryKey = (documentTypeId: number,
    versionId: number,) => {
    return [`/api/EmployeeDocumentTypes/${documentTypeId}/Versions/${versionId}/DocuSeal/Token`] as const;
    }

    
export const getGetDocuSealBuilderTokenQueryOptions = <TData = Awaited<ReturnType<typeof getDocuSealBuilderToken>>, TError = AxiosError<unknown>>(documentTypeId: number,
    versionId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocuSealBuilderToken>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDocuSealBuilderTokenQueryKey(documentTypeId,versionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDocuSealBuilderToken>>> = ({ signal }) => getDocuSealBuilderToken(documentTypeId,versionId, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(documentTypeId && versionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDocuSealBuilderToken>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDocuSealBuilderTokenQueryResult = NonNullable<Awaited<ReturnType<typeof getDocuSealBuilderToken>>>
export type GetDocuSealBuilderTokenQueryError = AxiosError<unknown>


export function useGetDocuSealBuilderToken<TData = Awaited<ReturnType<typeof getDocuSealBuilderToken>>, TError = AxiosError<unknown>>(
 documentTypeId: number,
    versionId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocuSealBuilderToken>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDocuSealBuilderToken>>,
          TError,
          Awaited<ReturnType<typeof getDocuSealBuilderToken>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDocuSealBuilderToken<TData = Awaited<ReturnType<typeof getDocuSealBuilderToken>>, TError = AxiosError<unknown>>(
 documentTypeId: number,
    versionId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocuSealBuilderToken>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDocuSealBuilderToken>>,
          TError,
          Awaited<ReturnType<typeof getDocuSealBuilderToken>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDocuSealBuilderToken<TData = Awaited<ReturnType<typeof getDocuSealBuilderToken>>, TError = AxiosError<unknown>>(
 documentTypeId: number,
    versionId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocuSealBuilderToken>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Gets employee document type version DocuSeal builder token
 */

export function useGetDocuSealBuilderToken<TData = Awaited<ReturnType<typeof getDocuSealBuilderToken>>, TError = AxiosError<unknown>>(
 documentTypeId: number,
    versionId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocuSealBuilderToken>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDocuSealBuilderTokenQueryOptions(documentTypeId,versionId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Deletes a draft employee document type version
 */
export const deleteEmployeeDocumentTypeVersionDraft = (
    documentTypeId: number,
    versionId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.default.delete(
      `/api/EmployeeDocumentTypes/${documentTypeId}/Versions/Drafts/${versionId}`,options
    );
  }



export const getDeleteEmployeeDocumentTypeVersionDraftMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteEmployeeDocumentTypeVersionDraft>>, TError,{documentTypeId: number;versionId: number}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof deleteEmployeeDocumentTypeVersionDraft>>, TError,{documentTypeId: number;versionId: number}, TContext> => {
    
const mutationKey = ['deleteEmployeeDocumentTypeVersionDraft'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteEmployeeDocumentTypeVersionDraft>>, {documentTypeId: number;versionId: number}> = (props) => {
          const {documentTypeId,versionId} = props ?? {};

          return  deleteEmployeeDocumentTypeVersionDraft(documentTypeId,versionId,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteEmployeeDocumentTypeVersionDraftMutationResult = NonNullable<Awaited<ReturnType<typeof deleteEmployeeDocumentTypeVersionDraft>>>
    
    export type DeleteEmployeeDocumentTypeVersionDraftMutationError = AxiosError<unknown>

    /**
 * @summary Deletes a draft employee document type version
 */
export const useDeleteEmployeeDocumentTypeVersionDraft = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteEmployeeDocumentTypeVersionDraft>>, TError,{documentTypeId: number;versionId: number}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof deleteEmployeeDocumentTypeVersionDraft>>,
        TError,
        {documentTypeId: number;versionId: number},
        TContext
      > => {

      const mutationOptions = getDeleteEmployeeDocumentTypeVersionDraftMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Cancels a scheduled activation for an employee document type version
 */
export const cancelEmployeeDocumentTypeVersionScheduledActivation = (
    documentTypeId: number,
    versionId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.default.delete(
      `/api/EmployeeDocumentTypes/${documentTypeId}/Versions/Scheduled/${versionId}`,options
    );
  }



export const getCancelEmployeeDocumentTypeVersionScheduledActivationMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelEmployeeDocumentTypeVersionScheduledActivation>>, TError,{documentTypeId: number;versionId: number}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof cancelEmployeeDocumentTypeVersionScheduledActivation>>, TError,{documentTypeId: number;versionId: number}, TContext> => {
    
const mutationKey = ['cancelEmployeeDocumentTypeVersionScheduledActivation'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancelEmployeeDocumentTypeVersionScheduledActivation>>, {documentTypeId: number;versionId: number}> = (props) => {
          const {documentTypeId,versionId} = props ?? {};

          return  cancelEmployeeDocumentTypeVersionScheduledActivation(documentTypeId,versionId,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CancelEmployeeDocumentTypeVersionScheduledActivationMutationResult = NonNullable<Awaited<ReturnType<typeof cancelEmployeeDocumentTypeVersionScheduledActivation>>>
    
    export type CancelEmployeeDocumentTypeVersionScheduledActivationMutationError = AxiosError<unknown>

    /**
 * @summary Cancels a scheduled activation for an employee document type version
 */
export const useCancelEmployeeDocumentTypeVersionScheduledActivation = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelEmployeeDocumentTypeVersionScheduledActivation>>, TError,{documentTypeId: number;versionId: number}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof cancelEmployeeDocumentTypeVersionScheduledActivation>>,
        TError,
        {documentTypeId: number;versionId: number},
        TContext
      > => {

      const mutationOptions = getCancelEmployeeDocumentTypeVersionScheduledActivationMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Deletes employee document type
 */
export const deleteEmployeeDocumentType = (
    id: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.default.delete(
      `/api/EmployeeDocumentTypes/${id}`,options
    );
  }



export const getDeleteEmployeeDocumentTypeMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteEmployeeDocumentType>>, TError,{id: number}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof deleteEmployeeDocumentType>>, TError,{id: number}, TContext> => {
    
const mutationKey = ['deleteEmployeeDocumentType'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteEmployeeDocumentType>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteEmployeeDocumentType(id,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteEmployeeDocumentTypeMutationResult = NonNullable<Awaited<ReturnType<typeof deleteEmployeeDocumentType>>>
    
    export type DeleteEmployeeDocumentTypeMutationError = AxiosError<unknown>

    /**
 * @summary Deletes employee document type
 */
export const useDeleteEmployeeDocumentType = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteEmployeeDocumentType>>, TError,{id: number}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof deleteEmployeeDocumentType>>,
        TError,
        {id: number},
        TContext
      > => {

      const mutationOptions = getDeleteEmployeeDocumentTypeMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Renames an employee document type (propagates the new name to every version)
 */
export const renameEmployeeDocumentType = (
    id: number,
    renameEmployeeDocumentTypeSchema: RenameEmployeeDocumentTypeSchema, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.default.put(
      `/api/EmployeeDocumentTypes/${id}/Name`,
      renameEmployeeDocumentTypeSchema,options
    );
  }



export const getRenameEmployeeDocumentTypeMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof renameEmployeeDocumentType>>, TError,{id: number;data: RenameEmployeeDocumentTypeSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof renameEmployeeDocumentType>>, TError,{id: number;data: RenameEmployeeDocumentTypeSchema}, TContext> => {
    
const mutationKey = ['renameEmployeeDocumentType'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof renameEmployeeDocumentType>>, {id: number;data: RenameEmployeeDocumentTypeSchema}> = (props) => {
          const {id,data} = props ?? {};

          return  renameEmployeeDocumentType(id,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RenameEmployeeDocumentTypeMutationResult = NonNullable<Awaited<ReturnType<typeof renameEmployeeDocumentType>>>
    export type RenameEmployeeDocumentTypeMutationBody = RenameEmployeeDocumentTypeSchema
    export type RenameEmployeeDocumentTypeMutationError = AxiosError<unknown>

    /**
 * @summary Renames an employee document type (propagates the new name to every version)
 */
export const useRenameEmployeeDocumentType = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof renameEmployeeDocumentType>>, TError,{id: number;data: RenameEmployeeDocumentTypeSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof renameEmployeeDocumentType>>,
        TError,
        {id: number;data: RenameEmployeeDocumentTypeSchema},
        TContext
      > => {

      const mutationOptions = getRenameEmployeeDocumentTypeMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Updates employee document type status
 */
export const updateEmployeeDocumentTypeStatus = (
    id: number,
    updateEmployeeDocumentTypeStatusSchema: UpdateEmployeeDocumentTypeStatusSchema, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.default.put(
      `/api/EmployeeDocumentTypes/${id}/Status`,
      updateEmployeeDocumentTypeStatusSchema,options
    );
  }



export const getUpdateEmployeeDocumentTypeStatusMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateEmployeeDocumentTypeStatus>>, TError,{id: number;data: UpdateEmployeeDocumentTypeStatusSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof updateEmployeeDocumentTypeStatus>>, TError,{id: number;data: UpdateEmployeeDocumentTypeStatusSchema}, TContext> => {
    
const mutationKey = ['updateEmployeeDocumentTypeStatus'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateEmployeeDocumentTypeStatus>>, {id: number;data: UpdateEmployeeDocumentTypeStatusSchema}> = (props) => {
          const {id,data} = props ?? {};

          return  updateEmployeeDocumentTypeStatus(id,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateEmployeeDocumentTypeStatusMutationResult = NonNullable<Awaited<ReturnType<typeof updateEmployeeDocumentTypeStatus>>>
    export type UpdateEmployeeDocumentTypeStatusMutationBody = UpdateEmployeeDocumentTypeStatusSchema
    export type UpdateEmployeeDocumentTypeStatusMutationError = AxiosError<unknown>

    /**
 * @summary Updates employee document type status
 */
export const useUpdateEmployeeDocumentTypeStatus = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateEmployeeDocumentTypeStatus>>, TError,{id: number;data: UpdateEmployeeDocumentTypeStatusSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof updateEmployeeDocumentTypeStatus>>,
        TError,
        {id: number;data: UpdateEmployeeDocumentTypeStatusSchema},
        TContext
      > => {

      const mutationOptions = getUpdateEmployeeDocumentTypeStatusMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Gets system fields available for DocuSeal template configuration (auto-filled from employee data)
 */
export const getEmployeeDocuSealSystemFields = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<EmployeeOnboardingTemplateFieldSchema[]>> => {
    
    
    return axios.default.get(
      `/api/EmployeeDocuSealFields/System`,options
    );
  }


export const getGetEmployeeDocuSealSystemFieldsQueryKey = () => {
    return [`/api/EmployeeDocuSealFields/System`] as const;
    }

    
export const getGetEmployeeDocuSealSystemFieldsQueryOptions = <TData = Awaited<ReturnType<typeof getEmployeeDocuSealSystemFields>>, TError = AxiosError<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeeDocuSealSystemFields>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEmployeeDocuSealSystemFieldsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEmployeeDocuSealSystemFields>>> = ({ signal }) => getEmployeeDocuSealSystemFields({ signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEmployeeDocuSealSystemFields>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEmployeeDocuSealSystemFieldsQueryResult = NonNullable<Awaited<ReturnType<typeof getEmployeeDocuSealSystemFields>>>
export type GetEmployeeDocuSealSystemFieldsQueryError = AxiosError<unknown>


export function useGetEmployeeDocuSealSystemFields<TData = Awaited<ReturnType<typeof getEmployeeDocuSealSystemFields>>, TError = AxiosError<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeeDocuSealSystemFields>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmployeeDocuSealSystemFields>>,
          TError,
          Awaited<ReturnType<typeof getEmployeeDocuSealSystemFields>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmployeeDocuSealSystemFields<TData = Awaited<ReturnType<typeof getEmployeeDocuSealSystemFields>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeeDocuSealSystemFields>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmployeeDocuSealSystemFields>>,
          TError,
          Awaited<ReturnType<typeof getEmployeeDocuSealSystemFields>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmployeeDocuSealSystemFields<TData = Awaited<ReturnType<typeof getEmployeeDocuSealSystemFields>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeeDocuSealSystemFields>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Gets system fields available for DocuSeal template configuration (auto-filled from employee data)
 */

export function useGetEmployeeDocuSealSystemFields<TData = Awaited<ReturnType<typeof getEmployeeDocuSealSystemFields>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeeDocuSealSystemFields>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEmployeeDocuSealSystemFieldsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Gets employee filters
 */
export const getEmployeeFilters = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<EmployeeFilterSchema[]>> => {
    
    
    return axios.default.get(
      `/api/EmployeeFilters`,options
    );
  }


export const getGetEmployeeFiltersQueryKey = () => {
    return [`/api/EmployeeFilters`] as const;
    }

    
export const getGetEmployeeFiltersQueryOptions = <TData = Awaited<ReturnType<typeof getEmployeeFilters>>, TError = AxiosError<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeeFilters>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEmployeeFiltersQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEmployeeFilters>>> = ({ signal }) => getEmployeeFilters({ signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEmployeeFilters>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEmployeeFiltersQueryResult = NonNullable<Awaited<ReturnType<typeof getEmployeeFilters>>>
export type GetEmployeeFiltersQueryError = AxiosError<unknown>


export function useGetEmployeeFilters<TData = Awaited<ReturnType<typeof getEmployeeFilters>>, TError = AxiosError<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeeFilters>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmployeeFilters>>,
          TError,
          Awaited<ReturnType<typeof getEmployeeFilters>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmployeeFilters<TData = Awaited<ReturnType<typeof getEmployeeFilters>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeeFilters>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmployeeFilters>>,
          TError,
          Awaited<ReturnType<typeof getEmployeeFilters>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmployeeFilters<TData = Awaited<ReturnType<typeof getEmployeeFilters>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeeFilters>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Gets employee filters
 */

export function useGetEmployeeFilters<TData = Awaited<ReturnType<typeof getEmployeeFilters>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeeFilters>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEmployeeFiltersQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Adds employee filter
 */
export const addEmployeeFilter = (
    upsertEmployeeFilterSchema: UpsertEmployeeFilterSchema, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.default.post(
      `/api/EmployeeFilters`,
      upsertEmployeeFilterSchema,options
    );
  }



export const getAddEmployeeFilterMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addEmployeeFilter>>, TError,{data: UpsertEmployeeFilterSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof addEmployeeFilter>>, TError,{data: UpsertEmployeeFilterSchema}, TContext> => {
    
const mutationKey = ['addEmployeeFilter'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addEmployeeFilter>>, {data: UpsertEmployeeFilterSchema}> = (props) => {
          const {data} = props ?? {};

          return  addEmployeeFilter(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AddEmployeeFilterMutationResult = NonNullable<Awaited<ReturnType<typeof addEmployeeFilter>>>
    export type AddEmployeeFilterMutationBody = UpsertEmployeeFilterSchema
    export type AddEmployeeFilterMutationError = AxiosError<unknown>

    /**
 * @summary Adds employee filter
 */
export const useAddEmployeeFilter = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addEmployeeFilter>>, TError,{data: UpsertEmployeeFilterSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof addEmployeeFilter>>,
        TError,
        {data: UpsertEmployeeFilterSchema},
        TContext
      > => {

      const mutationOptions = getAddEmployeeFilterMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Gets employee filter by ID
 */
export const getEmployeeFilter = (
    filterId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<EmployeeFilterSchema>> => {
    
    
    return axios.default.get(
      `/api/EmployeeFilters/${filterId}`,options
    );
  }


export const getGetEmployeeFilterQueryKey = (filterId: number,) => {
    return [`/api/EmployeeFilters/${filterId}`] as const;
    }

    
export const getGetEmployeeFilterQueryOptions = <TData = Awaited<ReturnType<typeof getEmployeeFilter>>, TError = AxiosError<unknown>>(filterId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeeFilter>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEmployeeFilterQueryKey(filterId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEmployeeFilter>>> = ({ signal }) => getEmployeeFilter(filterId, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(filterId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEmployeeFilter>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEmployeeFilterQueryResult = NonNullable<Awaited<ReturnType<typeof getEmployeeFilter>>>
export type GetEmployeeFilterQueryError = AxiosError<unknown>


export function useGetEmployeeFilter<TData = Awaited<ReturnType<typeof getEmployeeFilter>>, TError = AxiosError<unknown>>(
 filterId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeeFilter>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmployeeFilter>>,
          TError,
          Awaited<ReturnType<typeof getEmployeeFilter>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmployeeFilter<TData = Awaited<ReturnType<typeof getEmployeeFilter>>, TError = AxiosError<unknown>>(
 filterId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeeFilter>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmployeeFilter>>,
          TError,
          Awaited<ReturnType<typeof getEmployeeFilter>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmployeeFilter<TData = Awaited<ReturnType<typeof getEmployeeFilter>>, TError = AxiosError<unknown>>(
 filterId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeeFilter>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Gets employee filter by ID
 */

export function useGetEmployeeFilter<TData = Awaited<ReturnType<typeof getEmployeeFilter>>, TError = AxiosError<unknown>>(
 filterId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeeFilter>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEmployeeFilterQueryOptions(filterId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Updates employee filter
 */
export const updateEmployeeFilter = (
    filterId: number,
    upsertEmployeeFilterSchema: UpsertEmployeeFilterSchema, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.default.put(
      `/api/EmployeeFilters/${filterId}`,
      upsertEmployeeFilterSchema,options
    );
  }



export const getUpdateEmployeeFilterMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateEmployeeFilter>>, TError,{filterId: number;data: UpsertEmployeeFilterSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof updateEmployeeFilter>>, TError,{filterId: number;data: UpsertEmployeeFilterSchema}, TContext> => {
    
const mutationKey = ['updateEmployeeFilter'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateEmployeeFilter>>, {filterId: number;data: UpsertEmployeeFilterSchema}> = (props) => {
          const {filterId,data} = props ?? {};

          return  updateEmployeeFilter(filterId,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateEmployeeFilterMutationResult = NonNullable<Awaited<ReturnType<typeof updateEmployeeFilter>>>
    export type UpdateEmployeeFilterMutationBody = UpsertEmployeeFilterSchema
    export type UpdateEmployeeFilterMutationError = AxiosError<unknown>

    /**
 * @summary Updates employee filter
 */
export const useUpdateEmployeeFilter = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateEmployeeFilter>>, TError,{filterId: number;data: UpsertEmployeeFilterSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof updateEmployeeFilter>>,
        TError,
        {filterId: number;data: UpsertEmployeeFilterSchema},
        TContext
      > => {

      const mutationOptions = getUpdateEmployeeFilterMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Deletes employee filter
 */
export const deleteEmployeeFilter = (
    filterId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.default.delete(
      `/api/EmployeeFilters/${filterId}`,options
    );
  }



export const getDeleteEmployeeFilterMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteEmployeeFilter>>, TError,{filterId: number}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof deleteEmployeeFilter>>, TError,{filterId: number}, TContext> => {
    
const mutationKey = ['deleteEmployeeFilter'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteEmployeeFilter>>, {filterId: number}> = (props) => {
          const {filterId} = props ?? {};

          return  deleteEmployeeFilter(filterId,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteEmployeeFilterMutationResult = NonNullable<Awaited<ReturnType<typeof deleteEmployeeFilter>>>
    
    export type DeleteEmployeeFilterMutationError = AxiosError<unknown>

    /**
 * @summary Deletes employee filter
 */
export const useDeleteEmployeeFilter = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteEmployeeFilter>>, TError,{filterId: number}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof deleteEmployeeFilter>>,
        TError,
        {filterId: number},
        TContext
      > => {

      const mutationOptions = getDeleteEmployeeFilterMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Gets employee filters options
 */
export const getEmployeeFiltersOptions = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<EmployeeFilterOptionsSchema>> => {
    
    
    return axios.default.get(
      `/api/EmployeeFilters/Options`,options
    );
  }


export const getGetEmployeeFiltersOptionsQueryKey = () => {
    return [`/api/EmployeeFilters/Options`] as const;
    }

    
export const getGetEmployeeFiltersOptionsQueryOptions = <TData = Awaited<ReturnType<typeof getEmployeeFiltersOptions>>, TError = AxiosError<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeeFiltersOptions>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEmployeeFiltersOptionsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEmployeeFiltersOptions>>> = ({ signal }) => getEmployeeFiltersOptions({ signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEmployeeFiltersOptions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEmployeeFiltersOptionsQueryResult = NonNullable<Awaited<ReturnType<typeof getEmployeeFiltersOptions>>>
export type GetEmployeeFiltersOptionsQueryError = AxiosError<unknown>


export function useGetEmployeeFiltersOptions<TData = Awaited<ReturnType<typeof getEmployeeFiltersOptions>>, TError = AxiosError<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeeFiltersOptions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmployeeFiltersOptions>>,
          TError,
          Awaited<ReturnType<typeof getEmployeeFiltersOptions>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmployeeFiltersOptions<TData = Awaited<ReturnType<typeof getEmployeeFiltersOptions>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeeFiltersOptions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmployeeFiltersOptions>>,
          TError,
          Awaited<ReturnType<typeof getEmployeeFiltersOptions>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmployeeFiltersOptions<TData = Awaited<ReturnType<typeof getEmployeeFiltersOptions>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeeFiltersOptions>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Gets employee filters options
 */

export function useGetEmployeeFiltersOptions<TData = Awaited<ReturnType<typeof getEmployeeFiltersOptions>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeeFiltersOptions>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEmployeeFiltersOptionsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Submits onboarding for review
 */
export const submitOnboardingForReview = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.default.post(
      `/api/EmployeeOnboarding`,undefined,options
    );
  }



export const getSubmitOnboardingForReviewMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitOnboardingForReview>>, TError,void, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof submitOnboardingForReview>>, TError,void, TContext> => {
    
const mutationKey = ['submitOnboardingForReview'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof submitOnboardingForReview>>, void> = () => {
          

          return  submitOnboardingForReview(axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SubmitOnboardingForReviewMutationResult = NonNullable<Awaited<ReturnType<typeof submitOnboardingForReview>>>
    
    export type SubmitOnboardingForReviewMutationError = AxiosError<unknown>

    /**
 * @summary Submits onboarding for review
 */
export const useSubmitOnboardingForReview = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitOnboardingForReview>>, TError,void, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof submitOnboardingForReview>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getSubmitOnboardingForReviewMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const overrideAdverseBackgroundCheckResult = (
    entryId: number,
    providerId: 1,
    orderId: number,
    overrideBackgroundCheckRequestSchema: OverrideBackgroundCheckRequestSchema, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<BackgroundCheckOrderDtoSchema>> => {
    
    
    return axios.default.post(
      `/api/EmployeeOnboarding/${entryId}/BackgroundCheck/${providerId}/Orders/${orderId}/override`,
      overrideBackgroundCheckRequestSchema,options
    );
  }



export const getOverrideAdverseBackgroundCheckResultMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof overrideAdverseBackgroundCheckResult>>, TError,{entryId: number;providerId: 1;orderId: number;data: OverrideBackgroundCheckRequestSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof overrideAdverseBackgroundCheckResult>>, TError,{entryId: number;providerId: 1;orderId: number;data: OverrideBackgroundCheckRequestSchema}, TContext> => {
    
const mutationKey = ['overrideAdverseBackgroundCheckResult'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof overrideAdverseBackgroundCheckResult>>, {entryId: number;providerId: 1;orderId: number;data: OverrideBackgroundCheckRequestSchema}> = (props) => {
          const {entryId,providerId,orderId,data} = props ?? {};

          return  overrideAdverseBackgroundCheckResult(entryId,providerId,orderId,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type OverrideAdverseBackgroundCheckResultMutationResult = NonNullable<Awaited<ReturnType<typeof overrideAdverseBackgroundCheckResult>>>
    export type OverrideAdverseBackgroundCheckResultMutationBody = OverrideBackgroundCheckRequestSchema
    export type OverrideAdverseBackgroundCheckResultMutationError = AxiosError<unknown>

    export const useOverrideAdverseBackgroundCheckResult = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof overrideAdverseBackgroundCheckResult>>, TError,{entryId: number;providerId: 1;orderId: number;data: OverrideBackgroundCheckRequestSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof overrideAdverseBackgroundCheckResult>>,
        TError,
        {entryId: number;providerId: 1;orderId: number;data: OverrideBackgroundCheckRequestSchema},
        TContext
      > => {

      const mutationOptions = getOverrideAdverseBackgroundCheckResultMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getActivationBgCheckStatus = (
    entryId: number,
    providerId: 1, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ActivationBgCheckStatusDtoSchema>> => {
    
    
    return axios.default.get(
      `/api/EmployeeOnboarding/${entryId}/BackgroundCheck/${providerId}/Orders/activation-status`,options
    );
  }


export const getGetActivationBgCheckStatusQueryKey = (entryId: number,
    providerId: 1,) => {
    return [`/api/EmployeeOnboarding/${entryId}/BackgroundCheck/${providerId}/Orders/activation-status`] as const;
    }

    
export const getGetActivationBgCheckStatusQueryOptions = <TData = Awaited<ReturnType<typeof getActivationBgCheckStatus>>, TError = AxiosError<unknown>>(entryId: number,
    providerId: 1, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActivationBgCheckStatus>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetActivationBgCheckStatusQueryKey(entryId,providerId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getActivationBgCheckStatus>>> = ({ signal }) => getActivationBgCheckStatus(entryId,providerId, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(entryId && providerId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getActivationBgCheckStatus>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetActivationBgCheckStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getActivationBgCheckStatus>>>
export type GetActivationBgCheckStatusQueryError = AxiosError<unknown>


export function useGetActivationBgCheckStatus<TData = Awaited<ReturnType<typeof getActivationBgCheckStatus>>, TError = AxiosError<unknown>>(
 entryId: number,
    providerId: 1, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActivationBgCheckStatus>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActivationBgCheckStatus>>,
          TError,
          Awaited<ReturnType<typeof getActivationBgCheckStatus>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetActivationBgCheckStatus<TData = Awaited<ReturnType<typeof getActivationBgCheckStatus>>, TError = AxiosError<unknown>>(
 entryId: number,
    providerId: 1, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActivationBgCheckStatus>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActivationBgCheckStatus>>,
          TError,
          Awaited<ReturnType<typeof getActivationBgCheckStatus>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetActivationBgCheckStatus<TData = Awaited<ReturnType<typeof getActivationBgCheckStatus>>, TError = AxiosError<unknown>>(
 entryId: number,
    providerId: 1, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActivationBgCheckStatus>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetActivationBgCheckStatus<TData = Awaited<ReturnType<typeof getActivationBgCheckStatus>>, TError = AxiosError<unknown>>(
 entryId: number,
    providerId: 1, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActivationBgCheckStatus>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetActivationBgCheckStatusQueryOptions(entryId,providerId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const sendBackgroundCheck = (
    entryId: number,
    providerId: 1,
    sendBackgroundCheckRequestSchema: SendBackgroundCheckRequestSchema, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<BackgroundCheckOrderGroupDtoSchema>> => {
    
    
    return axios.default.post(
      `/api/EmployeeOnboarding/${entryId}/BackgroundCheck/${providerId}/Orders/send`,
      sendBackgroundCheckRequestSchema,options
    );
  }



export const getSendBackgroundCheckMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendBackgroundCheck>>, TError,{entryId: number;providerId: 1;data: SendBackgroundCheckRequestSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof sendBackgroundCheck>>, TError,{entryId: number;providerId: 1;data: SendBackgroundCheckRequestSchema}, TContext> => {
    
const mutationKey = ['sendBackgroundCheck'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendBackgroundCheck>>, {entryId: number;providerId: 1;data: SendBackgroundCheckRequestSchema}> = (props) => {
          const {entryId,providerId,data} = props ?? {};

          return  sendBackgroundCheck(entryId,providerId,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SendBackgroundCheckMutationResult = NonNullable<Awaited<ReturnType<typeof sendBackgroundCheck>>>
    export type SendBackgroundCheckMutationBody = SendBackgroundCheckRequestSchema
    export type SendBackgroundCheckMutationError = AxiosError<unknown>

    export const useSendBackgroundCheck = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendBackgroundCheck>>, TError,{entryId: number;providerId: 1;data: SendBackgroundCheckRequestSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof sendBackgroundCheck>>,
        TError,
        {entryId: number;providerId: 1;data: SendBackgroundCheckRequestSchema},
        TContext
      > => {

      const mutationOptions = getSendBackgroundCheckMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getBackgroundCheckOrderStatus = (
    entryId: number,
    providerId: 1, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<BackgroundCheckOrderGroupDtoSchema>> => {
    
    
    return axios.default.get(
      `/api/EmployeeOnboarding/${entryId}/BackgroundCheck/${providerId}/Orders/status`,options
    );
  }


export const getGetBackgroundCheckOrderStatusQueryKey = (entryId: number,
    providerId: 1,) => {
    return [`/api/EmployeeOnboarding/${entryId}/BackgroundCheck/${providerId}/Orders/status`] as const;
    }

    
export const getGetBackgroundCheckOrderStatusQueryOptions = <TData = Awaited<ReturnType<typeof getBackgroundCheckOrderStatus>>, TError = AxiosError<unknown>>(entryId: number,
    providerId: 1, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBackgroundCheckOrderStatus>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBackgroundCheckOrderStatusQueryKey(entryId,providerId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBackgroundCheckOrderStatus>>> = ({ signal }) => getBackgroundCheckOrderStatus(entryId,providerId, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(entryId && providerId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBackgroundCheckOrderStatus>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBackgroundCheckOrderStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getBackgroundCheckOrderStatus>>>
export type GetBackgroundCheckOrderStatusQueryError = AxiosError<unknown>


export function useGetBackgroundCheckOrderStatus<TData = Awaited<ReturnType<typeof getBackgroundCheckOrderStatus>>, TError = AxiosError<unknown>>(
 entryId: number,
    providerId: 1, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBackgroundCheckOrderStatus>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBackgroundCheckOrderStatus>>,
          TError,
          Awaited<ReturnType<typeof getBackgroundCheckOrderStatus>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBackgroundCheckOrderStatus<TData = Awaited<ReturnType<typeof getBackgroundCheckOrderStatus>>, TError = AxiosError<unknown>>(
 entryId: number,
    providerId: 1, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBackgroundCheckOrderStatus>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBackgroundCheckOrderStatus>>,
          TError,
          Awaited<ReturnType<typeof getBackgroundCheckOrderStatus>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBackgroundCheckOrderStatus<TData = Awaited<ReturnType<typeof getBackgroundCheckOrderStatus>>, TError = AxiosError<unknown>>(
 entryId: number,
    providerId: 1, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBackgroundCheckOrderStatus>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetBackgroundCheckOrderStatus<TData = Awaited<ReturnType<typeof getBackgroundCheckOrderStatus>>, TError = AxiosError<unknown>>(
 entryId: number,
    providerId: 1, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBackgroundCheckOrderStatus>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBackgroundCheckOrderStatusQueryOptions(entryId,providerId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Adds new user account for employee
 */
export const addNewEmployeeAccount = (
    addEmployeeAccountSchema: AddEmployeeAccountSchema, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<UserAuthorizationResultsSchema>> => {
    
    
    return axios.default.post(
      `/api/EmployeeOnboarding/Accounts`,
      addEmployeeAccountSchema,options
    );
  }



export const getAddNewEmployeeAccountMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addNewEmployeeAccount>>, TError,{data: AddEmployeeAccountSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof addNewEmployeeAccount>>, TError,{data: AddEmployeeAccountSchema}, TContext> => {
    
const mutationKey = ['addNewEmployeeAccount'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addNewEmployeeAccount>>, {data: AddEmployeeAccountSchema}> = (props) => {
          const {data} = props ?? {};

          return  addNewEmployeeAccount(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AddNewEmployeeAccountMutationResult = NonNullable<Awaited<ReturnType<typeof addNewEmployeeAccount>>>
    export type AddNewEmployeeAccountMutationBody = AddEmployeeAccountSchema
    export type AddNewEmployeeAccountMutationError = AxiosError<unknown>

    /**
 * @summary Adds new user account for employee
 */
export const useAddNewEmployeeAccount = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addNewEmployeeAccount>>, TError,{data: AddEmployeeAccountSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof addNewEmployeeAccount>>,
        TError,
        {data: AddEmployeeAccountSchema},
        TContext
      > => {

      const mutationOptions = getAddNewEmployeeAccountMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Gets the employee's background check status and portal link
 */
export const getEmployeeBackgroundCheckStatus = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<EmployeeBackgroundCheckStatusDtoSchema | void>> => {
    
    
    return axios.default.get(
      `/api/EmployeeOnboarding/BackgroundCheckStatus`,options
    );
  }


export const getGetEmployeeBackgroundCheckStatusQueryKey = () => {
    return [`/api/EmployeeOnboarding/BackgroundCheckStatus`] as const;
    }

    
export const getGetEmployeeBackgroundCheckStatusQueryOptions = <TData = Awaited<ReturnType<typeof getEmployeeBackgroundCheckStatus>>, TError = AxiosError<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeeBackgroundCheckStatus>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEmployeeBackgroundCheckStatusQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEmployeeBackgroundCheckStatus>>> = ({ signal }) => getEmployeeBackgroundCheckStatus({ signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEmployeeBackgroundCheckStatus>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEmployeeBackgroundCheckStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getEmployeeBackgroundCheckStatus>>>
export type GetEmployeeBackgroundCheckStatusQueryError = AxiosError<unknown>


export function useGetEmployeeBackgroundCheckStatus<TData = Awaited<ReturnType<typeof getEmployeeBackgroundCheckStatus>>, TError = AxiosError<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeeBackgroundCheckStatus>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmployeeBackgroundCheckStatus>>,
          TError,
          Awaited<ReturnType<typeof getEmployeeBackgroundCheckStatus>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmployeeBackgroundCheckStatus<TData = Awaited<ReturnType<typeof getEmployeeBackgroundCheckStatus>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeeBackgroundCheckStatus>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmployeeBackgroundCheckStatus>>,
          TError,
          Awaited<ReturnType<typeof getEmployeeBackgroundCheckStatus>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmployeeBackgroundCheckStatus<TData = Awaited<ReturnType<typeof getEmployeeBackgroundCheckStatus>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeeBackgroundCheckStatus>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Gets the employee's background check status and portal link
 */

export function useGetEmployeeBackgroundCheckStatus<TData = Awaited<ReturnType<typeof getEmployeeBackgroundCheckStatus>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeeBackgroundCheckStatus>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEmployeeBackgroundCheckStatusQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Gets contractor info
 */
export const getContractorInfo = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ContractorInfoSchema>> => {
    
    
    return axios.default.get(
      `/api/EmployeeOnboarding/ContractorInfo`,options
    );
  }


export const getGetContractorInfoQueryKey = () => {
    return [`/api/EmployeeOnboarding/ContractorInfo`] as const;
    }

    
export const getGetContractorInfoQueryOptions = <TData = Awaited<ReturnType<typeof getContractorInfo>>, TError = AxiosError<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getContractorInfo>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetContractorInfoQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getContractorInfo>>> = ({ signal }) => getContractorInfo({ signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getContractorInfo>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetContractorInfoQueryResult = NonNullable<Awaited<ReturnType<typeof getContractorInfo>>>
export type GetContractorInfoQueryError = AxiosError<unknown>


export function useGetContractorInfo<TData = Awaited<ReturnType<typeof getContractorInfo>>, TError = AxiosError<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getContractorInfo>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getContractorInfo>>,
          TError,
          Awaited<ReturnType<typeof getContractorInfo>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetContractorInfo<TData = Awaited<ReturnType<typeof getContractorInfo>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getContractorInfo>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getContractorInfo>>,
          TError,
          Awaited<ReturnType<typeof getContractorInfo>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetContractorInfo<TData = Awaited<ReturnType<typeof getContractorInfo>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getContractorInfo>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Gets contractor info
 */

export function useGetContractorInfo<TData = Awaited<ReturnType<typeof getContractorInfo>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getContractorInfo>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetContractorInfoQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Updates contractor info
 */
export const updateContractorInfo = (
    contractorInfoUpdateSchema: ContractorInfoUpdateSchema, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.default.post(
      `/api/EmployeeOnboarding/ContractorInfo`,
      contractorInfoUpdateSchema,options
    );
  }



export const getUpdateContractorInfoMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateContractorInfo>>, TError,{data: ContractorInfoUpdateSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof updateContractorInfo>>, TError,{data: ContractorInfoUpdateSchema}, TContext> => {
    
const mutationKey = ['updateContractorInfo'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateContractorInfo>>, {data: ContractorInfoUpdateSchema}> = (props) => {
          const {data} = props ?? {};

          return  updateContractorInfo(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateContractorInfoMutationResult = NonNullable<Awaited<ReturnType<typeof updateContractorInfo>>>
    export type UpdateContractorInfoMutationBody = ContractorInfoUpdateSchema
    export type UpdateContractorInfoMutationError = AxiosError<unknown>

    /**
 * @summary Updates contractor info
 */
export const useUpdateContractorInfo = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateContractorInfo>>, TError,{data: ContractorInfoUpdateSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof updateContractorInfo>>,
        TError,
        {data: ContractorInfoUpdateSchema},
        TContext
      > => {

      const mutationOptions = getUpdateContractorInfoMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Gets employee onboarding document template
 */
export const getEmployeeDocumentTemplate = (
    templateId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<EmployeeOnboardingDocumentTemplateSchema>> => {
    
    
    return axios.default.get(
      `/api/EmployeeOnboarding/CustomTemplates/${templateId}`,options
    );
  }


export const getGetEmployeeDocumentTemplateQueryKey = (templateId: number,) => {
    return [`/api/EmployeeOnboarding/CustomTemplates/${templateId}`] as const;
    }

    
export const getGetEmployeeDocumentTemplateQueryOptions = <TData = Awaited<ReturnType<typeof getEmployeeDocumentTemplate>>, TError = AxiosError<unknown>>(templateId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeeDocumentTemplate>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEmployeeDocumentTemplateQueryKey(templateId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEmployeeDocumentTemplate>>> = ({ signal }) => getEmployeeDocumentTemplate(templateId, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(templateId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEmployeeDocumentTemplate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEmployeeDocumentTemplateQueryResult = NonNullable<Awaited<ReturnType<typeof getEmployeeDocumentTemplate>>>
export type GetEmployeeDocumentTemplateQueryError = AxiosError<unknown>


export function useGetEmployeeDocumentTemplate<TData = Awaited<ReturnType<typeof getEmployeeDocumentTemplate>>, TError = AxiosError<unknown>>(
 templateId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeeDocumentTemplate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmployeeDocumentTemplate>>,
          TError,
          Awaited<ReturnType<typeof getEmployeeDocumentTemplate>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmployeeDocumentTemplate<TData = Awaited<ReturnType<typeof getEmployeeDocumentTemplate>>, TError = AxiosError<unknown>>(
 templateId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeeDocumentTemplate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmployeeDocumentTemplate>>,
          TError,
          Awaited<ReturnType<typeof getEmployeeDocumentTemplate>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmployeeDocumentTemplate<TData = Awaited<ReturnType<typeof getEmployeeDocumentTemplate>>, TError = AxiosError<unknown>>(
 templateId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeeDocumentTemplate>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Gets employee onboarding document template
 */

export function useGetEmployeeDocumentTemplate<TData = Awaited<ReturnType<typeof getEmployeeDocumentTemplate>>, TError = AxiosError<unknown>>(
 templateId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeeDocumentTemplate>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEmployeeDocumentTemplateQueryOptions(templateId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Submits employee onboarding document template
 */
export const submitEmployeeDocumentTemplate = (
    templateId: number,
    submitOnboardingCustomTemplateSchema: SubmitOnboardingCustomTemplateSchema, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.default.post(
      `/api/EmployeeOnboarding/CustomTemplates/${templateId}`,
      submitOnboardingCustomTemplateSchema,options
    );
  }



export const getSubmitEmployeeDocumentTemplateMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitEmployeeDocumentTemplate>>, TError,{templateId: number;data: SubmitOnboardingCustomTemplateSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof submitEmployeeDocumentTemplate>>, TError,{templateId: number;data: SubmitOnboardingCustomTemplateSchema}, TContext> => {
    
const mutationKey = ['submitEmployeeDocumentTemplate'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof submitEmployeeDocumentTemplate>>, {templateId: number;data: SubmitOnboardingCustomTemplateSchema}> = (props) => {
          const {templateId,data} = props ?? {};

          return  submitEmployeeDocumentTemplate(templateId,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SubmitEmployeeDocumentTemplateMutationResult = NonNullable<Awaited<ReturnType<typeof submitEmployeeDocumentTemplate>>>
    export type SubmitEmployeeDocumentTemplateMutationBody = SubmitOnboardingCustomTemplateSchema
    export type SubmitEmployeeDocumentTemplateMutationError = AxiosError<unknown>

    /**
 * @summary Submits employee onboarding document template
 */
export const useSubmitEmployeeDocumentTemplate = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitEmployeeDocumentTemplate>>, TError,{templateId: number;data: SubmitOnboardingCustomTemplateSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof submitEmployeeDocumentTemplate>>,
        TError,
        {templateId: number;data: SubmitOnboardingCustomTemplateSchema},
        TContext
      > => {

      const mutationOptions = getSubmitEmployeeDocumentTemplateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Gets employee onboarding document
 */
export const getEmployeeOnboardingDocumentAttachment = (
    documentId: number,
    params?: GetEmployeeOnboardingDocumentAttachmentParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Blob>> => {
    
    
    return axios.default.get(
      `/api/EmployeeOnboarding/Documents/${documentId}`,{
        responseType: 'blob',
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getGetEmployeeOnboardingDocumentAttachmentQueryKey = (documentId: number,
    params?: GetEmployeeOnboardingDocumentAttachmentParams,) => {
    return [`/api/EmployeeOnboarding/Documents/${documentId}`, ...(params ? [params]: [])] as const;
    }

    
export const getGetEmployeeOnboardingDocumentAttachmentQueryOptions = <TData = Awaited<ReturnType<typeof getEmployeeOnboardingDocumentAttachment>>, TError = AxiosError<unknown>>(documentId: number,
    params?: GetEmployeeOnboardingDocumentAttachmentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeeOnboardingDocumentAttachment>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEmployeeOnboardingDocumentAttachmentQueryKey(documentId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEmployeeOnboardingDocumentAttachment>>> = ({ signal }) => getEmployeeOnboardingDocumentAttachment(documentId,params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(documentId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEmployeeOnboardingDocumentAttachment>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEmployeeOnboardingDocumentAttachmentQueryResult = NonNullable<Awaited<ReturnType<typeof getEmployeeOnboardingDocumentAttachment>>>
export type GetEmployeeOnboardingDocumentAttachmentQueryError = AxiosError<unknown>


export function useGetEmployeeOnboardingDocumentAttachment<TData = Awaited<ReturnType<typeof getEmployeeOnboardingDocumentAttachment>>, TError = AxiosError<unknown>>(
 documentId: number,
    params: undefined |  GetEmployeeOnboardingDocumentAttachmentParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeeOnboardingDocumentAttachment>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmployeeOnboardingDocumentAttachment>>,
          TError,
          Awaited<ReturnType<typeof getEmployeeOnboardingDocumentAttachment>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmployeeOnboardingDocumentAttachment<TData = Awaited<ReturnType<typeof getEmployeeOnboardingDocumentAttachment>>, TError = AxiosError<unknown>>(
 documentId: number,
    params?: GetEmployeeOnboardingDocumentAttachmentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeeOnboardingDocumentAttachment>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmployeeOnboardingDocumentAttachment>>,
          TError,
          Awaited<ReturnType<typeof getEmployeeOnboardingDocumentAttachment>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmployeeOnboardingDocumentAttachment<TData = Awaited<ReturnType<typeof getEmployeeOnboardingDocumentAttachment>>, TError = AxiosError<unknown>>(
 documentId: number,
    params?: GetEmployeeOnboardingDocumentAttachmentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeeOnboardingDocumentAttachment>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Gets employee onboarding document
 */

export function useGetEmployeeOnboardingDocumentAttachment<TData = Awaited<ReturnType<typeof getEmployeeOnboardingDocumentAttachment>>, TError = AxiosError<unknown>>(
 documentId: number,
    params?: GetEmployeeOnboardingDocumentAttachmentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeeOnboardingDocumentAttachment>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEmployeeOnboardingDocumentAttachmentQueryOptions(documentId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Updates employee onboarding document
 */
export const updateEmployeeOnboardingDocumentDetails = (
    documentId: number,
    updateEmployeeOnboardingDocumentDetailsBody: UpdateEmployeeOnboardingDocumentDetailsBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    const formData = createFormData(updateEmployeeOnboardingDocumentDetailsBody)
    return axios.default.patch(
      `/api/EmployeeOnboarding/Documents/${documentId}`,
      formData,options
    );
  }



export const getUpdateEmployeeOnboardingDocumentDetailsMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateEmployeeOnboardingDocumentDetails>>, TError,{documentId: number;data: UpdateEmployeeOnboardingDocumentDetailsBody}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof updateEmployeeOnboardingDocumentDetails>>, TError,{documentId: number;data: UpdateEmployeeOnboardingDocumentDetailsBody}, TContext> => {
    
const mutationKey = ['updateEmployeeOnboardingDocumentDetails'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateEmployeeOnboardingDocumentDetails>>, {documentId: number;data: UpdateEmployeeOnboardingDocumentDetailsBody}> = (props) => {
          const {documentId,data} = props ?? {};

          return  updateEmployeeOnboardingDocumentDetails(documentId,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateEmployeeOnboardingDocumentDetailsMutationResult = NonNullable<Awaited<ReturnType<typeof updateEmployeeOnboardingDocumentDetails>>>
    export type UpdateEmployeeOnboardingDocumentDetailsMutationBody = UpdateEmployeeOnboardingDocumentDetailsBody
    export type UpdateEmployeeOnboardingDocumentDetailsMutationError = AxiosError<unknown>

    /**
 * @summary Updates employee onboarding document
 */
export const useUpdateEmployeeOnboardingDocumentDetails = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateEmployeeOnboardingDocumentDetails>>, TError,{documentId: number;data: UpdateEmployeeOnboardingDocumentDetailsBody}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof updateEmployeeOnboardingDocumentDetails>>,
        TError,
        {documentId: number;data: UpdateEmployeeOnboardingDocumentDetailsBody},
        TContext
      > => {

      const mutationOptions = getUpdateEmployeeOnboardingDocumentDetailsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Updates employee onboarding document attachment
 */
export const updateEmployeeOnboardingDocumentAttachment = (
    documentId: number,
    attachmentIndex: number,
    updateEmployeeOnboardingDocumentAttachmentBody: UpdateEmployeeOnboardingDocumentAttachmentBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    const formData = createFormData(updateEmployeeOnboardingDocumentAttachmentBody)
    return axios.default.put(
      `/api/EmployeeOnboarding/Documents/${documentId}/Attachments/${attachmentIndex}`,
      formData,options
    );
  }



export const getUpdateEmployeeOnboardingDocumentAttachmentMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateEmployeeOnboardingDocumentAttachment>>, TError,{documentId: number;attachmentIndex: number;data: UpdateEmployeeOnboardingDocumentAttachmentBody}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof updateEmployeeOnboardingDocumentAttachment>>, TError,{documentId: number;attachmentIndex: number;data: UpdateEmployeeOnboardingDocumentAttachmentBody}, TContext> => {
    
const mutationKey = ['updateEmployeeOnboardingDocumentAttachment'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateEmployeeOnboardingDocumentAttachment>>, {documentId: number;attachmentIndex: number;data: UpdateEmployeeOnboardingDocumentAttachmentBody}> = (props) => {
          const {documentId,attachmentIndex,data} = props ?? {};

          return  updateEmployeeOnboardingDocumentAttachment(documentId,attachmentIndex,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateEmployeeOnboardingDocumentAttachmentMutationResult = NonNullable<Awaited<ReturnType<typeof updateEmployeeOnboardingDocumentAttachment>>>
    export type UpdateEmployeeOnboardingDocumentAttachmentMutationBody = UpdateEmployeeOnboardingDocumentAttachmentBody
    export type UpdateEmployeeOnboardingDocumentAttachmentMutationError = AxiosError<unknown>

    /**
 * @summary Updates employee onboarding document attachment
 */
export const useUpdateEmployeeOnboardingDocumentAttachment = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateEmployeeOnboardingDocumentAttachment>>, TError,{documentId: number;attachmentIndex: number;data: UpdateEmployeeOnboardingDocumentAttachmentBody}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof updateEmployeeOnboardingDocumentAttachment>>,
        TError,
        {documentId: number;attachmentIndex: number;data: UpdateEmployeeOnboardingDocumentAttachmentBody},
        TContext
      > => {

      const mutationOptions = getUpdateEmployeeOnboardingDocumentAttachmentMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Gets employee onboarding field attachment
 */
export const getEmployeeFieldAttachment = (
    fieldId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Blob>> => {
    
    
    return axios.default.get(
      `/api/EmployeeOnboarding/Fields/${fieldId}/Attachment`,{
        responseType: 'blob',
    ...options,}
    );
  }


export const getGetEmployeeFieldAttachmentQueryKey = (fieldId: number,) => {
    return [`/api/EmployeeOnboarding/Fields/${fieldId}/Attachment`] as const;
    }

    
export const getGetEmployeeFieldAttachmentQueryOptions = <TData = Awaited<ReturnType<typeof getEmployeeFieldAttachment>>, TError = AxiosError<unknown>>(fieldId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeeFieldAttachment>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEmployeeFieldAttachmentQueryKey(fieldId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEmployeeFieldAttachment>>> = ({ signal }) => getEmployeeFieldAttachment(fieldId, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(fieldId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEmployeeFieldAttachment>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEmployeeFieldAttachmentQueryResult = NonNullable<Awaited<ReturnType<typeof getEmployeeFieldAttachment>>>
export type GetEmployeeFieldAttachmentQueryError = AxiosError<unknown>


export function useGetEmployeeFieldAttachment<TData = Awaited<ReturnType<typeof getEmployeeFieldAttachment>>, TError = AxiosError<unknown>>(
 fieldId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeeFieldAttachment>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmployeeFieldAttachment>>,
          TError,
          Awaited<ReturnType<typeof getEmployeeFieldAttachment>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmployeeFieldAttachment<TData = Awaited<ReturnType<typeof getEmployeeFieldAttachment>>, TError = AxiosError<unknown>>(
 fieldId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeeFieldAttachment>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmployeeFieldAttachment>>,
          TError,
          Awaited<ReturnType<typeof getEmployeeFieldAttachment>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmployeeFieldAttachment<TData = Awaited<ReturnType<typeof getEmployeeFieldAttachment>>, TError = AxiosError<unknown>>(
 fieldId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeeFieldAttachment>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Gets employee onboarding field attachment
 */

export function useGetEmployeeFieldAttachment<TData = Awaited<ReturnType<typeof getEmployeeFieldAttachment>>, TError = AxiosError<unknown>>(
 fieldId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeeFieldAttachment>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEmployeeFieldAttachmentQueryOptions(fieldId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Updates employee onboarding field attachment
 */
export const updateEmployeeFieldAttachment = (
    fieldId: number,
    updateEmployeeFieldAttachmentBody: UpdateEmployeeFieldAttachmentBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    const formData = createFormData(updateEmployeeFieldAttachmentBody)
    return axios.default.post(
      `/api/EmployeeOnboarding/Fields/${fieldId}/Attachment`,
      formData,options
    );
  }



export const getUpdateEmployeeFieldAttachmentMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateEmployeeFieldAttachment>>, TError,{fieldId: number;data: UpdateEmployeeFieldAttachmentBody}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof updateEmployeeFieldAttachment>>, TError,{fieldId: number;data: UpdateEmployeeFieldAttachmentBody}, TContext> => {
    
const mutationKey = ['updateEmployeeFieldAttachment'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateEmployeeFieldAttachment>>, {fieldId: number;data: UpdateEmployeeFieldAttachmentBody}> = (props) => {
          const {fieldId,data} = props ?? {};

          return  updateEmployeeFieldAttachment(fieldId,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateEmployeeFieldAttachmentMutationResult = NonNullable<Awaited<ReturnType<typeof updateEmployeeFieldAttachment>>>
    export type UpdateEmployeeFieldAttachmentMutationBody = UpdateEmployeeFieldAttachmentBody
    export type UpdateEmployeeFieldAttachmentMutationError = AxiosError<unknown>

    /**
 * @summary Updates employee onboarding field attachment
 */
export const useUpdateEmployeeFieldAttachment = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateEmployeeFieldAttachment>>, TError,{fieldId: number;data: UpdateEmployeeFieldAttachmentBody}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof updateEmployeeFieldAttachment>>,
        TError,
        {fieldId: number;data: UpdateEmployeeFieldAttachmentBody},
        TContext
      > => {

      const mutationOptions = getUpdateEmployeeFieldAttachmentMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Gets employee identification info
 */
export const getEmployeeIdentificationInfo = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<EmployeeIdentificationInfoSchema>> => {
    
    
    return axios.default.get(
      `/api/EmployeeOnboarding/IdentificationInfo`,options
    );
  }


export const getGetEmployeeIdentificationInfoQueryKey = () => {
    return [`/api/EmployeeOnboarding/IdentificationInfo`] as const;
    }

    
export const getGetEmployeeIdentificationInfoQueryOptions = <TData = Awaited<ReturnType<typeof getEmployeeIdentificationInfo>>, TError = AxiosError<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeeIdentificationInfo>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEmployeeIdentificationInfoQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEmployeeIdentificationInfo>>> = ({ signal }) => getEmployeeIdentificationInfo({ signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEmployeeIdentificationInfo>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEmployeeIdentificationInfoQueryResult = NonNullable<Awaited<ReturnType<typeof getEmployeeIdentificationInfo>>>
export type GetEmployeeIdentificationInfoQueryError = AxiosError<unknown>


export function useGetEmployeeIdentificationInfo<TData = Awaited<ReturnType<typeof getEmployeeIdentificationInfo>>, TError = AxiosError<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeeIdentificationInfo>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmployeeIdentificationInfo>>,
          TError,
          Awaited<ReturnType<typeof getEmployeeIdentificationInfo>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmployeeIdentificationInfo<TData = Awaited<ReturnType<typeof getEmployeeIdentificationInfo>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeeIdentificationInfo>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmployeeIdentificationInfo>>,
          TError,
          Awaited<ReturnType<typeof getEmployeeIdentificationInfo>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmployeeIdentificationInfo<TData = Awaited<ReturnType<typeof getEmployeeIdentificationInfo>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeeIdentificationInfo>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Gets employee identification info
 */

export function useGetEmployeeIdentificationInfo<TData = Awaited<ReturnType<typeof getEmployeeIdentificationInfo>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeeIdentificationInfo>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEmployeeIdentificationInfoQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Adds employee identification info
 */
export const addEmployeeIdentificationInfo = (
    addEmployeeIdentificationInfoBody: AddEmployeeIdentificationInfoBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    const formData = createFormData(addEmployeeIdentificationInfoBody)
    return axios.default.post(
      `/api/EmployeeOnboarding/IdentificationInfo`,
      formData,options
    );
  }



export const getAddEmployeeIdentificationInfoMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addEmployeeIdentificationInfo>>, TError,{data: AddEmployeeIdentificationInfoBody}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof addEmployeeIdentificationInfo>>, TError,{data: AddEmployeeIdentificationInfoBody}, TContext> => {
    
const mutationKey = ['addEmployeeIdentificationInfo'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addEmployeeIdentificationInfo>>, {data: AddEmployeeIdentificationInfoBody}> = (props) => {
          const {data} = props ?? {};

          return  addEmployeeIdentificationInfo(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AddEmployeeIdentificationInfoMutationResult = NonNullable<Awaited<ReturnType<typeof addEmployeeIdentificationInfo>>>
    export type AddEmployeeIdentificationInfoMutationBody = AddEmployeeIdentificationInfoBody
    export type AddEmployeeIdentificationInfoMutationError = AxiosError<unknown>

    /**
 * @summary Adds employee identification info
 */
export const useAddEmployeeIdentificationInfo = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addEmployeeIdentificationInfo>>, TError,{data: AddEmployeeIdentificationInfoBody}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof addEmployeeIdentificationInfo>>,
        TError,
        {data: AddEmployeeIdentificationInfoBody},
        TContext
      > => {

      const mutationOptions = getAddEmployeeIdentificationInfoMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Gets onboarding invite info
 */
export const getInviteInfo = (
    onboardingCode: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.default.get(
      `/api/EmployeeOnboarding/Invites/${onboardingCode}`,options
    );
  }


export const getGetInviteInfoQueryKey = (onboardingCode: string,) => {
    return [`/api/EmployeeOnboarding/Invites/${onboardingCode}`] as const;
    }

    
export const getGetInviteInfoQueryOptions = <TData = Awaited<ReturnType<typeof getInviteInfo>>, TError = AxiosError<unknown>>(onboardingCode: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInviteInfo>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInviteInfoQueryKey(onboardingCode);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInviteInfo>>> = ({ signal }) => getInviteInfo(onboardingCode, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(onboardingCode), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInviteInfo>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetInviteInfoQueryResult = NonNullable<Awaited<ReturnType<typeof getInviteInfo>>>
export type GetInviteInfoQueryError = AxiosError<unknown>


export function useGetInviteInfo<TData = Awaited<ReturnType<typeof getInviteInfo>>, TError = AxiosError<unknown>>(
 onboardingCode: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInviteInfo>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInviteInfo>>,
          TError,
          Awaited<ReturnType<typeof getInviteInfo>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInviteInfo<TData = Awaited<ReturnType<typeof getInviteInfo>>, TError = AxiosError<unknown>>(
 onboardingCode: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInviteInfo>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInviteInfo>>,
          TError,
          Awaited<ReturnType<typeof getInviteInfo>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInviteInfo<TData = Awaited<ReturnType<typeof getInviteInfo>>, TError = AxiosError<unknown>>(
 onboardingCode: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInviteInfo>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Gets onboarding invite info
 */

export function useGetInviteInfo<TData = Awaited<ReturnType<typeof getInviteInfo>>, TError = AxiosError<unknown>>(
 onboardingCode: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInviteInfo>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetInviteInfoQueryOptions(onboardingCode,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Opens onboarding invite
 */
export const updateInviteOpened = (
    onboardingCode: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.default.put(
      `/api/EmployeeOnboarding/Invites/${onboardingCode}`,undefined,options
    );
  }



export const getUpdateInviteOpenedMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateInviteOpened>>, TError,{onboardingCode: string}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof updateInviteOpened>>, TError,{onboardingCode: string}, TContext> => {
    
const mutationKey = ['updateInviteOpened'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateInviteOpened>>, {onboardingCode: string}> = (props) => {
          const {onboardingCode} = props ?? {};

          return  updateInviteOpened(onboardingCode,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateInviteOpenedMutationResult = NonNullable<Awaited<ReturnType<typeof updateInviteOpened>>>
    
    export type UpdateInviteOpenedMutationError = AxiosError<unknown>

    /**
 * @summary Opens onboarding invite
 */
export const useUpdateInviteOpened = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateInviteOpened>>, TError,{onboardingCode: string}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof updateInviteOpened>>,
        TError,
        {onboardingCode: string},
        TContext
      > => {

      const mutationOptions = getUpdateInviteOpenedMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Gets states
 */
export const getEmployeeStates = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.default.get(
      `/api/EmployeeOnboarding/States`,options
    );
  }


export const getGetEmployeeStatesQueryKey = () => {
    return [`/api/EmployeeOnboarding/States`] as const;
    }

    
export const getGetEmployeeStatesQueryOptions = <TData = Awaited<ReturnType<typeof getEmployeeStates>>, TError = AxiosError<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeeStates>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEmployeeStatesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEmployeeStates>>> = ({ signal }) => getEmployeeStates({ signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEmployeeStates>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEmployeeStatesQueryResult = NonNullable<Awaited<ReturnType<typeof getEmployeeStates>>>
export type GetEmployeeStatesQueryError = AxiosError<unknown>


export function useGetEmployeeStates<TData = Awaited<ReturnType<typeof getEmployeeStates>>, TError = AxiosError<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeeStates>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmployeeStates>>,
          TError,
          Awaited<ReturnType<typeof getEmployeeStates>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmployeeStates<TData = Awaited<ReturnType<typeof getEmployeeStates>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeeStates>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmployeeStates>>,
          TError,
          Awaited<ReturnType<typeof getEmployeeStates>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmployeeStates<TData = Awaited<ReturnType<typeof getEmployeeStates>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeeStates>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Gets states
 */

export function useGetEmployeeStates<TData = Awaited<ReturnType<typeof getEmployeeStates>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeeStates>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEmployeeStatesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Gets employee onboarding status
 */
export const getOnboardingStatus = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<EmployeeOnboardingStatusSchema>> => {
    
    
    return axios.default.get(
      `/api/EmployeeOnboarding/Status`,options
    );
  }


export const getGetOnboardingStatusQueryKey = () => {
    return [`/api/EmployeeOnboarding/Status`] as const;
    }

    
export const getGetOnboardingStatusQueryOptions = <TData = Awaited<ReturnType<typeof getOnboardingStatus>>, TError = AxiosError<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOnboardingStatus>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOnboardingStatusQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOnboardingStatus>>> = ({ signal }) => getOnboardingStatus({ signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOnboardingStatus>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOnboardingStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getOnboardingStatus>>>
export type GetOnboardingStatusQueryError = AxiosError<unknown>


export function useGetOnboardingStatus<TData = Awaited<ReturnType<typeof getOnboardingStatus>>, TError = AxiosError<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOnboardingStatus>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOnboardingStatus>>,
          TError,
          Awaited<ReturnType<typeof getOnboardingStatus>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOnboardingStatus<TData = Awaited<ReturnType<typeof getOnboardingStatus>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOnboardingStatus>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOnboardingStatus>>,
          TError,
          Awaited<ReturnType<typeof getOnboardingStatus>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOnboardingStatus<TData = Awaited<ReturnType<typeof getOnboardingStatus>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOnboardingStatus>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Gets employee onboarding status
 */

export function useGetOnboardingStatus<TData = Awaited<ReturnType<typeof getOnboardingStatus>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOnboardingStatus>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOnboardingStatusQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Gets employee onboarding step details
 */
export const getEmployeeOnboardingStepDetails = (
    id: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<EmployeeOnboardingStepDetailsSchema>> => {
    
    
    return axios.default.get(
      `/api/EmployeeOnboarding/Steps/${id}`,options
    );
  }


export const getGetEmployeeOnboardingStepDetailsQueryKey = (id: number,) => {
    return [`/api/EmployeeOnboarding/Steps/${id}`] as const;
    }

    
export const getGetEmployeeOnboardingStepDetailsQueryOptions = <TData = Awaited<ReturnType<typeof getEmployeeOnboardingStepDetails>>, TError = AxiosError<unknown>>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeeOnboardingStepDetails>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEmployeeOnboardingStepDetailsQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEmployeeOnboardingStepDetails>>> = ({ signal }) => getEmployeeOnboardingStepDetails(id, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEmployeeOnboardingStepDetails>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEmployeeOnboardingStepDetailsQueryResult = NonNullable<Awaited<ReturnType<typeof getEmployeeOnboardingStepDetails>>>
export type GetEmployeeOnboardingStepDetailsQueryError = AxiosError<unknown>


export function useGetEmployeeOnboardingStepDetails<TData = Awaited<ReturnType<typeof getEmployeeOnboardingStepDetails>>, TError = AxiosError<unknown>>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeeOnboardingStepDetails>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmployeeOnboardingStepDetails>>,
          TError,
          Awaited<ReturnType<typeof getEmployeeOnboardingStepDetails>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmployeeOnboardingStepDetails<TData = Awaited<ReturnType<typeof getEmployeeOnboardingStepDetails>>, TError = AxiosError<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeeOnboardingStepDetails>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmployeeOnboardingStepDetails>>,
          TError,
          Awaited<ReturnType<typeof getEmployeeOnboardingStepDetails>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmployeeOnboardingStepDetails<TData = Awaited<ReturnType<typeof getEmployeeOnboardingStepDetails>>, TError = AxiosError<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeeOnboardingStepDetails>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Gets employee onboarding step details
 */

export function useGetEmployeeOnboardingStepDetails<TData = Awaited<ReturnType<typeof getEmployeeOnboardingStepDetails>>, TError = AxiosError<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeeOnboardingStepDetails>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEmployeeOnboardingStepDetailsQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Updates employee onboarding step details
 */
export const updateEmployeeOnboardingStepDetails = (
    id: number,
    updateOnboardingStepDetailsSchema: UpdateOnboardingStepDetailsSchema, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<EmployeeOnboardingStepDetailsSchema>> => {
    
    
    return axios.default.post(
      `/api/EmployeeOnboarding/Steps/${id}`,
      updateOnboardingStepDetailsSchema,options
    );
  }



export const getUpdateEmployeeOnboardingStepDetailsMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateEmployeeOnboardingStepDetails>>, TError,{id: number;data: UpdateOnboardingStepDetailsSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof updateEmployeeOnboardingStepDetails>>, TError,{id: number;data: UpdateOnboardingStepDetailsSchema}, TContext> => {
    
const mutationKey = ['updateEmployeeOnboardingStepDetails'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateEmployeeOnboardingStepDetails>>, {id: number;data: UpdateOnboardingStepDetailsSchema}> = (props) => {
          const {id,data} = props ?? {};

          return  updateEmployeeOnboardingStepDetails(id,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateEmployeeOnboardingStepDetailsMutationResult = NonNullable<Awaited<ReturnType<typeof updateEmployeeOnboardingStepDetails>>>
    export type UpdateEmployeeOnboardingStepDetailsMutationBody = UpdateOnboardingStepDetailsSchema
    export type UpdateEmployeeOnboardingStepDetailsMutationError = AxiosError<unknown>

    /**
 * @summary Updates employee onboarding step details
 */
export const useUpdateEmployeeOnboardingStepDetails = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateEmployeeOnboardingStepDetails>>, TError,{id: number;data: UpdateOnboardingStepDetailsSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof updateEmployeeOnboardingStepDetails>>,
        TError,
        {id: number;data: UpdateOnboardingStepDetailsSchema},
        TContext
      > => {

      const mutationOptions = getUpdateEmployeeOnboardingStepDetailsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Marks a custom (non-predefined) step as complete by evaluating its saved field values
 */
export const completeEmployeeOnboardingStep = (
    id: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.default.post(
      `/api/EmployeeOnboarding/Steps/${id}/Complete`,undefined,options
    );
  }



export const getCompleteEmployeeOnboardingStepMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof completeEmployeeOnboardingStep>>, TError,{id: number}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof completeEmployeeOnboardingStep>>, TError,{id: number}, TContext> => {
    
const mutationKey = ['completeEmployeeOnboardingStep'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof completeEmployeeOnboardingStep>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  completeEmployeeOnboardingStep(id,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CompleteEmployeeOnboardingStepMutationResult = NonNullable<Awaited<ReturnType<typeof completeEmployeeOnboardingStep>>>
    
    export type CompleteEmployeeOnboardingStepMutationError = AxiosError<unknown>

    /**
 * @summary Marks a custom (non-predefined) step as complete by evaluating its saved field values
 */
export const useCompleteEmployeeOnboardingStep = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof completeEmployeeOnboardingStep>>, TError,{id: number}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof completeEmployeeOnboardingStep>>,
        TError,
        {id: number},
        TContext
      > => {

      const mutationOptions = getCompleteEmployeeOnboardingStepMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Reopens a completed custom (non-predefined) step
 */
export const reopenEmployeeOnboardingStep = (
    id: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.default.post(
      `/api/EmployeeOnboarding/Steps/${id}/Reopen`,undefined,options
    );
  }



export const getReopenEmployeeOnboardingStepMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reopenEmployeeOnboardingStep>>, TError,{id: number}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof reopenEmployeeOnboardingStep>>, TError,{id: number}, TContext> => {
    
const mutationKey = ['reopenEmployeeOnboardingStep'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reopenEmployeeOnboardingStep>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  reopenEmployeeOnboardingStep(id,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ReopenEmployeeOnboardingStepMutationResult = NonNullable<Awaited<ReturnType<typeof reopenEmployeeOnboardingStep>>>
    
    export type ReopenEmployeeOnboardingStepMutationError = AxiosError<unknown>

    /**
 * @summary Reopens a completed custom (non-predefined) step
 */
export const useReopenEmployeeOnboardingStep = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reopenEmployeeOnboardingStep>>, TError,{id: number}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof reopenEmployeeOnboardingStep>>,
        TError,
        {id: number},
        TContext
      > => {

      const mutationOptions = getReopenEmployeeOnboardingStepMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Marks a step as started (In Progress) without evaluating completion
 */
export const startEmployeeOnboardingStep = (
    id: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.default.post(
      `/api/EmployeeOnboarding/Steps/${id}/Start`,undefined,options
    );
  }



export const getStartEmployeeOnboardingStepMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startEmployeeOnboardingStep>>, TError,{id: number}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof startEmployeeOnboardingStep>>, TError,{id: number}, TContext> => {
    
const mutationKey = ['startEmployeeOnboardingStep'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof startEmployeeOnboardingStep>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  startEmployeeOnboardingStep(id,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type StartEmployeeOnboardingStepMutationResult = NonNullable<Awaited<ReturnType<typeof startEmployeeOnboardingStep>>>
    
    export type StartEmployeeOnboardingStepMutationError = AxiosError<unknown>

    /**
 * @summary Marks a step as started (In Progress) without evaluating completion
 */
export const useStartEmployeeOnboardingStep = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startEmployeeOnboardingStep>>, TError,{id: number}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof startEmployeeOnboardingStep>>,
        TError,
        {id: number},
        TContext
      > => {

      const mutationOptions = getStartEmployeeOnboardingStepMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Marks a predefined/system step as complete by evaluating the employee's current data
 */
export const completeEmployeeOnboardingSystemStep = (
    params?: CompleteEmployeeOnboardingSystemStepParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.default.post(
      `/api/EmployeeOnboarding/Steps/System/Complete`,undefined,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getCompleteEmployeeOnboardingSystemStepMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof completeEmployeeOnboardingSystemStep>>, TError,{params?: CompleteEmployeeOnboardingSystemStepParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof completeEmployeeOnboardingSystemStep>>, TError,{params?: CompleteEmployeeOnboardingSystemStepParams}, TContext> => {
    
const mutationKey = ['completeEmployeeOnboardingSystemStep'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof completeEmployeeOnboardingSystemStep>>, {params?: CompleteEmployeeOnboardingSystemStepParams}> = (props) => {
          const {params} = props ?? {};

          return  completeEmployeeOnboardingSystemStep(params,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CompleteEmployeeOnboardingSystemStepMutationResult = NonNullable<Awaited<ReturnType<typeof completeEmployeeOnboardingSystemStep>>>
    
    export type CompleteEmployeeOnboardingSystemStepMutationError = AxiosError<unknown>

    /**
 * @summary Marks a predefined/system step as complete by evaluating the employee's current data
 */
export const useCompleteEmployeeOnboardingSystemStep = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof completeEmployeeOnboardingSystemStep>>, TError,{params?: CompleteEmployeeOnboardingSystemStepParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof completeEmployeeOnboardingSystemStep>>,
        TError,
        {params?: CompleteEmployeeOnboardingSystemStepParams},
        TContext
      > => {

      const mutationOptions = getCompleteEmployeeOnboardingSystemStepMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Reopens a predefined/system step, clearing completion status and associated flags
 */
export const reopenEmployeeOnboardingSystemStep = (
    params?: ReopenEmployeeOnboardingSystemStepParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.default.post(
      `/api/EmployeeOnboarding/Steps/System/Reopen`,undefined,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getReopenEmployeeOnboardingSystemStepMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reopenEmployeeOnboardingSystemStep>>, TError,{params?: ReopenEmployeeOnboardingSystemStepParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof reopenEmployeeOnboardingSystemStep>>, TError,{params?: ReopenEmployeeOnboardingSystemStepParams}, TContext> => {
    
const mutationKey = ['reopenEmployeeOnboardingSystemStep'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reopenEmployeeOnboardingSystemStep>>, {params?: ReopenEmployeeOnboardingSystemStepParams}> = (props) => {
          const {params} = props ?? {};

          return  reopenEmployeeOnboardingSystemStep(params,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ReopenEmployeeOnboardingSystemStepMutationResult = NonNullable<Awaited<ReturnType<typeof reopenEmployeeOnboardingSystemStep>>>
    
    export type ReopenEmployeeOnboardingSystemStepMutationError = AxiosError<unknown>

    /**
 * @summary Reopens a predefined/system step, clearing completion status and associated flags
 */
export const useReopenEmployeeOnboardingSystemStep = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reopenEmployeeOnboardingSystemStep>>, TError,{params?: ReopenEmployeeOnboardingSystemStepParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof reopenEmployeeOnboardingSystemStep>>,
        TError,
        {params?: ReopenEmployeeOnboardingSystemStepParams},
        TContext
      > => {

      const mutationOptions = getReopenEmployeeOnboardingSystemStepMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Gets the welcome screen for the employee
 */
export const getWelcomeScreen = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<EmployeeWelcomeScreenSchema | void>> => {
    
    
    return axios.default.get(
      `/api/EmployeeOnboarding/WelcomeScreen`,options
    );
  }


export const getGetWelcomeScreenQueryKey = () => {
    return [`/api/EmployeeOnboarding/WelcomeScreen`] as const;
    }

    
export const getGetWelcomeScreenQueryOptions = <TData = Awaited<ReturnType<typeof getWelcomeScreen>>, TError = AxiosError<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWelcomeScreen>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWelcomeScreenQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWelcomeScreen>>> = ({ signal }) => getWelcomeScreen({ signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getWelcomeScreen>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetWelcomeScreenQueryResult = NonNullable<Awaited<ReturnType<typeof getWelcomeScreen>>>
export type GetWelcomeScreenQueryError = AxiosError<unknown>


export function useGetWelcomeScreen<TData = Awaited<ReturnType<typeof getWelcomeScreen>>, TError = AxiosError<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWelcomeScreen>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWelcomeScreen>>,
          TError,
          Awaited<ReturnType<typeof getWelcomeScreen>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWelcomeScreen<TData = Awaited<ReturnType<typeof getWelcomeScreen>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWelcomeScreen>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWelcomeScreen>>,
          TError,
          Awaited<ReturnType<typeof getWelcomeScreen>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWelcomeScreen<TData = Awaited<ReturnType<typeof getWelcomeScreen>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWelcomeScreen>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Gets the welcome screen for the employee
 */

export function useGetWelcomeScreen<TData = Awaited<ReturnType<typeof getWelcomeScreen>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWelcomeScreen>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetWelcomeScreenQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Gets the welcome screen logo image
 */
export const getWelcomeScreenLogo = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.default.get(
      `/api/EmployeeOnboarding/WelcomeScreen/Logo`,options
    );
  }


export const getGetWelcomeScreenLogoQueryKey = () => {
    return [`/api/EmployeeOnboarding/WelcomeScreen/Logo`] as const;
    }

    
export const getGetWelcomeScreenLogoQueryOptions = <TData = Awaited<ReturnType<typeof getWelcomeScreenLogo>>, TError = AxiosError<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWelcomeScreenLogo>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWelcomeScreenLogoQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWelcomeScreenLogo>>> = ({ signal }) => getWelcomeScreenLogo({ signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getWelcomeScreenLogo>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetWelcomeScreenLogoQueryResult = NonNullable<Awaited<ReturnType<typeof getWelcomeScreenLogo>>>
export type GetWelcomeScreenLogoQueryError = AxiosError<unknown>


export function useGetWelcomeScreenLogo<TData = Awaited<ReturnType<typeof getWelcomeScreenLogo>>, TError = AxiosError<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWelcomeScreenLogo>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWelcomeScreenLogo>>,
          TError,
          Awaited<ReturnType<typeof getWelcomeScreenLogo>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWelcomeScreenLogo<TData = Awaited<ReturnType<typeof getWelcomeScreenLogo>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWelcomeScreenLogo>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWelcomeScreenLogo>>,
          TError,
          Awaited<ReturnType<typeof getWelcomeScreenLogo>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWelcomeScreenLogo<TData = Awaited<ReturnType<typeof getWelcomeScreenLogo>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWelcomeScreenLogo>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Gets the welcome screen logo image
 */

export function useGetWelcomeScreenLogo<TData = Awaited<ReturnType<typeof getWelcomeScreenLogo>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWelcomeScreenLogo>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetWelcomeScreenLogoQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Gets onboarding employees filtered by statuses.
Defaults to active statuses (Pending, Submitted, UnderReview, ReadyToActivate, Activated) when no statuses are specified.
 */
export const getOnboardingEmployees = (
    params?: GetOnboardingEmployeesParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<OnboardingEmployeeSchema[]>> => {
    
    
    return axios.default.get(
      `/api/EmployeeOnboardingManager/Employees`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getGetOnboardingEmployeesQueryKey = (params?: GetOnboardingEmployeesParams,) => {
    return [`/api/EmployeeOnboardingManager/Employees`, ...(params ? [params]: [])] as const;
    }

    
export const getGetOnboardingEmployeesQueryOptions = <TData = Awaited<ReturnType<typeof getOnboardingEmployees>>, TError = AxiosError<unknown>>(params?: GetOnboardingEmployeesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOnboardingEmployees>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOnboardingEmployeesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOnboardingEmployees>>> = ({ signal }) => getOnboardingEmployees(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOnboardingEmployees>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOnboardingEmployeesQueryResult = NonNullable<Awaited<ReturnType<typeof getOnboardingEmployees>>>
export type GetOnboardingEmployeesQueryError = AxiosError<unknown>


export function useGetOnboardingEmployees<TData = Awaited<ReturnType<typeof getOnboardingEmployees>>, TError = AxiosError<unknown>>(
 params: undefined |  GetOnboardingEmployeesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOnboardingEmployees>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOnboardingEmployees>>,
          TError,
          Awaited<ReturnType<typeof getOnboardingEmployees>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOnboardingEmployees<TData = Awaited<ReturnType<typeof getOnboardingEmployees>>, TError = AxiosError<unknown>>(
 params?: GetOnboardingEmployeesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOnboardingEmployees>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOnboardingEmployees>>,
          TError,
          Awaited<ReturnType<typeof getOnboardingEmployees>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOnboardingEmployees<TData = Awaited<ReturnType<typeof getOnboardingEmployees>>, TError = AxiosError<unknown>>(
 params?: GetOnboardingEmployeesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOnboardingEmployees>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Gets onboarding employees filtered by statuses.
Defaults to active statuses (Pending, Submitted, UnderReview, ReadyToActivate, Activated) when no statuses are specified.
 */

export function useGetOnboardingEmployees<TData = Awaited<ReturnType<typeof getOnboardingEmployees>>, TError = AxiosError<unknown>>(
 params?: GetOnboardingEmployeesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOnboardingEmployees>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOnboardingEmployeesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Adds new onboarding employee
 */
export const addOnboardingEmployee = (
    addOnboardingEmployeeSchema: AddOnboardingEmployeeSchema, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<AddOnboardingEmployeeResponseSchema>> => {
    
    
    return axios.default.post(
      `/api/EmployeeOnboardingManager/Employees`,
      addOnboardingEmployeeSchema,options
    );
  }



export const getAddOnboardingEmployeeMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addOnboardingEmployee>>, TError,{data: AddOnboardingEmployeeSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof addOnboardingEmployee>>, TError,{data: AddOnboardingEmployeeSchema}, TContext> => {
    
const mutationKey = ['addOnboardingEmployee'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addOnboardingEmployee>>, {data: AddOnboardingEmployeeSchema}> = (props) => {
          const {data} = props ?? {};

          return  addOnboardingEmployee(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AddOnboardingEmployeeMutationResult = NonNullable<Awaited<ReturnType<typeof addOnboardingEmployee>>>
    export type AddOnboardingEmployeeMutationBody = AddOnboardingEmployeeSchema
    export type AddOnboardingEmployeeMutationError = AxiosError<unknown>

    /**
 * @summary Adds new onboarding employee
 */
export const useAddOnboardingEmployee = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addOnboardingEmployee>>, TError,{data: AddOnboardingEmployeeSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof addOnboardingEmployee>>,
        TError,
        {data: AddOnboardingEmployeeSchema},
        TContext
      > => {

      const mutationOptions = getAddOnboardingEmployeeMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Gets employer onboarding document template for employee
 */
export const getEmployerDocumentTemplate = (
    employeeNumber: number,
    templateId: number,
    versionId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<EmployeeOnboardingDocumentTemplateSchema>> => {
    
    
    return axios.default.get(
      `/api/EmployeeOnboardingManager/Employees/${employeeNumber}/CustomTemplates/${templateId}/Versions/${versionId}`,options
    );
  }


export const getGetEmployerDocumentTemplateQueryKey = (employeeNumber: number,
    templateId: number,
    versionId: number,) => {
    return [`/api/EmployeeOnboardingManager/Employees/${employeeNumber}/CustomTemplates/${templateId}/Versions/${versionId}`] as const;
    }

    
export const getGetEmployerDocumentTemplateQueryOptions = <TData = Awaited<ReturnType<typeof getEmployerDocumentTemplate>>, TError = AxiosError<unknown>>(employeeNumber: number,
    templateId: number,
    versionId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployerDocumentTemplate>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEmployerDocumentTemplateQueryKey(employeeNumber,templateId,versionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEmployerDocumentTemplate>>> = ({ signal }) => getEmployerDocumentTemplate(employeeNumber,templateId,versionId, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(employeeNumber && templateId && versionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEmployerDocumentTemplate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEmployerDocumentTemplateQueryResult = NonNullable<Awaited<ReturnType<typeof getEmployerDocumentTemplate>>>
export type GetEmployerDocumentTemplateQueryError = AxiosError<unknown>


export function useGetEmployerDocumentTemplate<TData = Awaited<ReturnType<typeof getEmployerDocumentTemplate>>, TError = AxiosError<unknown>>(
 employeeNumber: number,
    templateId: number,
    versionId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployerDocumentTemplate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmployerDocumentTemplate>>,
          TError,
          Awaited<ReturnType<typeof getEmployerDocumentTemplate>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmployerDocumentTemplate<TData = Awaited<ReturnType<typeof getEmployerDocumentTemplate>>, TError = AxiosError<unknown>>(
 employeeNumber: number,
    templateId: number,
    versionId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployerDocumentTemplate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmployerDocumentTemplate>>,
          TError,
          Awaited<ReturnType<typeof getEmployerDocumentTemplate>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmployerDocumentTemplate<TData = Awaited<ReturnType<typeof getEmployerDocumentTemplate>>, TError = AxiosError<unknown>>(
 employeeNumber: number,
    templateId: number,
    versionId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployerDocumentTemplate>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Gets employer onboarding document template for employee
 */

export function useGetEmployerDocumentTemplate<TData = Awaited<ReturnType<typeof getEmployerDocumentTemplate>>, TError = AxiosError<unknown>>(
 employeeNumber: number,
    templateId: number,
    versionId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployerDocumentTemplate>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEmployerDocumentTemplateQueryOptions(employeeNumber,templateId,versionId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Submits employer onboarding document template for employee
 */
export const submitEmployerDocumentTemplate = (
    employeeNumber: number,
    templateId: number,
    versionId: number,
    submitOnboardingCustomTemplateSchema: SubmitOnboardingCustomTemplateSchema, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.default.post(
      `/api/EmployeeOnboardingManager/Employees/${employeeNumber}/CustomTemplates/${templateId}/Versions/${versionId}`,
      submitOnboardingCustomTemplateSchema,options
    );
  }



export const getSubmitEmployerDocumentTemplateMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitEmployerDocumentTemplate>>, TError,{employeeNumber: number;templateId: number;versionId: number;data: SubmitOnboardingCustomTemplateSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof submitEmployerDocumentTemplate>>, TError,{employeeNumber: number;templateId: number;versionId: number;data: SubmitOnboardingCustomTemplateSchema}, TContext> => {
    
const mutationKey = ['submitEmployerDocumentTemplate'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof submitEmployerDocumentTemplate>>, {employeeNumber: number;templateId: number;versionId: number;data: SubmitOnboardingCustomTemplateSchema}> = (props) => {
          const {employeeNumber,templateId,versionId,data} = props ?? {};

          return  submitEmployerDocumentTemplate(employeeNumber,templateId,versionId,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SubmitEmployerDocumentTemplateMutationResult = NonNullable<Awaited<ReturnType<typeof submitEmployerDocumentTemplate>>>
    export type SubmitEmployerDocumentTemplateMutationBody = SubmitOnboardingCustomTemplateSchema
    export type SubmitEmployerDocumentTemplateMutationError = AxiosError<unknown>

    /**
 * @summary Submits employer onboarding document template for employee
 */
export const useSubmitEmployerDocumentTemplate = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitEmployerDocumentTemplate>>, TError,{employeeNumber: number;templateId: number;versionId: number;data: SubmitOnboardingCustomTemplateSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof submitEmployerDocumentTemplate>>,
        TError,
        {employeeNumber: number;templateId: number;versionId: number;data: SubmitOnboardingCustomTemplateSchema},
        TContext
      > => {

      const mutationOptions = getSubmitEmployerDocumentTemplateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Gets employer onboarding document for employee
 */
export const getEmployerDocumentAttachment = (
    employeeNumber: number,
    documentId: number,
    versionId: number,
    params?: GetEmployerDocumentAttachmentParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Blob>> => {
    
    
    return axios.default.get(
      `/api/EmployeeOnboardingManager/Employees/${employeeNumber}/Documents/${documentId}/Versions/${versionId}`,{
        responseType: 'blob',
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getGetEmployerDocumentAttachmentQueryKey = (employeeNumber: number,
    documentId: number,
    versionId: number,
    params?: GetEmployerDocumentAttachmentParams,) => {
    return [`/api/EmployeeOnboardingManager/Employees/${employeeNumber}/Documents/${documentId}/Versions/${versionId}`, ...(params ? [params]: [])] as const;
    }

    
export const getGetEmployerDocumentAttachmentQueryOptions = <TData = Awaited<ReturnType<typeof getEmployerDocumentAttachment>>, TError = AxiosError<unknown>>(employeeNumber: number,
    documentId: number,
    versionId: number,
    params?: GetEmployerDocumentAttachmentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployerDocumentAttachment>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEmployerDocumentAttachmentQueryKey(employeeNumber,documentId,versionId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEmployerDocumentAttachment>>> = ({ signal }) => getEmployerDocumentAttachment(employeeNumber,documentId,versionId,params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(employeeNumber && documentId && versionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEmployerDocumentAttachment>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEmployerDocumentAttachmentQueryResult = NonNullable<Awaited<ReturnType<typeof getEmployerDocumentAttachment>>>
export type GetEmployerDocumentAttachmentQueryError = AxiosError<unknown>


export function useGetEmployerDocumentAttachment<TData = Awaited<ReturnType<typeof getEmployerDocumentAttachment>>, TError = AxiosError<unknown>>(
 employeeNumber: number,
    documentId: number,
    versionId: number,
    params: undefined |  GetEmployerDocumentAttachmentParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployerDocumentAttachment>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmployerDocumentAttachment>>,
          TError,
          Awaited<ReturnType<typeof getEmployerDocumentAttachment>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmployerDocumentAttachment<TData = Awaited<ReturnType<typeof getEmployerDocumentAttachment>>, TError = AxiosError<unknown>>(
 employeeNumber: number,
    documentId: number,
    versionId: number,
    params?: GetEmployerDocumentAttachmentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployerDocumentAttachment>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmployerDocumentAttachment>>,
          TError,
          Awaited<ReturnType<typeof getEmployerDocumentAttachment>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmployerDocumentAttachment<TData = Awaited<ReturnType<typeof getEmployerDocumentAttachment>>, TError = AxiosError<unknown>>(
 employeeNumber: number,
    documentId: number,
    versionId: number,
    params?: GetEmployerDocumentAttachmentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployerDocumentAttachment>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Gets employer onboarding document for employee
 */

export function useGetEmployerDocumentAttachment<TData = Awaited<ReturnType<typeof getEmployerDocumentAttachment>>, TError = AxiosError<unknown>>(
 employeeNumber: number,
    documentId: number,
    versionId: number,
    params?: GetEmployerDocumentAttachmentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployerDocumentAttachment>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEmployerDocumentAttachmentQueryOptions(employeeNumber,documentId,versionId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Updates employer onboarding document attachment for employee
 */
export const updateEmployerDocumentAttachment = (
    employeeNumber: number,
    documentId: number,
    versionId: number,
    attachmentIndex: number,
    updateEmployerDocumentAttachmentBody: UpdateEmployerDocumentAttachmentBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    const formData = createFormData(updateEmployerDocumentAttachmentBody)
    return axios.default.put(
      `/api/EmployeeOnboardingManager/Employees/${employeeNumber}/Documents/${documentId}/Versions/${versionId}/Attachments/${attachmentIndex}`,
      formData,options
    );
  }



export const getUpdateEmployerDocumentAttachmentMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateEmployerDocumentAttachment>>, TError,{employeeNumber: number;documentId: number;versionId: number;attachmentIndex: number;data: UpdateEmployerDocumentAttachmentBody}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof updateEmployerDocumentAttachment>>, TError,{employeeNumber: number;documentId: number;versionId: number;attachmentIndex: number;data: UpdateEmployerDocumentAttachmentBody}, TContext> => {
    
const mutationKey = ['updateEmployerDocumentAttachment'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateEmployerDocumentAttachment>>, {employeeNumber: number;documentId: number;versionId: number;attachmentIndex: number;data: UpdateEmployerDocumentAttachmentBody}> = (props) => {
          const {employeeNumber,documentId,versionId,attachmentIndex,data} = props ?? {};

          return  updateEmployerDocumentAttachment(employeeNumber,documentId,versionId,attachmentIndex,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateEmployerDocumentAttachmentMutationResult = NonNullable<Awaited<ReturnType<typeof updateEmployerDocumentAttachment>>>
    export type UpdateEmployerDocumentAttachmentMutationBody = UpdateEmployerDocumentAttachmentBody
    export type UpdateEmployerDocumentAttachmentMutationError = AxiosError<unknown>

    /**
 * @summary Updates employer onboarding document attachment for employee
 */
export const useUpdateEmployerDocumentAttachment = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateEmployerDocumentAttachment>>, TError,{employeeNumber: number;documentId: number;versionId: number;attachmentIndex: number;data: UpdateEmployerDocumentAttachmentBody}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof updateEmployerDocumentAttachment>>,
        TError,
        {employeeNumber: number;documentId: number;versionId: number;attachmentIndex: number;data: UpdateEmployerDocumentAttachmentBody},
        TContext
      > => {

      const mutationOptions = getUpdateEmployerDocumentAttachmentMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Gets employer onboarding step details by ID
 */
export const getEmployerOnboardingStepDetails = (
    employeeNumber: number,
    id: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<EmployeeOnboardingStepDetailsSchema>> => {
    
    
    return axios.default.get(
      `/api/EmployeeOnboardingManager/Employees/${employeeNumber}/EmployerSteps/${id}`,options
    );
  }


export const getGetEmployerOnboardingStepDetailsQueryKey = (employeeNumber: number,
    id: number,) => {
    return [`/api/EmployeeOnboardingManager/Employees/${employeeNumber}/EmployerSteps/${id}`] as const;
    }

    
export const getGetEmployerOnboardingStepDetailsQueryOptions = <TData = Awaited<ReturnType<typeof getEmployerOnboardingStepDetails>>, TError = AxiosError<unknown>>(employeeNumber: number,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployerOnboardingStepDetails>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEmployerOnboardingStepDetailsQueryKey(employeeNumber,id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEmployerOnboardingStepDetails>>> = ({ signal }) => getEmployerOnboardingStepDetails(employeeNumber,id, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(employeeNumber && id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEmployerOnboardingStepDetails>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEmployerOnboardingStepDetailsQueryResult = NonNullable<Awaited<ReturnType<typeof getEmployerOnboardingStepDetails>>>
export type GetEmployerOnboardingStepDetailsQueryError = AxiosError<unknown>


export function useGetEmployerOnboardingStepDetails<TData = Awaited<ReturnType<typeof getEmployerOnboardingStepDetails>>, TError = AxiosError<unknown>>(
 employeeNumber: number,
    id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployerOnboardingStepDetails>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmployerOnboardingStepDetails>>,
          TError,
          Awaited<ReturnType<typeof getEmployerOnboardingStepDetails>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmployerOnboardingStepDetails<TData = Awaited<ReturnType<typeof getEmployerOnboardingStepDetails>>, TError = AxiosError<unknown>>(
 employeeNumber: number,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployerOnboardingStepDetails>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmployerOnboardingStepDetails>>,
          TError,
          Awaited<ReturnType<typeof getEmployerOnboardingStepDetails>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmployerOnboardingStepDetails<TData = Awaited<ReturnType<typeof getEmployerOnboardingStepDetails>>, TError = AxiosError<unknown>>(
 employeeNumber: number,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployerOnboardingStepDetails>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Gets employer onboarding step details by ID
 */

export function useGetEmployerOnboardingStepDetails<TData = Awaited<ReturnType<typeof getEmployerOnboardingStepDetails>>, TError = AxiosError<unknown>>(
 employeeNumber: number,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployerOnboardingStepDetails>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEmployerOnboardingStepDetailsQueryOptions(employeeNumber,id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Updates employer onboarding step details
 */
export const updateEmployerOnboardingStepDetails = (
    employeeNumber: number,
    id: number,
    updateOnboardingStepDetailsSchema: UpdateOnboardingStepDetailsSchema, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<EmployeeOnboardingStepDetailsSchema>> => {
    
    
    return axios.default.post(
      `/api/EmployeeOnboardingManager/Employees/${employeeNumber}/EmployerSteps/${id}`,
      updateOnboardingStepDetailsSchema,options
    );
  }



export const getUpdateEmployerOnboardingStepDetailsMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateEmployerOnboardingStepDetails>>, TError,{employeeNumber: number;id: number;data: UpdateOnboardingStepDetailsSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof updateEmployerOnboardingStepDetails>>, TError,{employeeNumber: number;id: number;data: UpdateOnboardingStepDetailsSchema}, TContext> => {
    
const mutationKey = ['updateEmployerOnboardingStepDetails'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateEmployerOnboardingStepDetails>>, {employeeNumber: number;id: number;data: UpdateOnboardingStepDetailsSchema}> = (props) => {
          const {employeeNumber,id,data} = props ?? {};

          return  updateEmployerOnboardingStepDetails(employeeNumber,id,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateEmployerOnboardingStepDetailsMutationResult = NonNullable<Awaited<ReturnType<typeof updateEmployerOnboardingStepDetails>>>
    export type UpdateEmployerOnboardingStepDetailsMutationBody = UpdateOnboardingStepDetailsSchema
    export type UpdateEmployerOnboardingStepDetailsMutationError = AxiosError<unknown>

    /**
 * @summary Updates employer onboarding step details
 */
export const useUpdateEmployerOnboardingStepDetails = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateEmployerOnboardingStepDetails>>, TError,{employeeNumber: number;id: number;data: UpdateOnboardingStepDetailsSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof updateEmployerOnboardingStepDetails>>,
        TError,
        {employeeNumber: number;id: number;data: UpdateOnboardingStepDetailsSchema},
        TContext
      > => {

      const mutationOptions = getUpdateEmployerOnboardingStepDetailsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Marks a custom (non-predefined) employer-owned step as complete by evaluating its saved field values
 */
export const completeEmployerOnboardingStep = (
    employeeNumber: number,
    id: number,
    approveOnboardingStepSchema: ApproveOnboardingStepSchema, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.default.post(
      `/api/EmployeeOnboardingManager/Employees/${employeeNumber}/EmployerSteps/${id}/Complete`,
      approveOnboardingStepSchema,options
    );
  }



export const getCompleteEmployerOnboardingStepMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof completeEmployerOnboardingStep>>, TError,{employeeNumber: number;id: number;data: ApproveOnboardingStepSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof completeEmployerOnboardingStep>>, TError,{employeeNumber: number;id: number;data: ApproveOnboardingStepSchema}, TContext> => {
    
const mutationKey = ['completeEmployerOnboardingStep'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof completeEmployerOnboardingStep>>, {employeeNumber: number;id: number;data: ApproveOnboardingStepSchema}> = (props) => {
          const {employeeNumber,id,data} = props ?? {};

          return  completeEmployerOnboardingStep(employeeNumber,id,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CompleteEmployerOnboardingStepMutationResult = NonNullable<Awaited<ReturnType<typeof completeEmployerOnboardingStep>>>
    export type CompleteEmployerOnboardingStepMutationBody = ApproveOnboardingStepSchema
    export type CompleteEmployerOnboardingStepMutationError = AxiosError<unknown>

    /**
 * @summary Marks a custom (non-predefined) employer-owned step as complete by evaluating its saved field values
 */
export const useCompleteEmployerOnboardingStep = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof completeEmployerOnboardingStep>>, TError,{employeeNumber: number;id: number;data: ApproveOnboardingStepSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof completeEmployerOnboardingStep>>,
        TError,
        {employeeNumber: number;id: number;data: ApproveOnboardingStepSchema},
        TContext
      > => {

      const mutationOptions = getCompleteEmployerOnboardingStepMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Gets employer onboarding field attachment for employee
 */
export const getEmployerFieldAttachment = (
    employeeNumber: number,
    id: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Blob>> => {
    
    
    return axios.default.get(
      `/api/EmployeeOnboardingManager/Employees/${employeeNumber}/Fields/${id}/Attachment`,{
        responseType: 'blob',
    ...options,}
    );
  }


export const getGetEmployerFieldAttachmentQueryKey = (employeeNumber: number,
    id: number,) => {
    return [`/api/EmployeeOnboardingManager/Employees/${employeeNumber}/Fields/${id}/Attachment`] as const;
    }

    
export const getGetEmployerFieldAttachmentQueryOptions = <TData = Awaited<ReturnType<typeof getEmployerFieldAttachment>>, TError = AxiosError<unknown>>(employeeNumber: number,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployerFieldAttachment>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEmployerFieldAttachmentQueryKey(employeeNumber,id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEmployerFieldAttachment>>> = ({ signal }) => getEmployerFieldAttachment(employeeNumber,id, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(employeeNumber && id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEmployerFieldAttachment>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEmployerFieldAttachmentQueryResult = NonNullable<Awaited<ReturnType<typeof getEmployerFieldAttachment>>>
export type GetEmployerFieldAttachmentQueryError = AxiosError<unknown>


export function useGetEmployerFieldAttachment<TData = Awaited<ReturnType<typeof getEmployerFieldAttachment>>, TError = AxiosError<unknown>>(
 employeeNumber: number,
    id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployerFieldAttachment>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmployerFieldAttachment>>,
          TError,
          Awaited<ReturnType<typeof getEmployerFieldAttachment>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmployerFieldAttachment<TData = Awaited<ReturnType<typeof getEmployerFieldAttachment>>, TError = AxiosError<unknown>>(
 employeeNumber: number,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployerFieldAttachment>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmployerFieldAttachment>>,
          TError,
          Awaited<ReturnType<typeof getEmployerFieldAttachment>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmployerFieldAttachment<TData = Awaited<ReturnType<typeof getEmployerFieldAttachment>>, TError = AxiosError<unknown>>(
 employeeNumber: number,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployerFieldAttachment>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Gets employer onboarding field attachment for employee
 */

export function useGetEmployerFieldAttachment<TData = Awaited<ReturnType<typeof getEmployerFieldAttachment>>, TError = AxiosError<unknown>>(
 employeeNumber: number,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployerFieldAttachment>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEmployerFieldAttachmentQueryOptions(employeeNumber,id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Updates employer onboarding field attachment for employee
 */
export const updateEmployerFieldAttachment = (
    employeeNumber: number,
    id: number,
    updateEmployerFieldAttachmentBody: UpdateEmployerFieldAttachmentBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    const formData = createFormData(updateEmployerFieldAttachmentBody)
    return axios.default.post(
      `/api/EmployeeOnboardingManager/Employees/${employeeNumber}/Fields/${id}/Attachment`,
      formData,options
    );
  }



export const getUpdateEmployerFieldAttachmentMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateEmployerFieldAttachment>>, TError,{employeeNumber: number;id: number;data: UpdateEmployerFieldAttachmentBody}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof updateEmployerFieldAttachment>>, TError,{employeeNumber: number;id: number;data: UpdateEmployerFieldAttachmentBody}, TContext> => {
    
const mutationKey = ['updateEmployerFieldAttachment'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateEmployerFieldAttachment>>, {employeeNumber: number;id: number;data: UpdateEmployerFieldAttachmentBody}> = (props) => {
          const {employeeNumber,id,data} = props ?? {};

          return  updateEmployerFieldAttachment(employeeNumber,id,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateEmployerFieldAttachmentMutationResult = NonNullable<Awaited<ReturnType<typeof updateEmployerFieldAttachment>>>
    export type UpdateEmployerFieldAttachmentMutationBody = UpdateEmployerFieldAttachmentBody
    export type UpdateEmployerFieldAttachmentMutationError = AxiosError<unknown>

    /**
 * @summary Updates employer onboarding field attachment for employee
 */
export const useUpdateEmployerFieldAttachment = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateEmployerFieldAttachment>>, TError,{employeeNumber: number;id: number;data: UpdateEmployerFieldAttachmentBody}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof updateEmployerFieldAttachment>>,
        TError,
        {employeeNumber: number;id: number;data: UpdateEmployerFieldAttachmentBody},
        TContext
      > => {

      const mutationOptions = getUpdateEmployerFieldAttachmentMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Gets onboarding employee steps by onboarding employee number
 */
export const getOnboardingEmployeeSteps = (
    employeeNumber: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ReviewEmployeeOnboardingStepSchema[]>> => {
    
    
    return axios.default.get(
      `/api/EmployeeOnboardingManager/Employees/${employeeNumber}/Steps`,options
    );
  }


export const getGetOnboardingEmployeeStepsQueryKey = (employeeNumber: number,) => {
    return [`/api/EmployeeOnboardingManager/Employees/${employeeNumber}/Steps`] as const;
    }

    
export const getGetOnboardingEmployeeStepsQueryOptions = <TData = Awaited<ReturnType<typeof getOnboardingEmployeeSteps>>, TError = AxiosError<unknown>>(employeeNumber: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOnboardingEmployeeSteps>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOnboardingEmployeeStepsQueryKey(employeeNumber);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOnboardingEmployeeSteps>>> = ({ signal }) => getOnboardingEmployeeSteps(employeeNumber, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(employeeNumber), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOnboardingEmployeeSteps>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOnboardingEmployeeStepsQueryResult = NonNullable<Awaited<ReturnType<typeof getOnboardingEmployeeSteps>>>
export type GetOnboardingEmployeeStepsQueryError = AxiosError<unknown>


export function useGetOnboardingEmployeeSteps<TData = Awaited<ReturnType<typeof getOnboardingEmployeeSteps>>, TError = AxiosError<unknown>>(
 employeeNumber: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOnboardingEmployeeSteps>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOnboardingEmployeeSteps>>,
          TError,
          Awaited<ReturnType<typeof getOnboardingEmployeeSteps>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOnboardingEmployeeSteps<TData = Awaited<ReturnType<typeof getOnboardingEmployeeSteps>>, TError = AxiosError<unknown>>(
 employeeNumber: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOnboardingEmployeeSteps>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOnboardingEmployeeSteps>>,
          TError,
          Awaited<ReturnType<typeof getOnboardingEmployeeSteps>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOnboardingEmployeeSteps<TData = Awaited<ReturnType<typeof getOnboardingEmployeeSteps>>, TError = AxiosError<unknown>>(
 employeeNumber: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOnboardingEmployeeSteps>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Gets onboarding employee steps by onboarding employee number
 */

export function useGetOnboardingEmployeeSteps<TData = Awaited<ReturnType<typeof getOnboardingEmployeeSteps>>, TError = AxiosError<unknown>>(
 employeeNumber: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOnboardingEmployeeSteps>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOnboardingEmployeeStepsQueryOptions(employeeNumber,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Gets details of a specific onboarding step including fields and document
 */
export const getOnboardingEmployeeStepDetails = (
    employeeNumber: number,
    stepId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ReviewEmployeeOnboardingStepDetailsSchema>> => {
    
    
    return axios.default.get(
      `/api/EmployeeOnboardingManager/Employees/${employeeNumber}/Steps/${stepId}`,options
    );
  }


export const getGetOnboardingEmployeeStepDetailsQueryKey = (employeeNumber: number,
    stepId: number,) => {
    return [`/api/EmployeeOnboardingManager/Employees/${employeeNumber}/Steps/${stepId}`] as const;
    }

    
export const getGetOnboardingEmployeeStepDetailsQueryOptions = <TData = Awaited<ReturnType<typeof getOnboardingEmployeeStepDetails>>, TError = AxiosError<unknown>>(employeeNumber: number,
    stepId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOnboardingEmployeeStepDetails>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOnboardingEmployeeStepDetailsQueryKey(employeeNumber,stepId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOnboardingEmployeeStepDetails>>> = ({ signal }) => getOnboardingEmployeeStepDetails(employeeNumber,stepId, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(employeeNumber && stepId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOnboardingEmployeeStepDetails>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOnboardingEmployeeStepDetailsQueryResult = NonNullable<Awaited<ReturnType<typeof getOnboardingEmployeeStepDetails>>>
export type GetOnboardingEmployeeStepDetailsQueryError = AxiosError<unknown>


export function useGetOnboardingEmployeeStepDetails<TData = Awaited<ReturnType<typeof getOnboardingEmployeeStepDetails>>, TError = AxiosError<unknown>>(
 employeeNumber: number,
    stepId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOnboardingEmployeeStepDetails>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOnboardingEmployeeStepDetails>>,
          TError,
          Awaited<ReturnType<typeof getOnboardingEmployeeStepDetails>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOnboardingEmployeeStepDetails<TData = Awaited<ReturnType<typeof getOnboardingEmployeeStepDetails>>, TError = AxiosError<unknown>>(
 employeeNumber: number,
    stepId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOnboardingEmployeeStepDetails>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOnboardingEmployeeStepDetails>>,
          TError,
          Awaited<ReturnType<typeof getOnboardingEmployeeStepDetails>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOnboardingEmployeeStepDetails<TData = Awaited<ReturnType<typeof getOnboardingEmployeeStepDetails>>, TError = AxiosError<unknown>>(
 employeeNumber: number,
    stepId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOnboardingEmployeeStepDetails>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Gets details of a specific onboarding step including fields and document
 */

export function useGetOnboardingEmployeeStepDetails<TData = Awaited<ReturnType<typeof getOnboardingEmployeeStepDetails>>, TError = AxiosError<unknown>>(
 employeeNumber: number,
    stepId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOnboardingEmployeeStepDetails>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOnboardingEmployeeStepDetailsQueryOptions(employeeNumber,stepId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Approves a specific onboarding step
 */
export const approveStep = (
    employeeNumber: number,
    stepId: number,
    approveOnboardingStepSchema: ApproveOnboardingStepSchema, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.default.post(
      `/api/EmployeeOnboardingManager/Employees/${employeeNumber}/Steps/${stepId}/Approve`,
      approveOnboardingStepSchema,options
    );
  }



export const getApproveStepMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveStep>>, TError,{employeeNumber: number;stepId: number;data: ApproveOnboardingStepSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof approveStep>>, TError,{employeeNumber: number;stepId: number;data: ApproveOnboardingStepSchema}, TContext> => {
    
const mutationKey = ['approveStep'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof approveStep>>, {employeeNumber: number;stepId: number;data: ApproveOnboardingStepSchema}> = (props) => {
          const {employeeNumber,stepId,data} = props ?? {};

          return  approveStep(employeeNumber,stepId,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApproveStepMutationResult = NonNullable<Awaited<ReturnType<typeof approveStep>>>
    export type ApproveStepMutationBody = ApproveOnboardingStepSchema
    export type ApproveStepMutationError = AxiosError<unknown>

    /**
 * @summary Approves a specific onboarding step
 */
export const useApproveStep = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveStep>>, TError,{employeeNumber: number;stepId: number;data: ApproveOnboardingStepSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof approveStep>>,
        TError,
        {employeeNumber: number;stepId: number;data: ApproveOnboardingStepSchema},
        TContext
      > => {

      const mutationOptions = getApproveStepMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Requests an update on a specific onboarding step
 */
export const requestStepUpdate = (
    employeeNumber: number,
    stepId: number,
    requestStepUpdateSchema: RequestStepUpdateSchema, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.default.post(
      `/api/EmployeeOnboardingManager/Employees/${employeeNumber}/Steps/${stepId}/UpdateRequest`,
      requestStepUpdateSchema,options
    );
  }



export const getRequestStepUpdateMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestStepUpdate>>, TError,{employeeNumber: number;stepId: number;data: RequestStepUpdateSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof requestStepUpdate>>, TError,{employeeNumber: number;stepId: number;data: RequestStepUpdateSchema}, TContext> => {
    
const mutationKey = ['requestStepUpdate'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof requestStepUpdate>>, {employeeNumber: number;stepId: number;data: RequestStepUpdateSchema}> = (props) => {
          const {employeeNumber,stepId,data} = props ?? {};

          return  requestStepUpdate(employeeNumber,stepId,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RequestStepUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof requestStepUpdate>>>
    export type RequestStepUpdateMutationBody = RequestStepUpdateSchema
    export type RequestStepUpdateMutationError = AxiosError<unknown>

    /**
 * @summary Requests an update on a specific onboarding step
 */
export const useRequestStepUpdate = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestStepUpdate>>, TError,{employeeNumber: number;stepId: number;data: RequestStepUpdateSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof requestStepUpdate>>,
        TError,
        {employeeNumber: number;stepId: number;data: RequestStepUpdateSchema},
        TContext
      > => {

      const mutationOptions = getRequestStepUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Removes an update request from a specific onboarding step
 */
export const removeStepUpdateRequest = (
    employeeNumber: number,
    stepId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.default.delete(
      `/api/EmployeeOnboardingManager/Employees/${employeeNumber}/Steps/${stepId}/UpdateRequest`,options
    );
  }



export const getRemoveStepUpdateRequestMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeStepUpdateRequest>>, TError,{employeeNumber: number;stepId: number}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof removeStepUpdateRequest>>, TError,{employeeNumber: number;stepId: number}, TContext> => {
    
const mutationKey = ['removeStepUpdateRequest'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof removeStepUpdateRequest>>, {employeeNumber: number;stepId: number}> = (props) => {
          const {employeeNumber,stepId} = props ?? {};

          return  removeStepUpdateRequest(employeeNumber,stepId,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RemoveStepUpdateRequestMutationResult = NonNullable<Awaited<ReturnType<typeof removeStepUpdateRequest>>>
    
    export type RemoveStepUpdateRequestMutationError = AxiosError<unknown>

    /**
 * @summary Removes an update request from a specific onboarding step
 */
export const useRemoveStepUpdateRequest = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeStepUpdateRequest>>, TError,{employeeNumber: number;stepId: number}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof removeStepUpdateRequest>>,
        TError,
        {employeeNumber: number;stepId: number},
        TContext
      > => {

      const mutationOptions = getRemoveStepUpdateRequestMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Gets onboarding employee details by onboarding employee number
 */
export const getOnboardingEmployee = (
    empNum: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<EmployeeDetailsSchema>> => {
    
    
    return axios.default.get(
      `/api/EmployeeOnboardingManager/Employees/${empNum}`,options
    );
  }


export const getGetOnboardingEmployeeQueryKey = (empNum: number,) => {
    return [`/api/EmployeeOnboardingManager/Employees/${empNum}`] as const;
    }

    
export const getGetOnboardingEmployeeQueryOptions = <TData = Awaited<ReturnType<typeof getOnboardingEmployee>>, TError = AxiosError<unknown>>(empNum: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOnboardingEmployee>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOnboardingEmployeeQueryKey(empNum);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOnboardingEmployee>>> = ({ signal }) => getOnboardingEmployee(empNum, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(empNum), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOnboardingEmployee>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOnboardingEmployeeQueryResult = NonNullable<Awaited<ReturnType<typeof getOnboardingEmployee>>>
export type GetOnboardingEmployeeQueryError = AxiosError<unknown>


export function useGetOnboardingEmployee<TData = Awaited<ReturnType<typeof getOnboardingEmployee>>, TError = AxiosError<unknown>>(
 empNum: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOnboardingEmployee>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOnboardingEmployee>>,
          TError,
          Awaited<ReturnType<typeof getOnboardingEmployee>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOnboardingEmployee<TData = Awaited<ReturnType<typeof getOnboardingEmployee>>, TError = AxiosError<unknown>>(
 empNum: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOnboardingEmployee>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOnboardingEmployee>>,
          TError,
          Awaited<ReturnType<typeof getOnboardingEmployee>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOnboardingEmployee<TData = Awaited<ReturnType<typeof getOnboardingEmployee>>, TError = AxiosError<unknown>>(
 empNum: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOnboardingEmployee>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Gets onboarding employee details by onboarding employee number
 */

export function useGetOnboardingEmployee<TData = Awaited<ReturnType<typeof getOnboardingEmployee>>, TError = AxiosError<unknown>>(
 empNum: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOnboardingEmployee>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOnboardingEmployeeQueryOptions(empNum,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Cancels employee onboarding
 */
export const cancelEmployeeOnboarding = (
    empNum: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.default.delete(
      `/api/EmployeeOnboardingManager/Employees/${empNum}`,options
    );
  }



export const getCancelEmployeeOnboardingMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelEmployeeOnboarding>>, TError,{empNum: number}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof cancelEmployeeOnboarding>>, TError,{empNum: number}, TContext> => {
    
const mutationKey = ['cancelEmployeeOnboarding'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancelEmployeeOnboarding>>, {empNum: number}> = (props) => {
          const {empNum} = props ?? {};

          return  cancelEmployeeOnboarding(empNum,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CancelEmployeeOnboardingMutationResult = NonNullable<Awaited<ReturnType<typeof cancelEmployeeOnboarding>>>
    
    export type CancelEmployeeOnboardingMutationError = AxiosError<unknown>

    /**
 * @summary Cancels employee onboarding
 */
export const useCancelEmployeeOnboarding = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelEmployeeOnboarding>>, TError,{empNum: number}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof cancelEmployeeOnboarding>>,
        TError,
        {empNum: number},
        TContext
      > => {

      const mutationOptions = getCancelEmployeeOnboardingMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Activates employee onboarding
 */
export const activateEmployeeOnboarding = (
    empNum: number,
    updateEmployeeInfoSchema: UpdateEmployeeInfoSchema, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.default.post(
      `/api/EmployeeOnboardingManager/Employees/${empNum}/Activate`,
      updateEmployeeInfoSchema,options
    );
  }



export const getActivateEmployeeOnboardingMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activateEmployeeOnboarding>>, TError,{empNum: number;data: UpdateEmployeeInfoSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof activateEmployeeOnboarding>>, TError,{empNum: number;data: UpdateEmployeeInfoSchema}, TContext> => {
    
const mutationKey = ['activateEmployeeOnboarding'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof activateEmployeeOnboarding>>, {empNum: number;data: UpdateEmployeeInfoSchema}> = (props) => {
          const {empNum,data} = props ?? {};

          return  activateEmployeeOnboarding(empNum,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ActivateEmployeeOnboardingMutationResult = NonNullable<Awaited<ReturnType<typeof activateEmployeeOnboarding>>>
    export type ActivateEmployeeOnboardingMutationBody = UpdateEmployeeInfoSchema
    export type ActivateEmployeeOnboardingMutationError = AxiosError<unknown>

    /**
 * @summary Activates employee onboarding
 */
export const useActivateEmployeeOnboarding = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activateEmployeeOnboarding>>, TError,{empNum: number;data: UpdateEmployeeInfoSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof activateEmployeeOnboarding>>,
        TError,
        {empNum: number;data: UpdateEmployeeInfoSchema},
        TContext
      > => {

      const mutationOptions = getActivateEmployeeOnboardingMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Completes the onboarding process
 */
export const completeEmployeeOnboarding = (
    empNum: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.default.post(
      `/api/EmployeeOnboardingManager/Employees/${empNum}/Complete`,undefined,options
    );
  }



export const getCompleteEmployeeOnboardingMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof completeEmployeeOnboarding>>, TError,{empNum: number}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof completeEmployeeOnboarding>>, TError,{empNum: number}, TContext> => {
    
const mutationKey = ['completeEmployeeOnboarding'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof completeEmployeeOnboarding>>, {empNum: number}> = (props) => {
          const {empNum} = props ?? {};

          return  completeEmployeeOnboarding(empNum,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CompleteEmployeeOnboardingMutationResult = NonNullable<Awaited<ReturnType<typeof completeEmployeeOnboarding>>>
    
    export type CompleteEmployeeOnboardingMutationError = AxiosError<unknown>

    /**
 * @summary Completes the onboarding process
 */
export const useCompleteEmployeeOnboarding = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof completeEmployeeOnboarding>>, TError,{empNum: number}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof completeEmployeeOnboarding>>,
        TError,
        {empNum: number},
        TContext
      > => {

      const mutationOptions = getCompleteEmployeeOnboardingMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Gets signed form for employee by type (FW4, SW4, I9 or W9)
 */
export const getSignedForm = (
    empNum: number,
    type: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Blob>> => {
    
    
    return axios.default.get(
      `/api/EmployeeOnboardingManager/Employees/${empNum}/Forms/${type}`,{
        responseType: 'blob',
    ...options,}
    );
  }


export const getGetSignedFormQueryKey = (empNum: number,
    type: string,) => {
    return [`/api/EmployeeOnboardingManager/Employees/${empNum}/Forms/${type}`] as const;
    }

    
export const getGetSignedFormQueryOptions = <TData = Awaited<ReturnType<typeof getSignedForm>>, TError = AxiosError<ProblemDetailsSchema>>(empNum: number,
    type: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSignedForm>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSignedFormQueryKey(empNum,type);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSignedForm>>> = ({ signal }) => getSignedForm(empNum,type, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(empNum && type), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSignedForm>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSignedFormQueryResult = NonNullable<Awaited<ReturnType<typeof getSignedForm>>>
export type GetSignedFormQueryError = AxiosError<ProblemDetailsSchema>


export function useGetSignedForm<TData = Awaited<ReturnType<typeof getSignedForm>>, TError = AxiosError<ProblemDetailsSchema>>(
 empNum: number,
    type: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSignedForm>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSignedForm>>,
          TError,
          Awaited<ReturnType<typeof getSignedForm>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSignedForm<TData = Awaited<ReturnType<typeof getSignedForm>>, TError = AxiosError<ProblemDetailsSchema>>(
 empNum: number,
    type: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSignedForm>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSignedForm>>,
          TError,
          Awaited<ReturnType<typeof getSignedForm>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSignedForm<TData = Awaited<ReturnType<typeof getSignedForm>>, TError = AxiosError<ProblemDetailsSchema>>(
 empNum: number,
    type: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSignedForm>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Gets signed form for employee by type (FW4, SW4, I9 or W9)
 */

export function useGetSignedForm<TData = Awaited<ReturnType<typeof getSignedForm>>, TError = AxiosError<ProblemDetailsSchema>>(
 empNum: number,
    type: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSignedForm>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSignedFormQueryOptions(empNum,type,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Signs I9 form as employer
 */
export const signIdentificationForm = (
    empNum: number,
    submitOnboardingSystemTemplateSchema: SubmitOnboardingSystemTemplateSchema, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.default.post(
      `/api/EmployeeOnboardingManager/Employees/${empNum}/Forms/I9`,
      submitOnboardingSystemTemplateSchema,options
    );
  }



export const getSignIdentificationFormMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof signIdentificationForm>>, TError,{empNum: number;data: SubmitOnboardingSystemTemplateSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof signIdentificationForm>>, TError,{empNum: number;data: SubmitOnboardingSystemTemplateSchema}, TContext> => {
    
const mutationKey = ['signIdentificationForm'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof signIdentificationForm>>, {empNum: number;data: SubmitOnboardingSystemTemplateSchema}> = (props) => {
          const {empNum,data} = props ?? {};

          return  signIdentificationForm(empNum,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SignIdentificationFormMutationResult = NonNullable<Awaited<ReturnType<typeof signIdentificationForm>>>
    export type SignIdentificationFormMutationBody = SubmitOnboardingSystemTemplateSchema
    export type SignIdentificationFormMutationError = AxiosError<unknown>

    /**
 * @summary Signs I9 form as employer
 */
export const useSignIdentificationForm = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof signIdentificationForm>>, TError,{empNum: number;data: SubmitOnboardingSystemTemplateSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof signIdentificationForm>>,
        TError,
        {empNum: number;data: SubmitOnboardingSystemTemplateSchema},
        TContext
      > => {

      const mutationOptions = getSignIdentificationFormMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Gets I9 form as employer
 */
export const getEmployerIdentificationForm = (
    empNum: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<EmployerFormSchema>> => {
    
    
    return axios.default.get(
      `/api/EmployeeOnboardingManager/Employees/${empNum}/Forms/I9/Template`,options
    );
  }


export const getGetEmployerIdentificationFormQueryKey = (empNum: number,) => {
    return [`/api/EmployeeOnboardingManager/Employees/${empNum}/Forms/I9/Template`] as const;
    }

    
export const getGetEmployerIdentificationFormQueryOptions = <TData = Awaited<ReturnType<typeof getEmployerIdentificationForm>>, TError = AxiosError<unknown>>(empNum: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployerIdentificationForm>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEmployerIdentificationFormQueryKey(empNum);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEmployerIdentificationForm>>> = ({ signal }) => getEmployerIdentificationForm(empNum, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(empNum), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEmployerIdentificationForm>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEmployerIdentificationFormQueryResult = NonNullable<Awaited<ReturnType<typeof getEmployerIdentificationForm>>>
export type GetEmployerIdentificationFormQueryError = AxiosError<unknown>


export function useGetEmployerIdentificationForm<TData = Awaited<ReturnType<typeof getEmployerIdentificationForm>>, TError = AxiosError<unknown>>(
 empNum: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployerIdentificationForm>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmployerIdentificationForm>>,
          TError,
          Awaited<ReturnType<typeof getEmployerIdentificationForm>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmployerIdentificationForm<TData = Awaited<ReturnType<typeof getEmployerIdentificationForm>>, TError = AxiosError<unknown>>(
 empNum: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployerIdentificationForm>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmployerIdentificationForm>>,
          TError,
          Awaited<ReturnType<typeof getEmployerIdentificationForm>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmployerIdentificationForm<TData = Awaited<ReturnType<typeof getEmployerIdentificationForm>>, TError = AxiosError<unknown>>(
 empNum: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployerIdentificationForm>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Gets I9 form as employer
 */

export function useGetEmployerIdentificationForm<TData = Awaited<ReturnType<typeof getEmployerIdentificationForm>>, TError = AxiosError<unknown>>(
 empNum: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployerIdentificationForm>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEmployerIdentificationFormQueryOptions(empNum,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Gets onboarding employee identification info
 */
export const getOnboardingEmployeeIdentificationInfo = (
    empNum: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ReviewEmployeeIdentificationInfoSchema>> => {
    
    
    return axios.default.get(
      `/api/EmployeeOnboardingManager/Employees/${empNum}/IdentificationInfo`,options
    );
  }


export const getGetOnboardingEmployeeIdentificationInfoQueryKey = (empNum: number,) => {
    return [`/api/EmployeeOnboardingManager/Employees/${empNum}/IdentificationInfo`] as const;
    }

    
export const getGetOnboardingEmployeeIdentificationInfoQueryOptions = <TData = Awaited<ReturnType<typeof getOnboardingEmployeeIdentificationInfo>>, TError = AxiosError<unknown>>(empNum: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOnboardingEmployeeIdentificationInfo>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOnboardingEmployeeIdentificationInfoQueryKey(empNum);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOnboardingEmployeeIdentificationInfo>>> = ({ signal }) => getOnboardingEmployeeIdentificationInfo(empNum, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(empNum), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOnboardingEmployeeIdentificationInfo>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOnboardingEmployeeIdentificationInfoQueryResult = NonNullable<Awaited<ReturnType<typeof getOnboardingEmployeeIdentificationInfo>>>
export type GetOnboardingEmployeeIdentificationInfoQueryError = AxiosError<unknown>


export function useGetOnboardingEmployeeIdentificationInfo<TData = Awaited<ReturnType<typeof getOnboardingEmployeeIdentificationInfo>>, TError = AxiosError<unknown>>(
 empNum: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOnboardingEmployeeIdentificationInfo>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOnboardingEmployeeIdentificationInfo>>,
          TError,
          Awaited<ReturnType<typeof getOnboardingEmployeeIdentificationInfo>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOnboardingEmployeeIdentificationInfo<TData = Awaited<ReturnType<typeof getOnboardingEmployeeIdentificationInfo>>, TError = AxiosError<unknown>>(
 empNum: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOnboardingEmployeeIdentificationInfo>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOnboardingEmployeeIdentificationInfo>>,
          TError,
          Awaited<ReturnType<typeof getOnboardingEmployeeIdentificationInfo>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOnboardingEmployeeIdentificationInfo<TData = Awaited<ReturnType<typeof getOnboardingEmployeeIdentificationInfo>>, TError = AxiosError<unknown>>(
 empNum: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOnboardingEmployeeIdentificationInfo>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Gets onboarding employee identification info
 */

export function useGetOnboardingEmployeeIdentificationInfo<TData = Awaited<ReturnType<typeof getOnboardingEmployeeIdentificationInfo>>, TError = AxiosError<unknown>>(
 empNum: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOnboardingEmployeeIdentificationInfo>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOnboardingEmployeeIdentificationInfoQueryOptions(empNum,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Updates onboarding employee identification info
 */
export const updateEmployeeIdentificationInfo = (
    empNum: number,
    updateEmployeeIdDocumentsInfoSchema: UpdateEmployeeIdDocumentsInfoSchema, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<UpdateEmployeeIdDocumentsInfoResponseSchema>> => {
    
    
    return axios.default.put(
      `/api/EmployeeOnboardingManager/Employees/${empNum}/IdentificationInfo`,
      updateEmployeeIdDocumentsInfoSchema,options
    );
  }



export const getUpdateEmployeeIdentificationInfoMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateEmployeeIdentificationInfo>>, TError,{empNum: number;data: UpdateEmployeeIdDocumentsInfoSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof updateEmployeeIdentificationInfo>>, TError,{empNum: number;data: UpdateEmployeeIdDocumentsInfoSchema}, TContext> => {
    
const mutationKey = ['updateEmployeeIdentificationInfo'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateEmployeeIdentificationInfo>>, {empNum: number;data: UpdateEmployeeIdDocumentsInfoSchema}> = (props) => {
          const {empNum,data} = props ?? {};

          return  updateEmployeeIdentificationInfo(empNum,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateEmployeeIdentificationInfoMutationResult = NonNullable<Awaited<ReturnType<typeof updateEmployeeIdentificationInfo>>>
    export type UpdateEmployeeIdentificationInfoMutationBody = UpdateEmployeeIdDocumentsInfoSchema
    export type UpdateEmployeeIdentificationInfoMutationError = AxiosError<unknown>

    /**
 * @summary Updates onboarding employee identification info
 */
export const useUpdateEmployeeIdentificationInfo = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateEmployeeIdentificationInfo>>, TError,{empNum: number;data: UpdateEmployeeIdDocumentsInfoSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof updateEmployeeIdentificationInfo>>,
        TError,
        {empNum: number;data: UpdateEmployeeIdDocumentsInfoSchema},
        TContext
      > => {

      const mutationOptions = getUpdateEmployeeIdentificationInfoMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Sends onboarding reminder to employee
 */
export const sendOnboardingReminderToEmployee = (
    empNum: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.default.post(
      `/api/EmployeeOnboardingManager/Employees/${empNum}/Reminder`,undefined,options
    );
  }



export const getSendOnboardingReminderToEmployeeMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendOnboardingReminderToEmployee>>, TError,{empNum: number}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof sendOnboardingReminderToEmployee>>, TError,{empNum: number}, TContext> => {
    
const mutationKey = ['sendOnboardingReminderToEmployee'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendOnboardingReminderToEmployee>>, {empNum: number}> = (props) => {
          const {empNum} = props ?? {};

          return  sendOnboardingReminderToEmployee(empNum,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SendOnboardingReminderToEmployeeMutationResult = NonNullable<Awaited<ReturnType<typeof sendOnboardingReminderToEmployee>>>
    
    export type SendOnboardingReminderToEmployeeMutationError = AxiosError<unknown>

    /**
 * @summary Sends onboarding reminder to employee
 */
export const useSendOnboardingReminderToEmployee = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendOnboardingReminderToEmployee>>, TError,{empNum: number}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof sendOnboardingReminderToEmployee>>,
        TError,
        {empNum: number},
        TContext
      > => {

      const mutationOptions = getSendOnboardingReminderToEmployeeMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Reopens the onboarding process
 */
export const reopenEmployeeOnboarding = (
    empNum: number,
    reopenEmployeeOnboardingInfoSchema: ReopenEmployeeOnboardingInfoSchema, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<OnboardingEmployeeSchema[]>> => {
    
    
    return axios.default.post(
      `/api/EmployeeOnboardingManager/Employees/${empNum}/Reopen`,
      reopenEmployeeOnboardingInfoSchema,options
    );
  }



export const getReopenEmployeeOnboardingMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reopenEmployeeOnboarding>>, TError,{empNum: number;data: ReopenEmployeeOnboardingInfoSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof reopenEmployeeOnboarding>>, TError,{empNum: number;data: ReopenEmployeeOnboardingInfoSchema}, TContext> => {
    
const mutationKey = ['reopenEmployeeOnboarding'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reopenEmployeeOnboarding>>, {empNum: number;data: ReopenEmployeeOnboardingInfoSchema}> = (props) => {
          const {empNum,data} = props ?? {};

          return  reopenEmployeeOnboarding(empNum,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ReopenEmployeeOnboardingMutationResult = NonNullable<Awaited<ReturnType<typeof reopenEmployeeOnboarding>>>
    export type ReopenEmployeeOnboardingMutationBody = ReopenEmployeeOnboardingInfoSchema
    export type ReopenEmployeeOnboardingMutationError = AxiosError<unknown>

    /**
 * @summary Reopens the onboarding process
 */
export const useReopenEmployeeOnboarding = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reopenEmployeeOnboarding>>, TError,{empNum: number;data: ReopenEmployeeOnboardingInfoSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof reopenEmployeeOnboarding>>,
        TError,
        {empNum: number;data: ReopenEmployeeOnboardingInfoSchema},
        TContext
      > => {

      const mutationOptions = getReopenEmployeeOnboardingMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Gets employee onboarding fields
 */
export const getEmployeeOnboardingFields = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<EmployeeOnboardingFieldSchema[]>> => {
    
    
    return axios.default.get(
      `/api/EmployeeOnboardingManager/Fields`,options
    );
  }


export const getGetEmployeeOnboardingFieldsQueryKey = () => {
    return [`/api/EmployeeOnboardingManager/Fields`] as const;
    }

    
export const getGetEmployeeOnboardingFieldsQueryOptions = <TData = Awaited<ReturnType<typeof getEmployeeOnboardingFields>>, TError = AxiosError<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeeOnboardingFields>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEmployeeOnboardingFieldsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEmployeeOnboardingFields>>> = ({ signal }) => getEmployeeOnboardingFields({ signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEmployeeOnboardingFields>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEmployeeOnboardingFieldsQueryResult = NonNullable<Awaited<ReturnType<typeof getEmployeeOnboardingFields>>>
export type GetEmployeeOnboardingFieldsQueryError = AxiosError<unknown>


export function useGetEmployeeOnboardingFields<TData = Awaited<ReturnType<typeof getEmployeeOnboardingFields>>, TError = AxiosError<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeeOnboardingFields>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmployeeOnboardingFields>>,
          TError,
          Awaited<ReturnType<typeof getEmployeeOnboardingFields>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmployeeOnboardingFields<TData = Awaited<ReturnType<typeof getEmployeeOnboardingFields>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeeOnboardingFields>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmployeeOnboardingFields>>,
          TError,
          Awaited<ReturnType<typeof getEmployeeOnboardingFields>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmployeeOnboardingFields<TData = Awaited<ReturnType<typeof getEmployeeOnboardingFields>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeeOnboardingFields>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Gets employee onboarding fields
 */

export function useGetEmployeeOnboardingFields<TData = Awaited<ReturnType<typeof getEmployeeOnboardingFields>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeeOnboardingFields>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEmployeeOnboardingFieldsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Upserts employee onboarding field
 */
export const upsertEmployeeOnboardingField = (
    upsertEmployeeOnboardingFieldSchema: UpsertEmployeeOnboardingFieldSchema, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.default.post(
      `/api/EmployeeOnboardingManager/Fields`,
      upsertEmployeeOnboardingFieldSchema,options
    );
  }



export const getUpsertEmployeeOnboardingFieldMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof upsertEmployeeOnboardingField>>, TError,{data: UpsertEmployeeOnboardingFieldSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof upsertEmployeeOnboardingField>>, TError,{data: UpsertEmployeeOnboardingFieldSchema}, TContext> => {
    
const mutationKey = ['upsertEmployeeOnboardingField'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof upsertEmployeeOnboardingField>>, {data: UpsertEmployeeOnboardingFieldSchema}> = (props) => {
          const {data} = props ?? {};

          return  upsertEmployeeOnboardingField(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpsertEmployeeOnboardingFieldMutationResult = NonNullable<Awaited<ReturnType<typeof upsertEmployeeOnboardingField>>>
    export type UpsertEmployeeOnboardingFieldMutationBody = UpsertEmployeeOnboardingFieldSchema
    export type UpsertEmployeeOnboardingFieldMutationError = AxiosError<unknown>

    /**
 * @summary Upserts employee onboarding field
 */
export const useUpsertEmployeeOnboardingField = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof upsertEmployeeOnboardingField>>, TError,{data: UpsertEmployeeOnboardingFieldSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof upsertEmployeeOnboardingField>>,
        TError,
        {data: UpsertEmployeeOnboardingFieldSchema},
        TContext
      > => {

      const mutationOptions = getUpsertEmployeeOnboardingFieldMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Gets employee onboarding field by ID
 */
export const getEmployeeOnboardingField = (
    id: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<EmployeeOnboardingFieldDetailsSchema>> => {
    
    
    return axios.default.get(
      `/api/EmployeeOnboardingManager/Fields/${id}`,options
    );
  }


export const getGetEmployeeOnboardingFieldQueryKey = (id: number,) => {
    return [`/api/EmployeeOnboardingManager/Fields/${id}`] as const;
    }

    
export const getGetEmployeeOnboardingFieldQueryOptions = <TData = Awaited<ReturnType<typeof getEmployeeOnboardingField>>, TError = AxiosError<unknown>>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeeOnboardingField>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEmployeeOnboardingFieldQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEmployeeOnboardingField>>> = ({ signal }) => getEmployeeOnboardingField(id, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEmployeeOnboardingField>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEmployeeOnboardingFieldQueryResult = NonNullable<Awaited<ReturnType<typeof getEmployeeOnboardingField>>>
export type GetEmployeeOnboardingFieldQueryError = AxiosError<unknown>


export function useGetEmployeeOnboardingField<TData = Awaited<ReturnType<typeof getEmployeeOnboardingField>>, TError = AxiosError<unknown>>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeeOnboardingField>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmployeeOnboardingField>>,
          TError,
          Awaited<ReturnType<typeof getEmployeeOnboardingField>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmployeeOnboardingField<TData = Awaited<ReturnType<typeof getEmployeeOnboardingField>>, TError = AxiosError<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeeOnboardingField>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmployeeOnboardingField>>,
          TError,
          Awaited<ReturnType<typeof getEmployeeOnboardingField>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmployeeOnboardingField<TData = Awaited<ReturnType<typeof getEmployeeOnboardingField>>, TError = AxiosError<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeeOnboardingField>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Gets employee onboarding field by ID
 */

export function useGetEmployeeOnboardingField<TData = Awaited<ReturnType<typeof getEmployeeOnboardingField>>, TError = AxiosError<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeeOnboardingField>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEmployeeOnboardingFieldQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Deletes employee onboarding field
 */
export const deleteEmployeeOnboardingField = (
    id: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.default.delete(
      `/api/EmployeeOnboardingManager/Fields/${id}`,options
    );
  }



export const getDeleteEmployeeOnboardingFieldMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteEmployeeOnboardingField>>, TError,{id: number}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof deleteEmployeeOnboardingField>>, TError,{id: number}, TContext> => {
    
const mutationKey = ['deleteEmployeeOnboardingField'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteEmployeeOnboardingField>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteEmployeeOnboardingField(id,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteEmployeeOnboardingFieldMutationResult = NonNullable<Awaited<ReturnType<typeof deleteEmployeeOnboardingField>>>
    
    export type DeleteEmployeeOnboardingFieldMutationError = AxiosError<unknown>

    /**
 * @summary Deletes employee onboarding field
 */
export const useDeleteEmployeeOnboardingField = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteEmployeeOnboardingField>>, TError,{id: number}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof deleteEmployeeOnboardingField>>,
        TError,
        {id: number},
        TContext
      > => {

      const mutationOptions = getDeleteEmployeeOnboardingFieldMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Gets employee onboarding flows
 */
export const getEmployeeOnboardingFlows = (
    params?: GetEmployeeOnboardingFlowsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<EmployeeOnboardingFlowSchema[]>> => {
    
    
    return axios.default.get(
      `/api/EmployeeOnboardingManager/Flows`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getGetEmployeeOnboardingFlowsQueryKey = (params?: GetEmployeeOnboardingFlowsParams,) => {
    return [`/api/EmployeeOnboardingManager/Flows`, ...(params ? [params]: [])] as const;
    }

    
export const getGetEmployeeOnboardingFlowsQueryOptions = <TData = Awaited<ReturnType<typeof getEmployeeOnboardingFlows>>, TError = AxiosError<unknown>>(params?: GetEmployeeOnboardingFlowsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeeOnboardingFlows>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEmployeeOnboardingFlowsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEmployeeOnboardingFlows>>> = ({ signal }) => getEmployeeOnboardingFlows(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEmployeeOnboardingFlows>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEmployeeOnboardingFlowsQueryResult = NonNullable<Awaited<ReturnType<typeof getEmployeeOnboardingFlows>>>
export type GetEmployeeOnboardingFlowsQueryError = AxiosError<unknown>


export function useGetEmployeeOnboardingFlows<TData = Awaited<ReturnType<typeof getEmployeeOnboardingFlows>>, TError = AxiosError<unknown>>(
 params: undefined |  GetEmployeeOnboardingFlowsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeeOnboardingFlows>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmployeeOnboardingFlows>>,
          TError,
          Awaited<ReturnType<typeof getEmployeeOnboardingFlows>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmployeeOnboardingFlows<TData = Awaited<ReturnType<typeof getEmployeeOnboardingFlows>>, TError = AxiosError<unknown>>(
 params?: GetEmployeeOnboardingFlowsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeeOnboardingFlows>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmployeeOnboardingFlows>>,
          TError,
          Awaited<ReturnType<typeof getEmployeeOnboardingFlows>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmployeeOnboardingFlows<TData = Awaited<ReturnType<typeof getEmployeeOnboardingFlows>>, TError = AxiosError<unknown>>(
 params?: GetEmployeeOnboardingFlowsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeeOnboardingFlows>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Gets employee onboarding flows
 */

export function useGetEmployeeOnboardingFlows<TData = Awaited<ReturnType<typeof getEmployeeOnboardingFlows>>, TError = AxiosError<unknown>>(
 params?: GetEmployeeOnboardingFlowsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeeOnboardingFlows>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEmployeeOnboardingFlowsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Inserts employee onboarding flow
 */
export const insertEmployeeOnboardingFlow = (
    insertEmployeeOnboardingFlowSchema: InsertEmployeeOnboardingFlowSchema, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<RecordCreatedResultSchema>> => {
    
    
    return axios.default.post(
      `/api/EmployeeOnboardingManager/Flows`,
      insertEmployeeOnboardingFlowSchema,options
    );
  }



export const getInsertEmployeeOnboardingFlowMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof insertEmployeeOnboardingFlow>>, TError,{data: InsertEmployeeOnboardingFlowSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof insertEmployeeOnboardingFlow>>, TError,{data: InsertEmployeeOnboardingFlowSchema}, TContext> => {
    
const mutationKey = ['insertEmployeeOnboardingFlow'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof insertEmployeeOnboardingFlow>>, {data: InsertEmployeeOnboardingFlowSchema}> = (props) => {
          const {data} = props ?? {};

          return  insertEmployeeOnboardingFlow(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type InsertEmployeeOnboardingFlowMutationResult = NonNullable<Awaited<ReturnType<typeof insertEmployeeOnboardingFlow>>>
    export type InsertEmployeeOnboardingFlowMutationBody = InsertEmployeeOnboardingFlowSchema
    export type InsertEmployeeOnboardingFlowMutationError = AxiosError<unknown>

    /**
 * @summary Inserts employee onboarding flow
 */
export const useInsertEmployeeOnboardingFlow = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof insertEmployeeOnboardingFlow>>, TError,{data: InsertEmployeeOnboardingFlowSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof insertEmployeeOnboardingFlow>>,
        TError,
        {data: InsertEmployeeOnboardingFlowSchema},
        TContext
      > => {

      const mutationOptions = getInsertEmployeeOnboardingFlowMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getFlowConfig = (
    flowId: number,
    providerId: 1, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<BackgroundCheckFlowConfigDtoSchema>> => {
    
    
    return axios.default.get(
      `/api/EmployeeOnboardingManager/Flows/${flowId}/BackgroundCheck/${providerId}`,options
    );
  }


export const getGetFlowConfigQueryKey = (flowId: number,
    providerId: 1,) => {
    return [`/api/EmployeeOnboardingManager/Flows/${flowId}/BackgroundCheck/${providerId}`] as const;
    }

    
export const getGetFlowConfigQueryOptions = <TData = Awaited<ReturnType<typeof getFlowConfig>>, TError = AxiosError<unknown>>(flowId: number,
    providerId: 1, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFlowConfig>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFlowConfigQueryKey(flowId,providerId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFlowConfig>>> = ({ signal }) => getFlowConfig(flowId,providerId, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(flowId && providerId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFlowConfig>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetFlowConfigQueryResult = NonNullable<Awaited<ReturnType<typeof getFlowConfig>>>
export type GetFlowConfigQueryError = AxiosError<unknown>


export function useGetFlowConfig<TData = Awaited<ReturnType<typeof getFlowConfig>>, TError = AxiosError<unknown>>(
 flowId: number,
    providerId: 1, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFlowConfig>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFlowConfig>>,
          TError,
          Awaited<ReturnType<typeof getFlowConfig>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFlowConfig<TData = Awaited<ReturnType<typeof getFlowConfig>>, TError = AxiosError<unknown>>(
 flowId: number,
    providerId: 1, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFlowConfig>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFlowConfig>>,
          TError,
          Awaited<ReturnType<typeof getFlowConfig>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFlowConfig<TData = Awaited<ReturnType<typeof getFlowConfig>>, TError = AxiosError<unknown>>(
 flowId: number,
    providerId: 1, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFlowConfig>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetFlowConfig<TData = Awaited<ReturnType<typeof getFlowConfig>>, TError = AxiosError<unknown>>(
 flowId: number,
    providerId: 1, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFlowConfig>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetFlowConfigQueryOptions(flowId,providerId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const upsertFlowConfig = (
    flowId: number,
    providerId: 1,
    upsertBackgroundCheckFlowConfigRequestSchema: UpsertBackgroundCheckFlowConfigRequestSchema, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<BackgroundCheckFlowConfigDtoSchema>> => {
    
    
    return axios.default.put(
      `/api/EmployeeOnboardingManager/Flows/${flowId}/BackgroundCheck/${providerId}`,
      upsertBackgroundCheckFlowConfigRequestSchema,options
    );
  }



export const getUpsertFlowConfigMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof upsertFlowConfig>>, TError,{flowId: number;providerId: 1;data: UpsertBackgroundCheckFlowConfigRequestSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof upsertFlowConfig>>, TError,{flowId: number;providerId: 1;data: UpsertBackgroundCheckFlowConfigRequestSchema}, TContext> => {
    
const mutationKey = ['upsertFlowConfig'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof upsertFlowConfig>>, {flowId: number;providerId: 1;data: UpsertBackgroundCheckFlowConfigRequestSchema}> = (props) => {
          const {flowId,providerId,data} = props ?? {};

          return  upsertFlowConfig(flowId,providerId,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpsertFlowConfigMutationResult = NonNullable<Awaited<ReturnType<typeof upsertFlowConfig>>>
    export type UpsertFlowConfigMutationBody = UpsertBackgroundCheckFlowConfigRequestSchema
    export type UpsertFlowConfigMutationError = AxiosError<unknown>

    export const useUpsertFlowConfig = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof upsertFlowConfig>>, TError,{flowId: number;providerId: 1;data: UpsertBackgroundCheckFlowConfigRequestSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof upsertFlowConfig>>,
        TError,
        {flowId: number;providerId: 1;data: UpsertBackgroundCheckFlowConfigRequestSchema},
        TContext
      > => {

      const mutationOptions = getUpsertFlowConfigMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const deleteFlowConfig = (
    flowId: number,
    providerId: 1, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.default.delete(
      `/api/EmployeeOnboardingManager/Flows/${flowId}/BackgroundCheck/${providerId}`,options
    );
  }



export const getDeleteFlowConfigMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteFlowConfig>>, TError,{flowId: number;providerId: 1}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof deleteFlowConfig>>, TError,{flowId: number;providerId: 1}, TContext> => {
    
const mutationKey = ['deleteFlowConfig'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteFlowConfig>>, {flowId: number;providerId: 1}> = (props) => {
          const {flowId,providerId} = props ?? {};

          return  deleteFlowConfig(flowId,providerId,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteFlowConfigMutationResult = NonNullable<Awaited<ReturnType<typeof deleteFlowConfig>>>
    
    export type DeleteFlowConfigMutationError = AxiosError<unknown>

    export const useDeleteFlowConfig = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteFlowConfig>>, TError,{flowId: number;providerId: 1}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof deleteFlowConfig>>,
        TError,
        {flowId: number;providerId: 1},
        TContext
      > => {

      const mutationOptions = getDeleteFlowConfigMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Gets employee onboarding flow by ID
 */
export const getEmployeeOnboardingFlow = (
    id: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<EmployeeOnboardingFlowDetailsSchema>> => {
    
    
    return axios.default.get(
      `/api/EmployeeOnboardingManager/Flows/${id}`,options
    );
  }


export const getGetEmployeeOnboardingFlowQueryKey = (id: number,) => {
    return [`/api/EmployeeOnboardingManager/Flows/${id}`] as const;
    }

    
export const getGetEmployeeOnboardingFlowQueryOptions = <TData = Awaited<ReturnType<typeof getEmployeeOnboardingFlow>>, TError = AxiosError<unknown>>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeeOnboardingFlow>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEmployeeOnboardingFlowQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEmployeeOnboardingFlow>>> = ({ signal }) => getEmployeeOnboardingFlow(id, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEmployeeOnboardingFlow>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEmployeeOnboardingFlowQueryResult = NonNullable<Awaited<ReturnType<typeof getEmployeeOnboardingFlow>>>
export type GetEmployeeOnboardingFlowQueryError = AxiosError<unknown>


export function useGetEmployeeOnboardingFlow<TData = Awaited<ReturnType<typeof getEmployeeOnboardingFlow>>, TError = AxiosError<unknown>>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeeOnboardingFlow>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmployeeOnboardingFlow>>,
          TError,
          Awaited<ReturnType<typeof getEmployeeOnboardingFlow>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmployeeOnboardingFlow<TData = Awaited<ReturnType<typeof getEmployeeOnboardingFlow>>, TError = AxiosError<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeeOnboardingFlow>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmployeeOnboardingFlow>>,
          TError,
          Awaited<ReturnType<typeof getEmployeeOnboardingFlow>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmployeeOnboardingFlow<TData = Awaited<ReturnType<typeof getEmployeeOnboardingFlow>>, TError = AxiosError<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeeOnboardingFlow>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Gets employee onboarding flow by ID
 */

export function useGetEmployeeOnboardingFlow<TData = Awaited<ReturnType<typeof getEmployeeOnboardingFlow>>, TError = AxiosError<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeeOnboardingFlow>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEmployeeOnboardingFlowQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Updates employee onboarding flow
 */
export const updateEmployeeOnboardingFlow = (
    id: number,
    updateEmployeeOnboardingFlowSchema: UpdateEmployeeOnboardingFlowSchema, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.default.put(
      `/api/EmployeeOnboardingManager/Flows/${id}`,
      updateEmployeeOnboardingFlowSchema,options
    );
  }



export const getUpdateEmployeeOnboardingFlowMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateEmployeeOnboardingFlow>>, TError,{id: number;data: UpdateEmployeeOnboardingFlowSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof updateEmployeeOnboardingFlow>>, TError,{id: number;data: UpdateEmployeeOnboardingFlowSchema}, TContext> => {
    
const mutationKey = ['updateEmployeeOnboardingFlow'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateEmployeeOnboardingFlow>>, {id: number;data: UpdateEmployeeOnboardingFlowSchema}> = (props) => {
          const {id,data} = props ?? {};

          return  updateEmployeeOnboardingFlow(id,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateEmployeeOnboardingFlowMutationResult = NonNullable<Awaited<ReturnType<typeof updateEmployeeOnboardingFlow>>>
    export type UpdateEmployeeOnboardingFlowMutationBody = UpdateEmployeeOnboardingFlowSchema
    export type UpdateEmployeeOnboardingFlowMutationError = AxiosError<unknown>

    /**
 * @summary Updates employee onboarding flow
 */
export const useUpdateEmployeeOnboardingFlow = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateEmployeeOnboardingFlow>>, TError,{id: number;data: UpdateEmployeeOnboardingFlowSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof updateEmployeeOnboardingFlow>>,
        TError,
        {id: number;data: UpdateEmployeeOnboardingFlowSchema},
        TContext
      > => {

      const mutationOptions = getUpdateEmployeeOnboardingFlowMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Deletes employee onboarding flow by ID
 */
export const deleteEmployeeOnboardingFlow = (
    id: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.default.delete(
      `/api/EmployeeOnboardingManager/Flows/${id}`,options
    );
  }



export const getDeleteEmployeeOnboardingFlowMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteEmployeeOnboardingFlow>>, TError,{id: number}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof deleteEmployeeOnboardingFlow>>, TError,{id: number}, TContext> => {
    
const mutationKey = ['deleteEmployeeOnboardingFlow'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteEmployeeOnboardingFlow>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteEmployeeOnboardingFlow(id,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteEmployeeOnboardingFlowMutationResult = NonNullable<Awaited<ReturnType<typeof deleteEmployeeOnboardingFlow>>>
    
    export type DeleteEmployeeOnboardingFlowMutationError = AxiosError<unknown>

    /**
 * @summary Deletes employee onboarding flow by ID
 */
export const useDeleteEmployeeOnboardingFlow = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteEmployeeOnboardingFlow>>, TError,{id: number}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof deleteEmployeeOnboardingFlow>>,
        TError,
        {id: number},
        TContext
      > => {

      const mutationOptions = getDeleteEmployeeOnboardingFlowMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Duplicates employee onboarding flow
 */
export const duplicateEmployeeOnboardingFlow = (
    id: number,
    duplicateEmployeeOnboardingFlowSchema: DuplicateEmployeeOnboardingFlowSchema, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<EmployeeOnboardingFlowDetailsSchema>> => {
    
    
    return axios.default.post(
      `/api/EmployeeOnboardingManager/Flows/${id}`,
      duplicateEmployeeOnboardingFlowSchema,options
    );
  }



export const getDuplicateEmployeeOnboardingFlowMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof duplicateEmployeeOnboardingFlow>>, TError,{id: number;data: DuplicateEmployeeOnboardingFlowSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof duplicateEmployeeOnboardingFlow>>, TError,{id: number;data: DuplicateEmployeeOnboardingFlowSchema}, TContext> => {
    
const mutationKey = ['duplicateEmployeeOnboardingFlow'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof duplicateEmployeeOnboardingFlow>>, {id: number;data: DuplicateEmployeeOnboardingFlowSchema}> = (props) => {
          const {id,data} = props ?? {};

          return  duplicateEmployeeOnboardingFlow(id,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DuplicateEmployeeOnboardingFlowMutationResult = NonNullable<Awaited<ReturnType<typeof duplicateEmployeeOnboardingFlow>>>
    export type DuplicateEmployeeOnboardingFlowMutationBody = DuplicateEmployeeOnboardingFlowSchema
    export type DuplicateEmployeeOnboardingFlowMutationError = AxiosError<unknown>

    /**
 * @summary Duplicates employee onboarding flow
 */
export const useDuplicateEmployeeOnboardingFlow = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof duplicateEmployeeOnboardingFlow>>, TError,{id: number;data: DuplicateEmployeeOnboardingFlowSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof duplicateEmployeeOnboardingFlow>>,
        TError,
        {id: number;data: DuplicateEmployeeOnboardingFlowSchema},
        TContext
      > => {

      const mutationOptions = getDuplicateEmployeeOnboardingFlowMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Updates employee onboarding flow status
 */
export const updateEmployeeOnboardingFlowStatus = (
    id: number,
    updateEmployeeOnboardingFlowStatusSchema: UpdateEmployeeOnboardingFlowStatusSchema, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<EmployeeOnboardingFlowDetailsSchema>> => {
    
    
    return axios.default.post(
      `/api/EmployeeOnboardingManager/Flows/${id}/Status`,
      updateEmployeeOnboardingFlowStatusSchema,options
    );
  }



export const getUpdateEmployeeOnboardingFlowStatusMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateEmployeeOnboardingFlowStatus>>, TError,{id: number;data: UpdateEmployeeOnboardingFlowStatusSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof updateEmployeeOnboardingFlowStatus>>, TError,{id: number;data: UpdateEmployeeOnboardingFlowStatusSchema}, TContext> => {
    
const mutationKey = ['updateEmployeeOnboardingFlowStatus'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateEmployeeOnboardingFlowStatus>>, {id: number;data: UpdateEmployeeOnboardingFlowStatusSchema}> = (props) => {
          const {id,data} = props ?? {};

          return  updateEmployeeOnboardingFlowStatus(id,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateEmployeeOnboardingFlowStatusMutationResult = NonNullable<Awaited<ReturnType<typeof updateEmployeeOnboardingFlowStatus>>>
    export type UpdateEmployeeOnboardingFlowStatusMutationBody = UpdateEmployeeOnboardingFlowStatusSchema
    export type UpdateEmployeeOnboardingFlowStatusMutationError = AxiosError<unknown>

    /**
 * @summary Updates employee onboarding flow status
 */
export const useUpdateEmployeeOnboardingFlowStatus = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateEmployeeOnboardingFlowStatus>>, TError,{id: number;data: UpdateEmployeeOnboardingFlowStatusSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof updateEmployeeOnboardingFlowStatus>>,
        TError,
        {id: number;data: UpdateEmployeeOnboardingFlowStatusSchema},
        TContext
      > => {

      const mutationOptions = getUpdateEmployeeOnboardingFlowStatusMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Updates the configuration of a specific step within an onboarding flow
 */
export const updateOnboardingFlowStepConfiguration = (
    id: number,
    stepId: number,
    updateEmployeeOnboardingStepConfigurationSchema: UpdateEmployeeOnboardingStepConfigurationSchema, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<EmployeeOnboardingFlowDetailsSchema>> => {
    
    
    return axios.default.patch(
      `/api/EmployeeOnboardingManager/Flows/${id}/Steps/${stepId}`,
      updateEmployeeOnboardingStepConfigurationSchema,options
    );
  }



export const getUpdateOnboardingFlowStepConfigurationMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOnboardingFlowStepConfiguration>>, TError,{id: number;stepId: number;data: UpdateEmployeeOnboardingStepConfigurationSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof updateOnboardingFlowStepConfiguration>>, TError,{id: number;stepId: number;data: UpdateEmployeeOnboardingStepConfigurationSchema}, TContext> => {
    
const mutationKey = ['updateOnboardingFlowStepConfiguration'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateOnboardingFlowStepConfiguration>>, {id: number;stepId: number;data: UpdateEmployeeOnboardingStepConfigurationSchema}> = (props) => {
          const {id,stepId,data} = props ?? {};

          return  updateOnboardingFlowStepConfiguration(id,stepId,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateOnboardingFlowStepConfigurationMutationResult = NonNullable<Awaited<ReturnType<typeof updateOnboardingFlowStepConfiguration>>>
    export type UpdateOnboardingFlowStepConfigurationMutationBody = UpdateEmployeeOnboardingStepConfigurationSchema
    export type UpdateOnboardingFlowStepConfigurationMutationError = AxiosError<unknown>

    /**
 * @summary Updates the configuration of a specific step within an onboarding flow
 */
export const useUpdateOnboardingFlowStepConfiguration = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOnboardingFlowStepConfiguration>>, TError,{id: number;stepId: number;data: UpdateEmployeeOnboardingStepConfigurationSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof updateOnboardingFlowStepConfiguration>>,
        TError,
        {id: number;stepId: number;data: UpdateEmployeeOnboardingStepConfigurationSchema},
        TContext
      > => {

      const mutationOptions = getUpdateOnboardingFlowStepConfigurationMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Gets onboarding flows matching the given employee profile
 */
export const getMatchingFlows = (
    getMatchingFlowsRequestSchema: GetMatchingFlowsRequestSchema, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<MatchingEmployeeOnboardingFlowSchema[]>> => {
    
    
    return axios.default.post(
      `/api/EmployeeOnboardingManager/Flows/Matching`,
      getMatchingFlowsRequestSchema,options
    );
  }



export const getGetMatchingFlowsMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getMatchingFlows>>, TError,{data: GetMatchingFlowsRequestSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof getMatchingFlows>>, TError,{data: GetMatchingFlowsRequestSchema}, TContext> => {
    
const mutationKey = ['getMatchingFlows'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getMatchingFlows>>, {data: GetMatchingFlowsRequestSchema}> = (props) => {
          const {data} = props ?? {};

          return  getMatchingFlows(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type GetMatchingFlowsMutationResult = NonNullable<Awaited<ReturnType<typeof getMatchingFlows>>>
    export type GetMatchingFlowsMutationBody = GetMatchingFlowsRequestSchema
    export type GetMatchingFlowsMutationError = AxiosError<unknown>

    /**
 * @summary Gets onboarding flows matching the given employee profile
 */
export const useGetMatchingFlows = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getMatchingFlows>>, TError,{data: GetMatchingFlowsRequestSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof getMatchingFlows>>,
        TError,
        {data: GetMatchingFlowsRequestSchema},
        TContext
      > => {

      const mutationOptions = getGetMatchingFlowsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Gets default system onboarding flow steps
 */
export const getDefaultSystemOnboardingFlowSteps = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<FlowsEmployeeOnboardingStepSchema[]>> => {
    
    
    return axios.default.get(
      `/api/EmployeeOnboardingManager/Flows/SystemSteps`,options
    );
  }


export const getGetDefaultSystemOnboardingFlowStepsQueryKey = () => {
    return [`/api/EmployeeOnboardingManager/Flows/SystemSteps`] as const;
    }

    
export const getGetDefaultSystemOnboardingFlowStepsQueryOptions = <TData = Awaited<ReturnType<typeof getDefaultSystemOnboardingFlowSteps>>, TError = AxiosError<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDefaultSystemOnboardingFlowSteps>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDefaultSystemOnboardingFlowStepsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDefaultSystemOnboardingFlowSteps>>> = ({ signal }) => getDefaultSystemOnboardingFlowSteps({ signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDefaultSystemOnboardingFlowSteps>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDefaultSystemOnboardingFlowStepsQueryResult = NonNullable<Awaited<ReturnType<typeof getDefaultSystemOnboardingFlowSteps>>>
export type GetDefaultSystemOnboardingFlowStepsQueryError = AxiosError<unknown>


export function useGetDefaultSystemOnboardingFlowSteps<TData = Awaited<ReturnType<typeof getDefaultSystemOnboardingFlowSteps>>, TError = AxiosError<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDefaultSystemOnboardingFlowSteps>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDefaultSystemOnboardingFlowSteps>>,
          TError,
          Awaited<ReturnType<typeof getDefaultSystemOnboardingFlowSteps>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDefaultSystemOnboardingFlowSteps<TData = Awaited<ReturnType<typeof getDefaultSystemOnboardingFlowSteps>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDefaultSystemOnboardingFlowSteps>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDefaultSystemOnboardingFlowSteps>>,
          TError,
          Awaited<ReturnType<typeof getDefaultSystemOnboardingFlowSteps>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDefaultSystemOnboardingFlowSteps<TData = Awaited<ReturnType<typeof getDefaultSystemOnboardingFlowSteps>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDefaultSystemOnboardingFlowSteps>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Gets default system onboarding flow steps
 */

export function useGetDefaultSystemOnboardingFlowSteps<TData = Awaited<ReturnType<typeof getDefaultSystemOnboardingFlowSteps>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDefaultSystemOnboardingFlowSteps>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDefaultSystemOnboardingFlowStepsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Gets the onboarding welcome screen configuration
 */
export const getWelcomeScreenConfig = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WelcomeScreenConfigSchema>> => {
    
    
    return axios.default.get(
      `/api/EmployeeOnboardingManager/WelcomeScreen`,options
    );
  }


export const getGetWelcomeScreenConfigQueryKey = () => {
    return [`/api/EmployeeOnboardingManager/WelcomeScreen`] as const;
    }

    
export const getGetWelcomeScreenConfigQueryOptions = <TData = Awaited<ReturnType<typeof getWelcomeScreenConfig>>, TError = AxiosError<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWelcomeScreenConfig>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWelcomeScreenConfigQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWelcomeScreenConfig>>> = ({ signal }) => getWelcomeScreenConfig({ signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getWelcomeScreenConfig>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetWelcomeScreenConfigQueryResult = NonNullable<Awaited<ReturnType<typeof getWelcomeScreenConfig>>>
export type GetWelcomeScreenConfigQueryError = AxiosError<unknown>


export function useGetWelcomeScreenConfig<TData = Awaited<ReturnType<typeof getWelcomeScreenConfig>>, TError = AxiosError<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWelcomeScreenConfig>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWelcomeScreenConfig>>,
          TError,
          Awaited<ReturnType<typeof getWelcomeScreenConfig>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWelcomeScreenConfig<TData = Awaited<ReturnType<typeof getWelcomeScreenConfig>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWelcomeScreenConfig>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWelcomeScreenConfig>>,
          TError,
          Awaited<ReturnType<typeof getWelcomeScreenConfig>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWelcomeScreenConfig<TData = Awaited<ReturnType<typeof getWelcomeScreenConfig>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWelcomeScreenConfig>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Gets the onboarding welcome screen configuration
 */

export function useGetWelcomeScreenConfig<TData = Awaited<ReturnType<typeof getWelcomeScreenConfig>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWelcomeScreenConfig>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetWelcomeScreenConfigQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Updates the onboarding welcome screen configuration
 */
export const updateWelcomeScreenConfig = (
    updateWelcomeScreenConfigSchema: UpdateWelcomeScreenConfigSchema, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.default.put(
      `/api/EmployeeOnboardingManager/WelcomeScreen`,
      updateWelcomeScreenConfigSchema,options
    );
  }



export const getUpdateWelcomeScreenConfigMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateWelcomeScreenConfig>>, TError,{data: UpdateWelcomeScreenConfigSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof updateWelcomeScreenConfig>>, TError,{data: UpdateWelcomeScreenConfigSchema}, TContext> => {
    
const mutationKey = ['updateWelcomeScreenConfig'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateWelcomeScreenConfig>>, {data: UpdateWelcomeScreenConfigSchema}> = (props) => {
          const {data} = props ?? {};

          return  updateWelcomeScreenConfig(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateWelcomeScreenConfigMutationResult = NonNullable<Awaited<ReturnType<typeof updateWelcomeScreenConfig>>>
    export type UpdateWelcomeScreenConfigMutationBody = UpdateWelcomeScreenConfigSchema
    export type UpdateWelcomeScreenConfigMutationError = AxiosError<unknown>

    /**
 * @summary Updates the onboarding welcome screen configuration
 */
export const useUpdateWelcomeScreenConfig = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateWelcomeScreenConfig>>, TError,{data: UpdateWelcomeScreenConfigSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof updateWelcomeScreenConfig>>,
        TError,
        {data: UpdateWelcomeScreenConfigSchema},
        TContext
      > => {

      const mutationOptions = getUpdateWelcomeScreenConfigMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Uploads a logo for the welcome screen
 */
export const uploadWelcomeScreenLogo = (
    uploadWelcomeScreenLogoBody: UploadWelcomeScreenLogoBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    const formData = createFormData(uploadWelcomeScreenLogoBody)
    return axios.default.post(
      `/api/EmployeeOnboardingManager/WelcomeScreen/Logo`,
      formData,options
    );
  }



export const getUploadWelcomeScreenLogoMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadWelcomeScreenLogo>>, TError,{data: UploadWelcomeScreenLogoBody}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof uploadWelcomeScreenLogo>>, TError,{data: UploadWelcomeScreenLogoBody}, TContext> => {
    
const mutationKey = ['uploadWelcomeScreenLogo'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof uploadWelcomeScreenLogo>>, {data: UploadWelcomeScreenLogoBody}> = (props) => {
          const {data} = props ?? {};

          return  uploadWelcomeScreenLogo(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UploadWelcomeScreenLogoMutationResult = NonNullable<Awaited<ReturnType<typeof uploadWelcomeScreenLogo>>>
    export type UploadWelcomeScreenLogoMutationBody = UploadWelcomeScreenLogoBody
    export type UploadWelcomeScreenLogoMutationError = AxiosError<unknown>

    /**
 * @summary Uploads a logo for the welcome screen
 */
export const useUploadWelcomeScreenLogo = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadWelcomeScreenLogo>>, TError,{data: UploadWelcomeScreenLogoBody}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof uploadWelcomeScreenLogo>>,
        TError,
        {data: UploadWelcomeScreenLogoBody},
        TContext
      > => {

      const mutationOptions = getUploadWelcomeScreenLogoMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Deletes the welcome screen logo
 */
export const deleteWelcomeScreenLogo = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.default.delete(
      `/api/EmployeeOnboardingManager/WelcomeScreen/Logo`,options
    );
  }



export const getDeleteWelcomeScreenLogoMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteWelcomeScreenLogo>>, TError,void, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof deleteWelcomeScreenLogo>>, TError,void, TContext> => {
    
const mutationKey = ['deleteWelcomeScreenLogo'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteWelcomeScreenLogo>>, void> = () => {
          

          return  deleteWelcomeScreenLogo(axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteWelcomeScreenLogoMutationResult = NonNullable<Awaited<ReturnType<typeof deleteWelcomeScreenLogo>>>
    
    export type DeleteWelcomeScreenLogoMutationError = AxiosError<unknown>

    /**
 * @summary Deletes the welcome screen logo
 */
export const useDeleteWelcomeScreenLogo = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteWelcomeScreenLogo>>, TError,void, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof deleteWelcomeScreenLogo>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getDeleteWelcomeScreenLogoMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Gets the welcome screen logo image
 */
export const getWelcomeScreenConfigLogo = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.default.get(
      `/api/EmployeeOnboardingManager/WelcomeScreen/Logo`,options
    );
  }


export const getGetWelcomeScreenConfigLogoQueryKey = () => {
    return [`/api/EmployeeOnboardingManager/WelcomeScreen/Logo`] as const;
    }

    
export const getGetWelcomeScreenConfigLogoQueryOptions = <TData = Awaited<ReturnType<typeof getWelcomeScreenConfigLogo>>, TError = AxiosError<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWelcomeScreenConfigLogo>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWelcomeScreenConfigLogoQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWelcomeScreenConfigLogo>>> = ({ signal }) => getWelcomeScreenConfigLogo({ signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getWelcomeScreenConfigLogo>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetWelcomeScreenConfigLogoQueryResult = NonNullable<Awaited<ReturnType<typeof getWelcomeScreenConfigLogo>>>
export type GetWelcomeScreenConfigLogoQueryError = AxiosError<unknown>


export function useGetWelcomeScreenConfigLogo<TData = Awaited<ReturnType<typeof getWelcomeScreenConfigLogo>>, TError = AxiosError<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWelcomeScreenConfigLogo>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWelcomeScreenConfigLogo>>,
          TError,
          Awaited<ReturnType<typeof getWelcomeScreenConfigLogo>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWelcomeScreenConfigLogo<TData = Awaited<ReturnType<typeof getWelcomeScreenConfigLogo>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWelcomeScreenConfigLogo>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWelcomeScreenConfigLogo>>,
          TError,
          Awaited<ReturnType<typeof getWelcomeScreenConfigLogo>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWelcomeScreenConfigLogo<TData = Awaited<ReturnType<typeof getWelcomeScreenConfigLogo>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWelcomeScreenConfigLogo>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Gets the welcome screen logo image
 */

export function useGetWelcomeScreenConfigLogo<TData = Awaited<ReturnType<typeof getWelcomeScreenConfigLogo>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWelcomeScreenConfigLogo>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetWelcomeScreenConfigLogoQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getEmployees = (
    employeeListFilterSchema: EmployeeListFilterSchema, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<EmployeeListSchema>> => {
    
    
    return axios.default.post(
      `/api/employees`,
      employeeListFilterSchema,options
    );
  }



export const getGetEmployeesMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getEmployees>>, TError,{data: EmployeeListFilterSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof getEmployees>>, TError,{data: EmployeeListFilterSchema}, TContext> => {
    
const mutationKey = ['getEmployees'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getEmployees>>, {data: EmployeeListFilterSchema}> = (props) => {
          const {data} = props ?? {};

          return  getEmployees(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type GetEmployeesMutationResult = NonNullable<Awaited<ReturnType<typeof getEmployees>>>
    export type GetEmployeesMutationBody = EmployeeListFilterSchema
    export type GetEmployeesMutationError = AxiosError<unknown>

    export const useGetEmployees = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getEmployees>>, TError,{data: EmployeeListFilterSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof getEmployees>>,
        TError,
        {data: EmployeeListFilterSchema},
        TContext
      > => {

      const mutationOptions = getGetEmployeesMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Activates direct deposit accounts (skips pre-note)
 */
export const skipPreNote = (
    employeeNumber: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.default.post(
      `/api/Employees/${employeeNumber}/DirectDeposit/Activation`,undefined,options
    );
  }



export const getSkipPreNoteMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof skipPreNote>>, TError,{employeeNumber: number}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof skipPreNote>>, TError,{employeeNumber: number}, TContext> => {
    
const mutationKey = ['skipPreNote'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof skipPreNote>>, {employeeNumber: number}> = (props) => {
          const {employeeNumber} = props ?? {};

          return  skipPreNote(employeeNumber,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SkipPreNoteMutationResult = NonNullable<Awaited<ReturnType<typeof skipPreNote>>>
    
    export type SkipPreNoteMutationError = AxiosError<unknown>

    /**
 * @summary Activates direct deposit accounts (skips pre-note)
 */
export const useSkipPreNote = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof skipPreNote>>, TError,{employeeNumber: number}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof skipPreNote>>,
        TError,
        {employeeNumber: number},
        TContext
      > => {

      const mutationOptions = getSkipPreNoteMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getDocument = (
    employeeNumber: number,
    params?: GetDocumentParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Blob>> => {
    
    
    return axios.default.get(
      `/api/Employees/${employeeNumber}/Documents`,{
        responseType: 'blob',
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getGetDocumentQueryKey = (employeeNumber: number,
    params?: GetDocumentParams,) => {
    return [`/api/Employees/${employeeNumber}/Documents`, ...(params ? [params]: [])] as const;
    }

    
export const getGetDocumentQueryOptions = <TData = Awaited<ReturnType<typeof getDocument>>, TError = AxiosError<unknown>>(employeeNumber: number,
    params?: GetDocumentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocument>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDocumentQueryKey(employeeNumber,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDocument>>> = ({ signal }) => getDocument(employeeNumber,params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(employeeNumber), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDocument>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDocumentQueryResult = NonNullable<Awaited<ReturnType<typeof getDocument>>>
export type GetDocumentQueryError = AxiosError<unknown>


export function useGetDocument<TData = Awaited<ReturnType<typeof getDocument>>, TError = AxiosError<unknown>>(
 employeeNumber: number,
    params: undefined |  GetDocumentParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocument>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDocument>>,
          TError,
          Awaited<ReturnType<typeof getDocument>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDocument<TData = Awaited<ReturnType<typeof getDocument>>, TError = AxiosError<unknown>>(
 employeeNumber: number,
    params?: GetDocumentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocument>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDocument>>,
          TError,
          Awaited<ReturnType<typeof getDocument>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDocument<TData = Awaited<ReturnType<typeof getDocument>>, TError = AxiosError<unknown>>(
 employeeNumber: number,
    params?: GetDocumentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocument>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetDocument<TData = Awaited<ReturnType<typeof getDocument>>, TError = AxiosError<unknown>>(
 employeeNumber: number,
    params?: GetDocumentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocument>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDocumentQueryOptions(employeeNumber,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getEmployeeByEmpnum = (
    empnum: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<EmployeeRootSchema>> => {
    
    
    return axios.default.get(
      `/api/Employees/${empnum}`,options
    );
  }


export const getGetEmployeeByEmpnumQueryKey = (empnum: number,) => {
    return [`/api/Employees/${empnum}`] as const;
    }

    
export const getGetEmployeeByEmpnumQueryOptions = <TData = Awaited<ReturnType<typeof getEmployeeByEmpnum>>, TError = AxiosError<unknown>>(empnum: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeeByEmpnum>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEmployeeByEmpnumQueryKey(empnum);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEmployeeByEmpnum>>> = ({ signal }) => getEmployeeByEmpnum(empnum, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(empnum), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEmployeeByEmpnum>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEmployeeByEmpnumQueryResult = NonNullable<Awaited<ReturnType<typeof getEmployeeByEmpnum>>>
export type GetEmployeeByEmpnumQueryError = AxiosError<unknown>


export function useGetEmployeeByEmpnum<TData = Awaited<ReturnType<typeof getEmployeeByEmpnum>>, TError = AxiosError<unknown>>(
 empnum: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeeByEmpnum>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmployeeByEmpnum>>,
          TError,
          Awaited<ReturnType<typeof getEmployeeByEmpnum>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmployeeByEmpnum<TData = Awaited<ReturnType<typeof getEmployeeByEmpnum>>, TError = AxiosError<unknown>>(
 empnum: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeeByEmpnum>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmployeeByEmpnum>>,
          TError,
          Awaited<ReturnType<typeof getEmployeeByEmpnum>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmployeeByEmpnum<TData = Awaited<ReturnType<typeof getEmployeeByEmpnum>>, TError = AxiosError<unknown>>(
 empnum: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeeByEmpnum>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetEmployeeByEmpnum<TData = Awaited<ReturnType<typeof getEmployeeByEmpnum>>, TError = AxiosError<unknown>>(
 empnum: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeeByEmpnum>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEmployeeByEmpnumQueryOptions(empnum,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getAccrualHistory = (
    empnum: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<AccrualHistoryEntrySchema[]>> => {
    
    
    return axios.default.get(
      `/api/Employees/${empnum}/AccrualHistory`,options
    );
  }


export const getGetAccrualHistoryQueryKey = (empnum: number,) => {
    return [`/api/Employees/${empnum}/AccrualHistory`] as const;
    }

    
export const getGetAccrualHistoryQueryOptions = <TData = Awaited<ReturnType<typeof getAccrualHistory>>, TError = AxiosError<unknown>>(empnum: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccrualHistory>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAccrualHistoryQueryKey(empnum);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAccrualHistory>>> = ({ signal }) => getAccrualHistory(empnum, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(empnum), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAccrualHistory>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAccrualHistoryQueryResult = NonNullable<Awaited<ReturnType<typeof getAccrualHistory>>>
export type GetAccrualHistoryQueryError = AxiosError<unknown>


export function useGetAccrualHistory<TData = Awaited<ReturnType<typeof getAccrualHistory>>, TError = AxiosError<unknown>>(
 empnum: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccrualHistory>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAccrualHistory>>,
          TError,
          Awaited<ReturnType<typeof getAccrualHistory>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAccrualHistory<TData = Awaited<ReturnType<typeof getAccrualHistory>>, TError = AxiosError<unknown>>(
 empnum: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccrualHistory>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAccrualHistory>>,
          TError,
          Awaited<ReturnType<typeof getAccrualHistory>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAccrualHistory<TData = Awaited<ReturnType<typeof getAccrualHistory>>, TError = AxiosError<unknown>>(
 empnum: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccrualHistory>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAccrualHistory<TData = Awaited<ReturnType<typeof getAccrualHistory>>, TError = AxiosError<unknown>>(
 empnum: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccrualHistory>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAccrualHistoryQueryOptions(empnum,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const createAccrualEntry = (
    empnum: number,
    createAccrualEntryRequestSchema: CreateAccrualEntryRequestSchema, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<AccrualHistoryEntrySchema>> => {
    
    
    return axios.default.post(
      `/api/Employees/${empnum}/AccrualHistory`,
      createAccrualEntryRequestSchema,options
    );
  }



export const getCreateAccrualEntryMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAccrualEntry>>, TError,{empnum: number;data: CreateAccrualEntryRequestSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof createAccrualEntry>>, TError,{empnum: number;data: CreateAccrualEntryRequestSchema}, TContext> => {
    
const mutationKey = ['createAccrualEntry'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAccrualEntry>>, {empnum: number;data: CreateAccrualEntryRequestSchema}> = (props) => {
          const {empnum,data} = props ?? {};

          return  createAccrualEntry(empnum,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateAccrualEntryMutationResult = NonNullable<Awaited<ReturnType<typeof createAccrualEntry>>>
    export type CreateAccrualEntryMutationBody = CreateAccrualEntryRequestSchema
    export type CreateAccrualEntryMutationError = AxiosError<unknown>

    export const useCreateAccrualEntry = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAccrualEntry>>, TError,{empnum: number;data: CreateAccrualEntryRequestSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof createAccrualEntry>>,
        TError,
        {empnum: number;data: CreateAccrualEntryRequestSchema},
        TContext
      > => {

      const mutationOptions = getCreateAccrualEntryMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const updateAccrualEntry = (
    empnum: number,
    payrollNum: number,
    date: string,
    updateAccrualEntryRequestSchema: UpdateAccrualEntryRequestSchema, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<AccrualHistoryEntrySchema>> => {
    
    
    return axios.default.put(
      `/api/Employees/${empnum}/AccrualHistory/${payrollNum}/${date}`,
      updateAccrualEntryRequestSchema,options
    );
  }



export const getUpdateAccrualEntryMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAccrualEntry>>, TError,{empnum: number;payrollNum: number;date: string;data: UpdateAccrualEntryRequestSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof updateAccrualEntry>>, TError,{empnum: number;payrollNum: number;date: string;data: UpdateAccrualEntryRequestSchema}, TContext> => {
    
const mutationKey = ['updateAccrualEntry'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateAccrualEntry>>, {empnum: number;payrollNum: number;date: string;data: UpdateAccrualEntryRequestSchema}> = (props) => {
          const {empnum,payrollNum,date,data} = props ?? {};

          return  updateAccrualEntry(empnum,payrollNum,date,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateAccrualEntryMutationResult = NonNullable<Awaited<ReturnType<typeof updateAccrualEntry>>>
    export type UpdateAccrualEntryMutationBody = UpdateAccrualEntryRequestSchema
    export type UpdateAccrualEntryMutationError = AxiosError<unknown>

    export const useUpdateAccrualEntry = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAccrualEntry>>, TError,{empnum: number;payrollNum: number;date: string;data: UpdateAccrualEntryRequestSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof updateAccrualEntry>>,
        TError,
        {empnum: number;payrollNum: number;date: string;data: UpdateAccrualEntryRequestSchema},
        TContext
      > => {

      const mutationOptions = getUpdateAccrualEntryMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const deleteAccrualEntry = (
    empnum: number,
    payrollNum: number,
    date: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.default.delete(
      `/api/Employees/${empnum}/AccrualHistory/${payrollNum}/${date}`,options
    );
  }



export const getDeleteAccrualEntryMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAccrualEntry>>, TError,{empnum: number;payrollNum: number;date: string}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof deleteAccrualEntry>>, TError,{empnum: number;payrollNum: number;date: string}, TContext> => {
    
const mutationKey = ['deleteAccrualEntry'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAccrualEntry>>, {empnum: number;payrollNum: number;date: string}> = (props) => {
          const {empnum,payrollNum,date} = props ?? {};

          return  deleteAccrualEntry(empnum,payrollNum,date,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteAccrualEntryMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAccrualEntry>>>
    
    export type DeleteAccrualEntryMutationError = AxiosError<unknown>

    export const useDeleteAccrualEntry = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAccrualEntry>>, TError,{empnum: number;payrollNum: number;date: string}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof deleteAccrualEntry>>,
        TError,
        {empnum: number;payrollNum: number;date: string},
        TContext
      > => {

      const mutationOptions = getDeleteAccrualEntryMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getAllowedLeaveTypes = (
    empnum: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<string[]>> => {
    
    
    return axios.default.get(
      `/api/Employees/${empnum}/AccrualHistory/AllowedLeaveTypes`,options
    );
  }


export const getGetAllowedLeaveTypesQueryKey = (empnum: number,) => {
    return [`/api/Employees/${empnum}/AccrualHistory/AllowedLeaveTypes`] as const;
    }

    
export const getGetAllowedLeaveTypesQueryOptions = <TData = Awaited<ReturnType<typeof getAllowedLeaveTypes>>, TError = AxiosError<unknown>>(empnum: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllowedLeaveTypes>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllowedLeaveTypesQueryKey(empnum);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllowedLeaveTypes>>> = ({ signal }) => getAllowedLeaveTypes(empnum, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(empnum), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAllowedLeaveTypes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAllowedLeaveTypesQueryResult = NonNullable<Awaited<ReturnType<typeof getAllowedLeaveTypes>>>
export type GetAllowedLeaveTypesQueryError = AxiosError<unknown>


export function useGetAllowedLeaveTypes<TData = Awaited<ReturnType<typeof getAllowedLeaveTypes>>, TError = AxiosError<unknown>>(
 empnum: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllowedLeaveTypes>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllowedLeaveTypes>>,
          TError,
          Awaited<ReturnType<typeof getAllowedLeaveTypes>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAllowedLeaveTypes<TData = Awaited<ReturnType<typeof getAllowedLeaveTypes>>, TError = AxiosError<unknown>>(
 empnum: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllowedLeaveTypes>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllowedLeaveTypes>>,
          TError,
          Awaited<ReturnType<typeof getAllowedLeaveTypes>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAllowedLeaveTypes<TData = Awaited<ReturnType<typeof getAllowedLeaveTypes>>, TError = AxiosError<unknown>>(
 empnum: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllowedLeaveTypes>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAllowedLeaveTypes<TData = Awaited<ReturnType<typeof getAllowedLeaveTypes>>, TError = AxiosError<unknown>>(
 empnum: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllowedLeaveTypes>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAllowedLeaveTypesQueryOptions(empnum,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const updateEmployeeCheckMemo = (
    empnum: number,
    employeeCheckMemoSchema: EmployeeCheckMemoSchema, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.default.post(
      `/api/Employees/${empnum}/CheckMemo`,
      employeeCheckMemoSchema,options
    );
  }



export const getUpdateEmployeeCheckMemoMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateEmployeeCheckMemo>>, TError,{empnum: number;data: EmployeeCheckMemoSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof updateEmployeeCheckMemo>>, TError,{empnum: number;data: EmployeeCheckMemoSchema}, TContext> => {
    
const mutationKey = ['updateEmployeeCheckMemo'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateEmployeeCheckMemo>>, {empnum: number;data: EmployeeCheckMemoSchema}> = (props) => {
          const {empnum,data} = props ?? {};

          return  updateEmployeeCheckMemo(empnum,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateEmployeeCheckMemoMutationResult = NonNullable<Awaited<ReturnType<typeof updateEmployeeCheckMemo>>>
    export type UpdateEmployeeCheckMemoMutationBody = EmployeeCheckMemoSchema
    export type UpdateEmployeeCheckMemoMutationError = AxiosError<unknown>

    export const useUpdateEmployeeCheckMemo = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateEmployeeCheckMemo>>, TError,{empnum: number;data: EmployeeCheckMemoSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof updateEmployeeCheckMemo>>,
        TError,
        {empnum: number;data: EmployeeCheckMemoSchema},
        TContext
      > => {

      const mutationOptions = getUpdateEmployeeCheckMemoMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const updateDeduction = (
    empnum: number,
    employeeDeductionSchema: EmployeeDeductionSchema, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<EmployeeDeductionSchema>> => {
    
    
    return axios.default.post(
      `/api/Employees/${empnum}/Payroll/Deductions`,
      employeeDeductionSchema,options
    );
  }



export const getUpdateDeductionMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateDeduction>>, TError,{empnum: number;data: EmployeeDeductionSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof updateDeduction>>, TError,{empnum: number;data: EmployeeDeductionSchema}, TContext> => {
    
const mutationKey = ['updateDeduction'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateDeduction>>, {empnum: number;data: EmployeeDeductionSchema}> = (props) => {
          const {empnum,data} = props ?? {};

          return  updateDeduction(empnum,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateDeductionMutationResult = NonNullable<Awaited<ReturnType<typeof updateDeduction>>>
    export type UpdateDeductionMutationBody = EmployeeDeductionSchema
    export type UpdateDeductionMutationError = AxiosError<unknown>

    export const useUpdateDeduction = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateDeduction>>, TError,{empnum: number;data: EmployeeDeductionSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof updateDeduction>>,
        TError,
        {empnum: number;data: EmployeeDeductionSchema},
        TContext
      > => {

      const mutationOptions = getUpdateDeductionMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const updateEarning = (
    empnum: number,
    employeeEarningSchema: EmployeeEarningSchema, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<EmployeeEarningSchema>> => {
    
    
    return axios.default.post(
      `/api/Employees/${empnum}/Payroll/Earnings`,
      employeeEarningSchema,options
    );
  }



export const getUpdateEarningMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateEarning>>, TError,{empnum: number;data: EmployeeEarningSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof updateEarning>>, TError,{empnum: number;data: EmployeeEarningSchema}, TContext> => {
    
const mutationKey = ['updateEarning'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateEarning>>, {empnum: number;data: EmployeeEarningSchema}> = (props) => {
          const {empnum,data} = props ?? {};

          return  updateEarning(empnum,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateEarningMutationResult = NonNullable<Awaited<ReturnType<typeof updateEarning>>>
    export type UpdateEarningMutationBody = EmployeeEarningSchema
    export type UpdateEarningMutationError = AxiosError<unknown>

    export const useUpdateEarning = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateEarning>>, TError,{empnum: number;data: EmployeeEarningSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof updateEarning>>,
        TError,
        {empnum: number;data: EmployeeEarningSchema},
        TContext
      > => {

      const mutationOptions = getUpdateEarningMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const updateMemo = (
    empnum: number,
    employeeMemoSchema: EmployeeMemoSchema, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.default.post(
      `/api/Employees/${empnum}/Payroll/Memos`,
      employeeMemoSchema,options
    );
  }



export const getUpdateMemoMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateMemo>>, TError,{empnum: number;data: EmployeeMemoSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof updateMemo>>, TError,{empnum: number;data: EmployeeMemoSchema}, TContext> => {
    
const mutationKey = ['updateMemo'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateMemo>>, {empnum: number;data: EmployeeMemoSchema}> = (props) => {
          const {empnum,data} = props ?? {};

          return  updateMemo(empnum,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateMemoMutationResult = NonNullable<Awaited<ReturnType<typeof updateMemo>>>
    export type UpdateMemoMutationBody = EmployeeMemoSchema
    export type UpdateMemoMutationError = AxiosError<unknown>

    export const useUpdateMemo = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateMemo>>, TError,{empnum: number;data: EmployeeMemoSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof updateMemo>>,
        TError,
        {empnum: number;data: EmployeeMemoSchema},
        TContext
      > => {

      const mutationOptions = getUpdateMemoMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getEmployeeSecondCheckRules = (
    empnum: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<SecondCheckRuleSchema[]>> => {
    
    
    return axios.default.get(
      `/api/Employees/${empnum}/Payroll/SecondCheckRules`,options
    );
  }


export const getGetEmployeeSecondCheckRulesQueryKey = (empnum: number,) => {
    return [`/api/Employees/${empnum}/Payroll/SecondCheckRules`] as const;
    }

    
export const getGetEmployeeSecondCheckRulesQueryOptions = <TData = Awaited<ReturnType<typeof getEmployeeSecondCheckRules>>, TError = AxiosError<unknown>>(empnum: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeeSecondCheckRules>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEmployeeSecondCheckRulesQueryKey(empnum);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEmployeeSecondCheckRules>>> = ({ signal }) => getEmployeeSecondCheckRules(empnum, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(empnum), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEmployeeSecondCheckRules>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEmployeeSecondCheckRulesQueryResult = NonNullable<Awaited<ReturnType<typeof getEmployeeSecondCheckRules>>>
export type GetEmployeeSecondCheckRulesQueryError = AxiosError<unknown>


export function useGetEmployeeSecondCheckRules<TData = Awaited<ReturnType<typeof getEmployeeSecondCheckRules>>, TError = AxiosError<unknown>>(
 empnum: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeeSecondCheckRules>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmployeeSecondCheckRules>>,
          TError,
          Awaited<ReturnType<typeof getEmployeeSecondCheckRules>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmployeeSecondCheckRules<TData = Awaited<ReturnType<typeof getEmployeeSecondCheckRules>>, TError = AxiosError<unknown>>(
 empnum: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeeSecondCheckRules>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmployeeSecondCheckRules>>,
          TError,
          Awaited<ReturnType<typeof getEmployeeSecondCheckRules>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmployeeSecondCheckRules<TData = Awaited<ReturnType<typeof getEmployeeSecondCheckRules>>, TError = AxiosError<unknown>>(
 empnum: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeeSecondCheckRules>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetEmployeeSecondCheckRules<TData = Awaited<ReturnType<typeof getEmployeeSecondCheckRules>>, TError = AxiosError<unknown>>(
 empnum: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeeSecondCheckRules>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEmployeeSecondCheckRulesQueryOptions(empnum,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const createEmployeeSecondCheckRule = (
    empnum: number,
    secondCheckRuleRequestSchema: SecondCheckRuleRequestSchema, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<number>> => {
    
    
    return axios.default.post(
      `/api/Employees/${empnum}/Payroll/SecondCheckRules`,
      secondCheckRuleRequestSchema,options
    );
  }



export const getCreateEmployeeSecondCheckRuleMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createEmployeeSecondCheckRule>>, TError,{empnum: number;data: SecondCheckRuleRequestSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof createEmployeeSecondCheckRule>>, TError,{empnum: number;data: SecondCheckRuleRequestSchema}, TContext> => {
    
const mutationKey = ['createEmployeeSecondCheckRule'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createEmployeeSecondCheckRule>>, {empnum: number;data: SecondCheckRuleRequestSchema}> = (props) => {
          const {empnum,data} = props ?? {};

          return  createEmployeeSecondCheckRule(empnum,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateEmployeeSecondCheckRuleMutationResult = NonNullable<Awaited<ReturnType<typeof createEmployeeSecondCheckRule>>>
    export type CreateEmployeeSecondCheckRuleMutationBody = SecondCheckRuleRequestSchema
    export type CreateEmployeeSecondCheckRuleMutationError = AxiosError<unknown>

    export const useCreateEmployeeSecondCheckRule = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createEmployeeSecondCheckRule>>, TError,{empnum: number;data: SecondCheckRuleRequestSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof createEmployeeSecondCheckRule>>,
        TError,
        {empnum: number;data: SecondCheckRuleRequestSchema},
        TContext
      > => {

      const mutationOptions = getCreateEmployeeSecondCheckRuleMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const updateEmployeeSecondCheckRule = (
    empnum: number,
    ruleId: number,
    secondCheckRuleRequestSchema: SecondCheckRuleRequestSchema, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.default.put(
      `/api/Employees/${empnum}/Payroll/SecondCheckRules/${ruleId}`,
      secondCheckRuleRequestSchema,options
    );
  }



export const getUpdateEmployeeSecondCheckRuleMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateEmployeeSecondCheckRule>>, TError,{empnum: number;ruleId: number;data: SecondCheckRuleRequestSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof updateEmployeeSecondCheckRule>>, TError,{empnum: number;ruleId: number;data: SecondCheckRuleRequestSchema}, TContext> => {
    
const mutationKey = ['updateEmployeeSecondCheckRule'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateEmployeeSecondCheckRule>>, {empnum: number;ruleId: number;data: SecondCheckRuleRequestSchema}> = (props) => {
          const {empnum,ruleId,data} = props ?? {};

          return  updateEmployeeSecondCheckRule(empnum,ruleId,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateEmployeeSecondCheckRuleMutationResult = NonNullable<Awaited<ReturnType<typeof updateEmployeeSecondCheckRule>>>
    export type UpdateEmployeeSecondCheckRuleMutationBody = SecondCheckRuleRequestSchema
    export type UpdateEmployeeSecondCheckRuleMutationError = AxiosError<unknown>

    export const useUpdateEmployeeSecondCheckRule = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateEmployeeSecondCheckRule>>, TError,{empnum: number;ruleId: number;data: SecondCheckRuleRequestSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof updateEmployeeSecondCheckRule>>,
        TError,
        {empnum: number;ruleId: number;data: SecondCheckRuleRequestSchema},
        TContext
      > => {

      const mutationOptions = getUpdateEmployeeSecondCheckRuleMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const deleteEmployeeSecondCheckRule = (
    empnum: number,
    ruleId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.default.delete(
      `/api/Employees/${empnum}/Payroll/SecondCheckRules/${ruleId}`,options
    );
  }



export const getDeleteEmployeeSecondCheckRuleMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteEmployeeSecondCheckRule>>, TError,{empnum: number;ruleId: number}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof deleteEmployeeSecondCheckRule>>, TError,{empnum: number;ruleId: number}, TContext> => {
    
const mutationKey = ['deleteEmployeeSecondCheckRule'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteEmployeeSecondCheckRule>>, {empnum: number;ruleId: number}> = (props) => {
          const {empnum,ruleId} = props ?? {};

          return  deleteEmployeeSecondCheckRule(empnum,ruleId,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteEmployeeSecondCheckRuleMutationResult = NonNullable<Awaited<ReturnType<typeof deleteEmployeeSecondCheckRule>>>
    
    export type DeleteEmployeeSecondCheckRuleMutationError = AxiosError<unknown>

    export const useDeleteEmployeeSecondCheckRule = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteEmployeeSecondCheckRule>>, TError,{empnum: number;ruleId: number}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof deleteEmployeeSecondCheckRule>>,
        TError,
        {empnum: number;ruleId: number},
        TContext
      > => {

      const mutationOptions = getDeleteEmployeeSecondCheckRuleMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const updateEmployeeTimeAndLabor = (
    empnum: number,
    employeeTimeAndLaborSchema: EmployeeTimeAndLaborSchema, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<EmployeeTimeAndLaborSchema>> => {
    
    
    return axios.default.post(
      `/api/Employees/${empnum}/Payroll/TimeAndLabor`,
      employeeTimeAndLaborSchema,options
    );
  }



export const getUpdateEmployeeTimeAndLaborMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateEmployeeTimeAndLabor>>, TError,{empnum: number;data: EmployeeTimeAndLaborSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof updateEmployeeTimeAndLabor>>, TError,{empnum: number;data: EmployeeTimeAndLaborSchema}, TContext> => {
    
const mutationKey = ['updateEmployeeTimeAndLabor'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateEmployeeTimeAndLabor>>, {empnum: number;data: EmployeeTimeAndLaborSchema}> = (props) => {
          const {empnum,data} = props ?? {};

          return  updateEmployeeTimeAndLabor(empnum,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateEmployeeTimeAndLaborMutationResult = NonNullable<Awaited<ReturnType<typeof updateEmployeeTimeAndLabor>>>
    export type UpdateEmployeeTimeAndLaborMutationBody = EmployeeTimeAndLaborSchema
    export type UpdateEmployeeTimeAndLaborMutationError = AxiosError<unknown>

    export const useUpdateEmployeeTimeAndLabor = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateEmployeeTimeAndLabor>>, TError,{empnum: number;data: EmployeeTimeAndLaborSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof updateEmployeeTimeAndLabor>>,
        TError,
        {empnum: number;data: EmployeeTimeAndLaborSchema},
        TContext
      > => {

      const mutationOptions = getUpdateEmployeeTimeAndLaborMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getRateChangesHistory = (
    empnum: number,
    params?: GetRateChangesHistoryParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.default.get(
      `/api/Employees/${empnum}/RateChangesHistory`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getGetRateChangesHistoryQueryKey = (empnum: number,
    params?: GetRateChangesHistoryParams,) => {
    return [`/api/Employees/${empnum}/RateChangesHistory`, ...(params ? [params]: [])] as const;
    }

    
export const getGetRateChangesHistoryQueryOptions = <TData = Awaited<ReturnType<typeof getRateChangesHistory>>, TError = AxiosError<unknown>>(empnum: number,
    params?: GetRateChangesHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRateChangesHistory>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRateChangesHistoryQueryKey(empnum,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRateChangesHistory>>> = ({ signal }) => getRateChangesHistory(empnum,params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(empnum), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRateChangesHistory>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRateChangesHistoryQueryResult = NonNullable<Awaited<ReturnType<typeof getRateChangesHistory>>>
export type GetRateChangesHistoryQueryError = AxiosError<unknown>


export function useGetRateChangesHistory<TData = Awaited<ReturnType<typeof getRateChangesHistory>>, TError = AxiosError<unknown>>(
 empnum: number,
    params: undefined |  GetRateChangesHistoryParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRateChangesHistory>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRateChangesHistory>>,
          TError,
          Awaited<ReturnType<typeof getRateChangesHistory>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRateChangesHistory<TData = Awaited<ReturnType<typeof getRateChangesHistory>>, TError = AxiosError<unknown>>(
 empnum: number,
    params?: GetRateChangesHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRateChangesHistory>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRateChangesHistory>>,
          TError,
          Awaited<ReturnType<typeof getRateChangesHistory>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRateChangesHistory<TData = Awaited<ReturnType<typeof getRateChangesHistory>>, TError = AxiosError<unknown>>(
 empnum: number,
    params?: GetRateChangesHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRateChangesHistory>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetRateChangesHistory<TData = Awaited<ReturnType<typeof getRateChangesHistory>>, TError = AxiosError<unknown>>(
 empnum: number,
    params?: GetRateChangesHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRateChangesHistory>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetRateChangesHistoryQueryOptions(empnum,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getDivisions = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<DivisionSchema[]>> => {
    
    
    return axios.default.get(
      `/api/employees/Divisions`,options
    );
  }


export const getGetDivisionsQueryKey = () => {
    return [`/api/employees/Divisions`] as const;
    }

    
export const getGetDivisionsQueryOptions = <TData = Awaited<ReturnType<typeof getDivisions>>, TError = AxiosError<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDivisions>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDivisionsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDivisions>>> = ({ signal }) => getDivisions({ signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDivisions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDivisionsQueryResult = NonNullable<Awaited<ReturnType<typeof getDivisions>>>
export type GetDivisionsQueryError = AxiosError<unknown>


export function useGetDivisions<TData = Awaited<ReturnType<typeof getDivisions>>, TError = AxiosError<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDivisions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDivisions>>,
          TError,
          Awaited<ReturnType<typeof getDivisions>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDivisions<TData = Awaited<ReturnType<typeof getDivisions>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDivisions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDivisions>>,
          TError,
          Awaited<ReturnType<typeof getDivisions>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDivisions<TData = Awaited<ReturnType<typeof getDivisions>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDivisions>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetDivisions<TData = Awaited<ReturnType<typeof getDivisions>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDivisions>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDivisionsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getEmployeeJobDropdowns = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<EmployeeJobDropdownsSchema>> => {
    
    
    return axios.default.get(
      `/api/employees/EmployeeJob/Options`,options
    );
  }


export const getGetEmployeeJobDropdownsQueryKey = () => {
    return [`/api/employees/EmployeeJob/Options`] as const;
    }

    
export const getGetEmployeeJobDropdownsQueryOptions = <TData = Awaited<ReturnType<typeof getEmployeeJobDropdowns>>, TError = AxiosError<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeeJobDropdowns>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEmployeeJobDropdownsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEmployeeJobDropdowns>>> = ({ signal }) => getEmployeeJobDropdowns({ signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEmployeeJobDropdowns>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEmployeeJobDropdownsQueryResult = NonNullable<Awaited<ReturnType<typeof getEmployeeJobDropdowns>>>
export type GetEmployeeJobDropdownsQueryError = AxiosError<unknown>


export function useGetEmployeeJobDropdowns<TData = Awaited<ReturnType<typeof getEmployeeJobDropdowns>>, TError = AxiosError<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeeJobDropdowns>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmployeeJobDropdowns>>,
          TError,
          Awaited<ReturnType<typeof getEmployeeJobDropdowns>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmployeeJobDropdowns<TData = Awaited<ReturnType<typeof getEmployeeJobDropdowns>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeeJobDropdowns>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmployeeJobDropdowns>>,
          TError,
          Awaited<ReturnType<typeof getEmployeeJobDropdowns>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmployeeJobDropdowns<TData = Awaited<ReturnType<typeof getEmployeeJobDropdowns>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeeJobDropdowns>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetEmployeeJobDropdowns<TData = Awaited<ReturnType<typeof getEmployeeJobDropdowns>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeeJobDropdowns>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEmployeeJobDropdownsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getEmployeePersonalInfoDropdowns = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<EmployeePersonalInfoOptionsSchema>> => {
    
    
    return axios.default.get(
      `/api/employees/EmployeePersonalInfo/Options`,options
    );
  }


export const getGetEmployeePersonalInfoDropdownsQueryKey = () => {
    return [`/api/employees/EmployeePersonalInfo/Options`] as const;
    }

    
export const getGetEmployeePersonalInfoDropdownsQueryOptions = <TData = Awaited<ReturnType<typeof getEmployeePersonalInfoDropdowns>>, TError = AxiosError<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeePersonalInfoDropdowns>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEmployeePersonalInfoDropdownsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEmployeePersonalInfoDropdowns>>> = ({ signal }) => getEmployeePersonalInfoDropdowns({ signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEmployeePersonalInfoDropdowns>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEmployeePersonalInfoDropdownsQueryResult = NonNullable<Awaited<ReturnType<typeof getEmployeePersonalInfoDropdowns>>>
export type GetEmployeePersonalInfoDropdownsQueryError = AxiosError<unknown>


export function useGetEmployeePersonalInfoDropdowns<TData = Awaited<ReturnType<typeof getEmployeePersonalInfoDropdowns>>, TError = AxiosError<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeePersonalInfoDropdowns>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmployeePersonalInfoDropdowns>>,
          TError,
          Awaited<ReturnType<typeof getEmployeePersonalInfoDropdowns>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmployeePersonalInfoDropdowns<TData = Awaited<ReturnType<typeof getEmployeePersonalInfoDropdowns>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeePersonalInfoDropdowns>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmployeePersonalInfoDropdowns>>,
          TError,
          Awaited<ReturnType<typeof getEmployeePersonalInfoDropdowns>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmployeePersonalInfoDropdowns<TData = Awaited<ReturnType<typeof getEmployeePersonalInfoDropdowns>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeePersonalInfoDropdowns>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetEmployeePersonalInfoDropdowns<TData = Awaited<ReturnType<typeof getEmployeePersonalInfoDropdowns>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeePersonalInfoDropdowns>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEmployeePersonalInfoDropdownsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const createEmployee = (
    newEmployeeSchema: NonReadonly<NewEmployeeSchema>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.default.post(
      `/api/Employees/New`,
      newEmployeeSchema,options
    );
  }



export const getCreateEmployeeMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createEmployee>>, TError,{data: NonReadonly<NewEmployeeSchema>}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof createEmployee>>, TError,{data: NonReadonly<NewEmployeeSchema>}, TContext> => {
    
const mutationKey = ['createEmployee'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createEmployee>>, {data: NonReadonly<NewEmployeeSchema>}> = (props) => {
          const {data} = props ?? {};

          return  createEmployee(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateEmployeeMutationResult = NonNullable<Awaited<ReturnType<typeof createEmployee>>>
    export type CreateEmployeeMutationBody = NonReadonly<NewEmployeeSchema>
    export type CreateEmployeeMutationError = AxiosError<unknown>

    export const useCreateEmployee = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createEmployee>>, TError,{data: NonReadonly<NewEmployeeSchema>}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof createEmployee>>,
        TError,
        {data: NonReadonly<NewEmployeeSchema>},
        TContext
      > => {

      const mutationOptions = getCreateEmployeeMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const validateEmployeeNumber = (
    params?: ValidateEmployeeNumberParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<boolean>> => {
    
    
    return axios.default.post(
      `/api/Employees/New/ValidateEmpnum`,undefined,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getValidateEmployeeNumberMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof validateEmployeeNumber>>, TError,{params?: ValidateEmployeeNumberParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof validateEmployeeNumber>>, TError,{params?: ValidateEmployeeNumberParams}, TContext> => {
    
const mutationKey = ['validateEmployeeNumber'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof validateEmployeeNumber>>, {params?: ValidateEmployeeNumberParams}> = (props) => {
          const {params} = props ?? {};

          return  validateEmployeeNumber(params,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ValidateEmployeeNumberMutationResult = NonNullable<Awaited<ReturnType<typeof validateEmployeeNumber>>>
    
    export type ValidateEmployeeNumberMutationError = AxiosError<unknown>

    export const useValidateEmployeeNumber = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof validateEmployeeNumber>>, TError,{params?: ValidateEmployeeNumberParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof validateEmployeeNumber>>,
        TError,
        {params?: ValidateEmployeeNumberParams},
        TContext
      > => {

      const mutationOptions = getValidateEmployeeNumberMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getPaymentAddresses = (
    params?: GetPaymentAddressesParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PaymentAddressSchema[]>> => {
    
    
    return axios.default.get(
      `/api/Employees/PaymentAddresses`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getGetPaymentAddressesQueryKey = (params?: GetPaymentAddressesParams,) => {
    return [`/api/Employees/PaymentAddresses`, ...(params ? [params]: [])] as const;
    }

    
export const getGetPaymentAddressesQueryOptions = <TData = Awaited<ReturnType<typeof getPaymentAddresses>>, TError = AxiosError<unknown>>(params?: GetPaymentAddressesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentAddresses>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPaymentAddressesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPaymentAddresses>>> = ({ signal }) => getPaymentAddresses(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPaymentAddresses>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPaymentAddressesQueryResult = NonNullable<Awaited<ReturnType<typeof getPaymentAddresses>>>
export type GetPaymentAddressesQueryError = AxiosError<unknown>


export function useGetPaymentAddresses<TData = Awaited<ReturnType<typeof getPaymentAddresses>>, TError = AxiosError<unknown>>(
 params: undefined |  GetPaymentAddressesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentAddresses>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPaymentAddresses>>,
          TError,
          Awaited<ReturnType<typeof getPaymentAddresses>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPaymentAddresses<TData = Awaited<ReturnType<typeof getPaymentAddresses>>, TError = AxiosError<unknown>>(
 params?: GetPaymentAddressesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentAddresses>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPaymentAddresses>>,
          TError,
          Awaited<ReturnType<typeof getPaymentAddresses>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPaymentAddresses<TData = Awaited<ReturnType<typeof getPaymentAddresses>>, TError = AxiosError<unknown>>(
 params?: GetPaymentAddressesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentAddresses>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPaymentAddresses<TData = Awaited<ReturnType<typeof getPaymentAddresses>>, TError = AxiosError<unknown>>(
 params?: GetPaymentAddressesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentAddresses>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPaymentAddressesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const addPaymentAddress = (
    upsertPaymentAddressSchema: UpsertPaymentAddressSchema, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.default.post(
      `/api/Employees/PaymentAddresses`,
      upsertPaymentAddressSchema,options
    );
  }



export const getAddPaymentAddressMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addPaymentAddress>>, TError,{data: UpsertPaymentAddressSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof addPaymentAddress>>, TError,{data: UpsertPaymentAddressSchema}, TContext> => {
    
const mutationKey = ['addPaymentAddress'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addPaymentAddress>>, {data: UpsertPaymentAddressSchema}> = (props) => {
          const {data} = props ?? {};

          return  addPaymentAddress(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AddPaymentAddressMutationResult = NonNullable<Awaited<ReturnType<typeof addPaymentAddress>>>
    export type AddPaymentAddressMutationBody = UpsertPaymentAddressSchema
    export type AddPaymentAddressMutationError = AxiosError<unknown>

    export const useAddPaymentAddress = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addPaymentAddress>>, TError,{data: UpsertPaymentAddressSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof addPaymentAddress>>,
        TError,
        {data: UpsertPaymentAddressSchema},
        TContext
      > => {

      const mutationOptions = getAddPaymentAddressMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const updatePaymentAddress = (
    id: string,
    upsertPaymentAddressSchema: UpsertPaymentAddressSchema, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.default.put(
      `/api/Employees/PaymentAddresses/${id}`,
      upsertPaymentAddressSchema,options
    );
  }



export const getUpdatePaymentAddressMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePaymentAddress>>, TError,{id: string;data: UpsertPaymentAddressSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof updatePaymentAddress>>, TError,{id: string;data: UpsertPaymentAddressSchema}, TContext> => {
    
const mutationKey = ['updatePaymentAddress'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updatePaymentAddress>>, {id: string;data: UpsertPaymentAddressSchema}> = (props) => {
          const {id,data} = props ?? {};

          return  updatePaymentAddress(id,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdatePaymentAddressMutationResult = NonNullable<Awaited<ReturnType<typeof updatePaymentAddress>>>
    export type UpdatePaymentAddressMutationBody = UpsertPaymentAddressSchema
    export type UpdatePaymentAddressMutationError = AxiosError<unknown>

    export const useUpdatePaymentAddress = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePaymentAddress>>, TError,{id: string;data: UpsertPaymentAddressSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof updatePaymentAddress>>,
        TError,
        {id: string;data: UpsertPaymentAddressSchema},
        TContext
      > => {

      const mutationOptions = getUpdatePaymentAddressMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Gets the full company employee list for recipient/employee picking
 */
export const getEmployeePickerEmployees = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<EmployeePickerEmployeeSchema[]>> => {
    
    
    return axios.default.get(
      `/api/Employees/Picker`,options
    );
  }


export const getGetEmployeePickerEmployeesQueryKey = () => {
    return [`/api/Employees/Picker`] as const;
    }

    
export const getGetEmployeePickerEmployeesQueryOptions = <TData = Awaited<ReturnType<typeof getEmployeePickerEmployees>>, TError = AxiosError<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeePickerEmployees>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEmployeePickerEmployeesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEmployeePickerEmployees>>> = ({ signal }) => getEmployeePickerEmployees({ signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEmployeePickerEmployees>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEmployeePickerEmployeesQueryResult = NonNullable<Awaited<ReturnType<typeof getEmployeePickerEmployees>>>
export type GetEmployeePickerEmployeesQueryError = AxiosError<unknown>


export function useGetEmployeePickerEmployees<TData = Awaited<ReturnType<typeof getEmployeePickerEmployees>>, TError = AxiosError<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeePickerEmployees>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmployeePickerEmployees>>,
          TError,
          Awaited<ReturnType<typeof getEmployeePickerEmployees>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmployeePickerEmployees<TData = Awaited<ReturnType<typeof getEmployeePickerEmployees>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeePickerEmployees>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmployeePickerEmployees>>,
          TError,
          Awaited<ReturnType<typeof getEmployeePickerEmployees>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmployeePickerEmployees<TData = Awaited<ReturnType<typeof getEmployeePickerEmployees>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeePickerEmployees>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Gets the full company employee list for recipient/employee picking
 */

export function useGetEmployeePickerEmployees<TData = Awaited<ReturnType<typeof getEmployeePickerEmployees>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeePickerEmployees>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEmployeePickerEmployeesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Evaluates shared employee-filter criteria and returns the matching employee count and numbers
 */
export const getEmployeePickerCriteriaMatches = (
    employeeFilterCriteriaSchema: EmployeeFilterCriteriaSchema, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<EmployeePickerCriteriaMatchesSchema>> => {
    
    
    return axios.default.post(
      `/api/Employees/Picker/CriteriaMatches`,
      employeeFilterCriteriaSchema,options
    );
  }



export const getGetEmployeePickerCriteriaMatchesMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getEmployeePickerCriteriaMatches>>, TError,{data: EmployeeFilterCriteriaSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof getEmployeePickerCriteriaMatches>>, TError,{data: EmployeeFilterCriteriaSchema}, TContext> => {
    
const mutationKey = ['getEmployeePickerCriteriaMatches'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getEmployeePickerCriteriaMatches>>, {data: EmployeeFilterCriteriaSchema}> = (props) => {
          const {data} = props ?? {};

          return  getEmployeePickerCriteriaMatches(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type GetEmployeePickerCriteriaMatchesMutationResult = NonNullable<Awaited<ReturnType<typeof getEmployeePickerCriteriaMatches>>>
    export type GetEmployeePickerCriteriaMatchesMutationBody = EmployeeFilterCriteriaSchema
    export type GetEmployeePickerCriteriaMatchesMutationError = AxiosError<unknown>

    /**
 * @summary Evaluates shared employee-filter criteria and returns the matching employee count and numbers
 */
export const useGetEmployeePickerCriteriaMatches = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getEmployeePickerCriteriaMatches>>, TError,{data: EmployeeFilterCriteriaSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof getEmployeePickerCriteriaMatches>>,
        TError,
        {data: EmployeeFilterCriteriaSchema},
        TContext
      > => {

      const mutationOptions = getGetEmployeePickerCriteriaMatchesMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Gets divisions/departments and the criteria-builder field configuration
 */
export const getEmployeePickerFilters = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<EmployeePickerFiltersSchema>> => {
    
    
    return axios.default.get(
      `/api/Employees/Picker/Filters`,options
    );
  }


export const getGetEmployeePickerFiltersQueryKey = () => {
    return [`/api/Employees/Picker/Filters`] as const;
    }

    
export const getGetEmployeePickerFiltersQueryOptions = <TData = Awaited<ReturnType<typeof getEmployeePickerFilters>>, TError = AxiosError<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeePickerFilters>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEmployeePickerFiltersQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEmployeePickerFilters>>> = ({ signal }) => getEmployeePickerFilters({ signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEmployeePickerFilters>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEmployeePickerFiltersQueryResult = NonNullable<Awaited<ReturnType<typeof getEmployeePickerFilters>>>
export type GetEmployeePickerFiltersQueryError = AxiosError<unknown>


export function useGetEmployeePickerFilters<TData = Awaited<ReturnType<typeof getEmployeePickerFilters>>, TError = AxiosError<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeePickerFilters>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmployeePickerFilters>>,
          TError,
          Awaited<ReturnType<typeof getEmployeePickerFilters>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmployeePickerFilters<TData = Awaited<ReturnType<typeof getEmployeePickerFilters>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeePickerFilters>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmployeePickerFilters>>,
          TError,
          Awaited<ReturnType<typeof getEmployeePickerFilters>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmployeePickerFilters<TData = Awaited<ReturnType<typeof getEmployeePickerFilters>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeePickerFilters>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Gets divisions/departments and the criteria-builder field configuration
 */

export function useGetEmployeePickerFilters<TData = Awaited<ReturnType<typeof getEmployeePickerFilters>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeePickerFilters>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEmployeePickerFiltersQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getFeatureFlags = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<FeatureFlagStateSchema[]>> => {
    
    
    return axios.default.get(
      `/api/FeatureFlags`,options
    );
  }


export const getGetFeatureFlagsQueryKey = () => {
    return [`/api/FeatureFlags`] as const;
    }

    
export const getGetFeatureFlagsQueryOptions = <TData = Awaited<ReturnType<typeof getFeatureFlags>>, TError = AxiosError<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFeatureFlags>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFeatureFlagsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFeatureFlags>>> = ({ signal }) => getFeatureFlags({ signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFeatureFlags>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetFeatureFlagsQueryResult = NonNullable<Awaited<ReturnType<typeof getFeatureFlags>>>
export type GetFeatureFlagsQueryError = AxiosError<unknown>


export function useGetFeatureFlags<TData = Awaited<ReturnType<typeof getFeatureFlags>>, TError = AxiosError<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFeatureFlags>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFeatureFlags>>,
          TError,
          Awaited<ReturnType<typeof getFeatureFlags>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFeatureFlags<TData = Awaited<ReturnType<typeof getFeatureFlags>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFeatureFlags>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFeatureFlags>>,
          TError,
          Awaited<ReturnType<typeof getFeatureFlags>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFeatureFlags<TData = Awaited<ReturnType<typeof getFeatureFlags>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFeatureFlags>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetFeatureFlags<TData = Awaited<ReturnType<typeof getFeatureFlags>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFeatureFlags>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetFeatureFlagsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Submits a request to enable a specific feature for the authenticated user
 */
export const requestFeature = (
    featureName: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.default.post(
      `/api/Features/${featureName}`,undefined,options
    );
  }



export const getRequestFeatureMutationOptions = <TError = AxiosError<ProblemDetailsSchema>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestFeature>>, TError,{featureName: string}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof requestFeature>>, TError,{featureName: string}, TContext> => {
    
const mutationKey = ['requestFeature'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof requestFeature>>, {featureName: string}> = (props) => {
          const {featureName} = props ?? {};

          return  requestFeature(featureName,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RequestFeatureMutationResult = NonNullable<Awaited<ReturnType<typeof requestFeature>>>
    
    export type RequestFeatureMutationError = AxiosError<ProblemDetailsSchema>

    /**
 * @summary Submits a request to enable a specific feature for the authenticated user
 */
export const useRequestFeature = <TError = AxiosError<ProblemDetailsSchema>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestFeature>>, TError,{featureName: string}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof requestFeature>>,
        TError,
        {featureName: string},
        TContext
      > => {

      const mutationOptions = getRequestFeatureMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Creates open document assignments for a set of employees; employees who already have an open assignment are skipped.
Employees named in RemindEmpNums get a reminder email for the open assignment they already have
 */
export const createHrDocumentAssignments = (
    hrDocumentAssignmentsCreateRequestSchema: HrDocumentAssignmentsCreateRequestSchema, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<HrDocumentAssignmentsCreateResultSchema>> => {
    
    
    return axios.default.post(
      `/api/Hr/DocumentAssignments`,
      hrDocumentAssignmentsCreateRequestSchema,options
    );
  }



export const getCreateHrDocumentAssignmentsMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createHrDocumentAssignments>>, TError,{data: HrDocumentAssignmentsCreateRequestSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof createHrDocumentAssignments>>, TError,{data: HrDocumentAssignmentsCreateRequestSchema}, TContext> => {
    
const mutationKey = ['createHrDocumentAssignments'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createHrDocumentAssignments>>, {data: HrDocumentAssignmentsCreateRequestSchema}> = (props) => {
          const {data} = props ?? {};

          return  createHrDocumentAssignments(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateHrDocumentAssignmentsMutationResult = NonNullable<Awaited<ReturnType<typeof createHrDocumentAssignments>>>
    export type CreateHrDocumentAssignmentsMutationBody = HrDocumentAssignmentsCreateRequestSchema
    export type CreateHrDocumentAssignmentsMutationError = AxiosError<unknown>

    /**
 * @summary Creates open document assignments for a set of employees; employees who already have an open assignment are skipped.
Employees named in RemindEmpNums get a reminder email for the open assignment they already have
 */
export const useCreateHrDocumentAssignments = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createHrDocumentAssignments>>, TError,{data: HrDocumentAssignmentsCreateRequestSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof createHrDocumentAssignments>>,
        TError,
        {data: HrDocumentAssignmentsCreateRequestSchema},
        TContext
      > => {

      const mutationOptions = getCreateHrDocumentAssignmentsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Cancels an open document assignment
 */
export const cancelHrDocumentAssignment = (
    assignmentId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.default.delete(
      `/api/Hr/DocumentAssignments/${assignmentId}`,options
    );
  }



export const getCancelHrDocumentAssignmentMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelHrDocumentAssignment>>, TError,{assignmentId: number}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof cancelHrDocumentAssignment>>, TError,{assignmentId: number}, TContext> => {
    
const mutationKey = ['cancelHrDocumentAssignment'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancelHrDocumentAssignment>>, {assignmentId: number}> = (props) => {
          const {assignmentId} = props ?? {};

          return  cancelHrDocumentAssignment(assignmentId,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CancelHrDocumentAssignmentMutationResult = NonNullable<Awaited<ReturnType<typeof cancelHrDocumentAssignment>>>
    
    export type CancelHrDocumentAssignmentMutationError = AxiosError<unknown>

    /**
 * @summary Cancels an open document assignment
 */
export const useCancelHrDocumentAssignment = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelHrDocumentAssignment>>, TError,{assignmentId: number}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof cancelHrDocumentAssignment>>,
        TError,
        {assignmentId: number},
        TContext
      > => {

      const mutationOptions = getCancelHrDocumentAssignmentMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Sends a reminder email to the employee for an open document assignment
 */
export const sendHrDocumentReminder = (
    assignmentId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.default.post(
      `/api/Hr/DocumentAssignments/${assignmentId}/Reminder`,undefined,options
    );
  }



export const getSendHrDocumentReminderMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendHrDocumentReminder>>, TError,{assignmentId: number}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof sendHrDocumentReminder>>, TError,{assignmentId: number}, TContext> => {
    
const mutationKey = ['sendHrDocumentReminder'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendHrDocumentReminder>>, {assignmentId: number}> = (props) => {
          const {assignmentId} = props ?? {};

          return  sendHrDocumentReminder(assignmentId,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SendHrDocumentReminderMutationResult = NonNullable<Awaited<ReturnType<typeof sendHrDocumentReminder>>>
    
    export type SendHrDocumentReminderMutationError = AxiosError<unknown>

    /**
 * @summary Sends a reminder email to the employee for an open document assignment
 */
export const useSendHrDocumentReminder = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendHrDocumentReminder>>, TError,{assignmentId: number}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof sendHrDocumentReminder>>,
        TError,
        {assignmentId: number},
        TContext
      > => {

      const mutationOptions = getSendHrDocumentReminderMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Detects assignment conflicts for a template against a set of employees (POST because the set can be hundreds)
 */
export const getHrDocumentAssignmentConflicts = (
    hrDocumentAssignmentConflictsRequestSchema: HrDocumentAssignmentConflictsRequestSchema, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<HrDocumentAssignmentConflictSchema[]>> => {
    
    
    return axios.default.post(
      `/api/Hr/DocumentAssignments/Conflicts`,
      hrDocumentAssignmentConflictsRequestSchema,options
    );
  }



export const getGetHrDocumentAssignmentConflictsMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getHrDocumentAssignmentConflicts>>, TError,{data: HrDocumentAssignmentConflictsRequestSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof getHrDocumentAssignmentConflicts>>, TError,{data: HrDocumentAssignmentConflictsRequestSchema}, TContext> => {
    
const mutationKey = ['getHrDocumentAssignmentConflicts'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getHrDocumentAssignmentConflicts>>, {data: HrDocumentAssignmentConflictsRequestSchema}> = (props) => {
          const {data} = props ?? {};

          return  getHrDocumentAssignmentConflicts(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type GetHrDocumentAssignmentConflictsMutationResult = NonNullable<Awaited<ReturnType<typeof getHrDocumentAssignmentConflicts>>>
    export type GetHrDocumentAssignmentConflictsMutationBody = HrDocumentAssignmentConflictsRequestSchema
    export type GetHrDocumentAssignmentConflictsMutationError = AxiosError<unknown>

    /**
 * @summary Detects assignment conflicts for a template against a set of employees (POST because the set can be hundreds)
 */
export const useGetHrDocumentAssignmentConflicts = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getHrDocumentAssignmentConflicts>>, TError,{data: HrDocumentAssignmentConflictsRequestSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof getHrDocumentAssignmentConflicts>>,
        TError,
        {data: HrDocumentAssignmentConflictsRequestSchema},
        TContext
      > => {

      const mutationOptions = getGetHrDocumentAssignmentConflictsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Gets the company document list, one row per (employee, template) group; optionally scoped to one employee
 */
export const getHrDocuments = (
    params?: GetHrDocumentsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<HrDocumentListItemSchema[]>> => {
    
    
    return axios.default.get(
      `/api/Hr/Documents`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getGetHrDocumentsQueryKey = (params?: GetHrDocumentsParams,) => {
    return [`/api/Hr/Documents`, ...(params ? [params]: [])] as const;
    }

    
export const getGetHrDocumentsQueryOptions = <TData = Awaited<ReturnType<typeof getHrDocuments>>, TError = AxiosError<unknown>>(params?: GetHrDocumentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHrDocuments>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetHrDocumentsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getHrDocuments>>> = ({ signal }) => getHrDocuments(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getHrDocuments>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetHrDocumentsQueryResult = NonNullable<Awaited<ReturnType<typeof getHrDocuments>>>
export type GetHrDocumentsQueryError = AxiosError<unknown>


export function useGetHrDocuments<TData = Awaited<ReturnType<typeof getHrDocuments>>, TError = AxiosError<unknown>>(
 params: undefined |  GetHrDocumentsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHrDocuments>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getHrDocuments>>,
          TError,
          Awaited<ReturnType<typeof getHrDocuments>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetHrDocuments<TData = Awaited<ReturnType<typeof getHrDocuments>>, TError = AxiosError<unknown>>(
 params?: GetHrDocumentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHrDocuments>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getHrDocuments>>,
          TError,
          Awaited<ReturnType<typeof getHrDocuments>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetHrDocuments<TData = Awaited<ReturnType<typeof getHrDocuments>>, TError = AxiosError<unknown>>(
 params?: GetHrDocumentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHrDocuments>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Gets the company document list, one row per (employee, template) group; optionally scoped to one employee
 */

export function useGetHrDocuments<TData = Awaited<ReturnType<typeof getHrDocuments>>, TError = AxiosError<unknown>>(
 params?: GetHrDocumentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHrDocuments>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetHrDocumentsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Gets the full detail for a single document (detail-dialog payload)
 */
export const getHrDocumentDetail = (
    documentId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<HrDocumentDetailSchema>> => {
    
    
    return axios.default.get(
      `/api/Hr/Documents/${documentId}`,options
    );
  }


export const getGetHrDocumentDetailQueryKey = (documentId: number,) => {
    return [`/api/Hr/Documents/${documentId}`] as const;
    }

    
export const getGetHrDocumentDetailQueryOptions = <TData = Awaited<ReturnType<typeof getHrDocumentDetail>>, TError = AxiosError<unknown>>(documentId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHrDocumentDetail>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetHrDocumentDetailQueryKey(documentId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getHrDocumentDetail>>> = ({ signal }) => getHrDocumentDetail(documentId, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(documentId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getHrDocumentDetail>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetHrDocumentDetailQueryResult = NonNullable<Awaited<ReturnType<typeof getHrDocumentDetail>>>
export type GetHrDocumentDetailQueryError = AxiosError<unknown>


export function useGetHrDocumentDetail<TData = Awaited<ReturnType<typeof getHrDocumentDetail>>, TError = AxiosError<unknown>>(
 documentId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHrDocumentDetail>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getHrDocumentDetail>>,
          TError,
          Awaited<ReturnType<typeof getHrDocumentDetail>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetHrDocumentDetail<TData = Awaited<ReturnType<typeof getHrDocumentDetail>>, TError = AxiosError<unknown>>(
 documentId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHrDocumentDetail>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getHrDocumentDetail>>,
          TError,
          Awaited<ReturnType<typeof getHrDocumentDetail>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetHrDocumentDetail<TData = Awaited<ReturnType<typeof getHrDocumentDetail>>, TError = AxiosError<unknown>>(
 documentId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHrDocumentDetail>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Gets the full detail for a single document (detail-dialog payload)
 */

export function useGetHrDocumentDetail<TData = Awaited<ReturnType<typeof getHrDocumentDetail>>, TError = AxiosError<unknown>>(
 documentId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHrDocumentDetail>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetHrDocumentDetailQueryOptions(documentId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Approves a submitted document, completing employer review
 */
export const approveHrDocument = (
    documentId: number,
    approveHrDocumentRequestSchema: ApproveHrDocumentRequestSchema, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.default.post(
      `/api/Hr/Documents/${documentId}/Approve`,
      approveHrDocumentRequestSchema,options
    );
  }



export const getApproveHrDocumentMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveHrDocument>>, TError,{documentId: number;data: ApproveHrDocumentRequestSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof approveHrDocument>>, TError,{documentId: number;data: ApproveHrDocumentRequestSchema}, TContext> => {
    
const mutationKey = ['approveHrDocument'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof approveHrDocument>>, {documentId: number;data: ApproveHrDocumentRequestSchema}> = (props) => {
          const {documentId,data} = props ?? {};

          return  approveHrDocument(documentId,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApproveHrDocumentMutationResult = NonNullable<Awaited<ReturnType<typeof approveHrDocument>>>
    export type ApproveHrDocumentMutationBody = ApproveHrDocumentRequestSchema
    export type ApproveHrDocumentMutationError = AxiosError<unknown>

    /**
 * @summary Approves a submitted document, completing employer review
 */
export const useApproveHrDocument = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveHrDocument>>, TError,{documentId: number;data: ApproveHrDocumentRequestSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof approveHrDocument>>,
        TError,
        {documentId: number;data: ApproveHrDocumentRequestSchema},
        TContext
      > => {

      const mutationOptions = getApproveHrDocumentMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Manually archives a document; the group's status recalc promotes the next-best document
 */
export const archiveHrDocument = (
    documentId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.default.post(
      `/api/Hr/Documents/${documentId}/Archive`,undefined,options
    );
  }



export const getArchiveHrDocumentMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof archiveHrDocument>>, TError,{documentId: number}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof archiveHrDocument>>, TError,{documentId: number}, TContext> => {
    
const mutationKey = ['archiveHrDocument'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof archiveHrDocument>>, {documentId: number}> = (props) => {
          const {documentId} = props ?? {};

          return  archiveHrDocument(documentId,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ArchiveHrDocumentMutationResult = NonNullable<Awaited<ReturnType<typeof archiveHrDocument>>>
    
    export type ArchiveHrDocumentMutationError = AxiosError<unknown>

    /**
 * @summary Manually archives a document; the group's status recalc promotes the next-best document
 */
export const useArchiveHrDocument = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof archiveHrDocument>>, TError,{documentId: number}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof archiveHrDocument>>,
        TError,
        {documentId: number},
        TContext
      > => {

      const mutationOptions = getArchiveHrDocumentMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Downloads the primary file of a document
 */
export const downloadHrDocument = (
    documentId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Blob>> => {
    
    
    return axios.default.get(
      `/api/Hr/Documents/${documentId}/Download`,{
        responseType: 'blob',
    ...options,}
    );
  }


export const getDownloadHrDocumentQueryKey = (documentId: number,) => {
    return [`/api/Hr/Documents/${documentId}/Download`] as const;
    }

    
export const getDownloadHrDocumentQueryOptions = <TData = Awaited<ReturnType<typeof downloadHrDocument>>, TError = AxiosError<unknown>>(documentId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadHrDocument>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDownloadHrDocumentQueryKey(documentId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadHrDocument>>> = ({ signal }) => downloadHrDocument(documentId, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(documentId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof downloadHrDocument>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DownloadHrDocumentQueryResult = NonNullable<Awaited<ReturnType<typeof downloadHrDocument>>>
export type DownloadHrDocumentQueryError = AxiosError<unknown>


export function useDownloadHrDocument<TData = Awaited<ReturnType<typeof downloadHrDocument>>, TError = AxiosError<unknown>>(
 documentId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadHrDocument>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadHrDocument>>,
          TError,
          Awaited<ReturnType<typeof downloadHrDocument>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadHrDocument<TData = Awaited<ReturnType<typeof downloadHrDocument>>, TError = AxiosError<unknown>>(
 documentId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadHrDocument>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadHrDocument>>,
          TError,
          Awaited<ReturnType<typeof downloadHrDocument>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadHrDocument<TData = Awaited<ReturnType<typeof downloadHrDocument>>, TError = AxiosError<unknown>>(
 documentId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadHrDocument>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Downloads the primary file of a document
 */

export function useDownloadHrDocument<TData = Awaited<ReturnType<typeof downloadHrDocument>>, TError = AxiosError<unknown>>(
 documentId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadHrDocument>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDownloadHrDocumentQueryOptions(documentId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Updates employer-owned metadata field values on a document
 */
export const updateHrDocumentEmployerFields = (
    documentId: number,
    updateHrDocumentEmployerFieldsRequestSchema: UpdateHrDocumentEmployerFieldsRequestSchema, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.default.put(
      `/api/Hr/Documents/${documentId}/EmployerFields`,
      updateHrDocumentEmployerFieldsRequestSchema,options
    );
  }



export const getUpdateHrDocumentEmployerFieldsMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateHrDocumentEmployerFields>>, TError,{documentId: number;data: UpdateHrDocumentEmployerFieldsRequestSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof updateHrDocumentEmployerFields>>, TError,{documentId: number;data: UpdateHrDocumentEmployerFieldsRequestSchema}, TContext> => {
    
const mutationKey = ['updateHrDocumentEmployerFields'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateHrDocumentEmployerFields>>, {documentId: number;data: UpdateHrDocumentEmployerFieldsRequestSchema}> = (props) => {
          const {documentId,data} = props ?? {};

          return  updateHrDocumentEmployerFields(documentId,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateHrDocumentEmployerFieldsMutationResult = NonNullable<Awaited<ReturnType<typeof updateHrDocumentEmployerFields>>>
    export type UpdateHrDocumentEmployerFieldsMutationBody = UpdateHrDocumentEmployerFieldsRequestSchema
    export type UpdateHrDocumentEmployerFieldsMutationError = AxiosError<unknown>

    /**
 * @summary Updates employer-owned metadata field values on a document
 */
export const useUpdateHrDocumentEmployerFields = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateHrDocumentEmployerFields>>, TError,{documentId: number;data: UpdateHrDocumentEmployerFieldsRequestSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof updateHrDocumentEmployerFields>>,
        TError,
        {documentId: number;data: UpdateHrDocumentEmployerFieldsRequestSchema},
        TContext
      > => {

      const mutationOptions = getUpdateHrDocumentEmployerFieldsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Submits the employer's completed DocuSeal form, completing review
 */
export const submitHrDocumentEmployerForm = (
    documentId: number,
    submitHrDocumentEmployerFormRequestSchema: SubmitHrDocumentEmployerFormRequestSchema, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.default.post(
      `/api/Hr/Documents/${documentId}/EmployerForm`,
      submitHrDocumentEmployerFormRequestSchema,options
    );
  }



export const getSubmitHrDocumentEmployerFormMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitHrDocumentEmployerForm>>, TError,{documentId: number;data: SubmitHrDocumentEmployerFormRequestSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof submitHrDocumentEmployerForm>>, TError,{documentId: number;data: SubmitHrDocumentEmployerFormRequestSchema}, TContext> => {
    
const mutationKey = ['submitHrDocumentEmployerForm'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof submitHrDocumentEmployerForm>>, {documentId: number;data: SubmitHrDocumentEmployerFormRequestSchema}> = (props) => {
          const {documentId,data} = props ?? {};

          return  submitHrDocumentEmployerForm(documentId,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SubmitHrDocumentEmployerFormMutationResult = NonNullable<Awaited<ReturnType<typeof submitHrDocumentEmployerForm>>>
    export type SubmitHrDocumentEmployerFormMutationBody = SubmitHrDocumentEmployerFormRequestSchema
    export type SubmitHrDocumentEmployerFormMutationError = AxiosError<unknown>

    /**
 * @summary Submits the employer's completed DocuSeal form, completing review
 */
export const useSubmitHrDocumentEmployerForm = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitHrDocumentEmployerForm>>, TError,{documentId: number;data: SubmitHrDocumentEmployerFormRequestSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof submitHrDocumentEmployerForm>>,
        TError,
        {documentId: number;data: SubmitHrDocumentEmployerFormRequestSchema},
        TContext
      > => {

      const mutationOptions = getSubmitHrDocumentEmployerFormMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Gets the DocuSeal submission slug for the employer to complete their form on a submitted document
 */
export const getHrDocumentEmployerSignSlug = (
    documentId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<HrDocumentEmployerSignSlugSchema>> => {
    
    
    return axios.default.get(
      `/api/Hr/Documents/${documentId}/EmployerSignSlug`,options
    );
  }


export const getGetHrDocumentEmployerSignSlugQueryKey = (documentId: number,) => {
    return [`/api/Hr/Documents/${documentId}/EmployerSignSlug`] as const;
    }

    
export const getGetHrDocumentEmployerSignSlugQueryOptions = <TData = Awaited<ReturnType<typeof getHrDocumentEmployerSignSlug>>, TError = AxiosError<unknown>>(documentId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHrDocumentEmployerSignSlug>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetHrDocumentEmployerSignSlugQueryKey(documentId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getHrDocumentEmployerSignSlug>>> = ({ signal }) => getHrDocumentEmployerSignSlug(documentId, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(documentId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getHrDocumentEmployerSignSlug>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetHrDocumentEmployerSignSlugQueryResult = NonNullable<Awaited<ReturnType<typeof getHrDocumentEmployerSignSlug>>>
export type GetHrDocumentEmployerSignSlugQueryError = AxiosError<unknown>


export function useGetHrDocumentEmployerSignSlug<TData = Awaited<ReturnType<typeof getHrDocumentEmployerSignSlug>>, TError = AxiosError<unknown>>(
 documentId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHrDocumentEmployerSignSlug>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getHrDocumentEmployerSignSlug>>,
          TError,
          Awaited<ReturnType<typeof getHrDocumentEmployerSignSlug>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetHrDocumentEmployerSignSlug<TData = Awaited<ReturnType<typeof getHrDocumentEmployerSignSlug>>, TError = AxiosError<unknown>>(
 documentId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHrDocumentEmployerSignSlug>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getHrDocumentEmployerSignSlug>>,
          TError,
          Awaited<ReturnType<typeof getHrDocumentEmployerSignSlug>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetHrDocumentEmployerSignSlug<TData = Awaited<ReturnType<typeof getHrDocumentEmployerSignSlug>>, TError = AxiosError<unknown>>(
 documentId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHrDocumentEmployerSignSlug>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Gets the DocuSeal submission slug for the employer to complete their form on a submitted document
 */

export function useGetHrDocumentEmployerSignSlug<TData = Awaited<ReturnType<typeof getHrDocumentEmployerSignSlug>>, TError = AxiosError<unknown>>(
 documentId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHrDocumentEmployerSignSlug>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetHrDocumentEmployerSignSlugQueryOptions(documentId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Rejects a submitted document and reopens the assignment for the employee to resubmit
 */
export const reopenHrDocument = (
    documentId: number,
    reopenHrDocumentRequestSchema: ReopenHrDocumentRequestSchema, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.default.post(
      `/api/Hr/Documents/${documentId}/Reopen`,
      reopenHrDocumentRequestSchema,options
    );
  }



export const getReopenHrDocumentMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reopenHrDocument>>, TError,{documentId: number;data: ReopenHrDocumentRequestSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof reopenHrDocument>>, TError,{documentId: number;data: ReopenHrDocumentRequestSchema}, TContext> => {
    
const mutationKey = ['reopenHrDocument'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reopenHrDocument>>, {documentId: number;data: ReopenHrDocumentRequestSchema}> = (props) => {
          const {documentId,data} = props ?? {};

          return  reopenHrDocument(documentId,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ReopenHrDocumentMutationResult = NonNullable<Awaited<ReturnType<typeof reopenHrDocument>>>
    export type ReopenHrDocumentMutationBody = ReopenHrDocumentRequestSchema
    export type ReopenHrDocumentMutationError = AxiosError<unknown>

    /**
 * @summary Rejects a submitted document and reopens the assignment for the employee to resubmit
 */
export const useReopenHrDocument = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reopenHrDocument>>, TError,{documentId: number;data: ReopenHrDocumentRequestSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof reopenHrDocument>>,
        TError,
        {documentId: number;data: ReopenHrDocumentRequestSchema},
        TContext
      > => {

      const mutationOptions = getReopenHrDocumentMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Updates the message sent to the employee on a currently-reopened document
 */
export const updateHrDocumentReopenMessage = (
    documentId: number,
    reopenHrDocumentRequestSchema: ReopenHrDocumentRequestSchema, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.default.put(
      `/api/Hr/Documents/${documentId}/ReopenMessage`,
      reopenHrDocumentRequestSchema,options
    );
  }



export const getUpdateHrDocumentReopenMessageMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateHrDocumentReopenMessage>>, TError,{documentId: number;data: ReopenHrDocumentRequestSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof updateHrDocumentReopenMessage>>, TError,{documentId: number;data: ReopenHrDocumentRequestSchema}, TContext> => {
    
const mutationKey = ['updateHrDocumentReopenMessage'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateHrDocumentReopenMessage>>, {documentId: number;data: ReopenHrDocumentRequestSchema}> = (props) => {
          const {documentId,data} = props ?? {};

          return  updateHrDocumentReopenMessage(documentId,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateHrDocumentReopenMessageMutationResult = NonNullable<Awaited<ReturnType<typeof updateHrDocumentReopenMessage>>>
    export type UpdateHrDocumentReopenMessageMutationBody = ReopenHrDocumentRequestSchema
    export type UpdateHrDocumentReopenMessageMutationError = AxiosError<unknown>

    /**
 * @summary Updates the message sent to the employee on a currently-reopened document
 */
export const useUpdateHrDocumentReopenMessage = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateHrDocumentReopenMessage>>, TError,{documentId: number;data: ReopenHrDocumentRequestSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof updateHrDocumentReopenMessage>>,
        TError,
        {documentId: number;data: ReopenHrDocumentRequestSchema},
        TContext
      > => {

      const mutationOptions = getUpdateHrDocumentReopenMessageMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Cancels a reopen request, returning the document to awaiting-review
 */
export const undoHrDocumentReopen = (
    documentId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.default.post(
      `/api/Hr/Documents/${documentId}/UndoReopen`,undefined,options
    );
  }



export const getUndoHrDocumentReopenMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof undoHrDocumentReopen>>, TError,{documentId: number}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof undoHrDocumentReopen>>, TError,{documentId: number}, TContext> => {
    
const mutationKey = ['undoHrDocumentReopen'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof undoHrDocumentReopen>>, {documentId: number}> = (props) => {
          const {documentId} = props ?? {};

          return  undoHrDocumentReopen(documentId,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UndoHrDocumentReopenMutationResult = NonNullable<Awaited<ReturnType<typeof undoHrDocumentReopen>>>
    
    export type UndoHrDocumentReopenMutationError = AxiosError<unknown>

    /**
 * @summary Cancels a reopen request, returning the document to awaiting-review
 */
export const useUndoHrDocumentReopen = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof undoHrDocumentReopen>>, TError,{documentId: number}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof undoHrDocumentReopen>>,
        TError,
        {documentId: number},
        TContext
      > => {

      const mutationOptions = getUndoHrDocumentReopenMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Uploads documents on behalf of an employee, each optionally mapped to a template
 */
export const uploadHrDocuments = (
    uploadHrDocumentsBody: UploadHrDocumentsBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<HrDocumentsUploadResultSchema>> => {
    
    const formData = createFormData(uploadHrDocumentsBody)
    return axios.default.post(
      `/api/Hr/Documents/Upload`,
      formData,options
    );
  }



export const getUploadHrDocumentsMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadHrDocuments>>, TError,{data: UploadHrDocumentsBody}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof uploadHrDocuments>>, TError,{data: UploadHrDocumentsBody}, TContext> => {
    
const mutationKey = ['uploadHrDocuments'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof uploadHrDocuments>>, {data: UploadHrDocumentsBody}> = (props) => {
          const {data} = props ?? {};

          return  uploadHrDocuments(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UploadHrDocumentsMutationResult = NonNullable<Awaited<ReturnType<typeof uploadHrDocuments>>>
    export type UploadHrDocumentsMutationBody = UploadHrDocumentsBody
    export type UploadHrDocumentsMutationError = AxiosError<unknown>

    /**
 * @summary Uploads documents on behalf of an employee, each optionally mapped to a template
 */
export const useUploadHrDocuments = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadHrDocuments>>, TError,{data: UploadHrDocumentsBody}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof uploadHrDocuments>>,
        TError,
        {data: UploadHrDocumentsBody},
        TContext
      > => {

      const mutationOptions = getUploadHrDocumentsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const receivePostback = (
    providerId: 1,
    params?: ReceivePostbackParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.default.post(
      `/api/Integrations/BackgroundCheck/${providerId}/Postback`,undefined,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getReceivePostbackMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof receivePostback>>, TError,{providerId: 1;params?: ReceivePostbackParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof receivePostback>>, TError,{providerId: 1;params?: ReceivePostbackParams}, TContext> => {
    
const mutationKey = ['receivePostback'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof receivePostback>>, {providerId: 1;params?: ReceivePostbackParams}> = (props) => {
          const {providerId,params} = props ?? {};

          return  receivePostback(providerId,params,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ReceivePostbackMutationResult = NonNullable<Awaited<ReturnType<typeof receivePostback>>>
    
    export type ReceivePostbackMutationError = AxiosError<unknown>

    export const useReceivePostback = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof receivePostback>>, TError,{providerId: 1;params?: ReceivePostbackParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof receivePostback>>,
        TError,
        {providerId: 1;params?: ReceivePostbackParams},
        TContext
      > => {

      const mutationOptions = getReceivePostbackMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getSapphireSamlIdpMetadata = (
    accountCode: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.default.get(
      `/api/Integrations/SapphireSaml/${accountCode}/metadata`,options
    );
  }


export const getGetSapphireSamlIdpMetadataQueryKey = (accountCode: string,) => {
    return [`/api/Integrations/SapphireSaml/${accountCode}/metadata`] as const;
    }

    
export const getGetSapphireSamlIdpMetadataQueryOptions = <TData = Awaited<ReturnType<typeof getSapphireSamlIdpMetadata>>, TError = AxiosError<unknown>>(accountCode: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSapphireSamlIdpMetadata>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSapphireSamlIdpMetadataQueryKey(accountCode);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSapphireSamlIdpMetadata>>> = ({ signal }) => getSapphireSamlIdpMetadata(accountCode, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(accountCode), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSapphireSamlIdpMetadata>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSapphireSamlIdpMetadataQueryResult = NonNullable<Awaited<ReturnType<typeof getSapphireSamlIdpMetadata>>>
export type GetSapphireSamlIdpMetadataQueryError = AxiosError<unknown>


export function useGetSapphireSamlIdpMetadata<TData = Awaited<ReturnType<typeof getSapphireSamlIdpMetadata>>, TError = AxiosError<unknown>>(
 accountCode: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSapphireSamlIdpMetadata>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSapphireSamlIdpMetadata>>,
          TError,
          Awaited<ReturnType<typeof getSapphireSamlIdpMetadata>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSapphireSamlIdpMetadata<TData = Awaited<ReturnType<typeof getSapphireSamlIdpMetadata>>, TError = AxiosError<unknown>>(
 accountCode: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSapphireSamlIdpMetadata>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSapphireSamlIdpMetadata>>,
          TError,
          Awaited<ReturnType<typeof getSapphireSamlIdpMetadata>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSapphireSamlIdpMetadata<TData = Awaited<ReturnType<typeof getSapphireSamlIdpMetadata>>, TError = AxiosError<unknown>>(
 accountCode: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSapphireSamlIdpMetadata>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetSapphireSamlIdpMetadata<TData = Awaited<ReturnType<typeof getSapphireSamlIdpMetadata>>, TError = AxiosError<unknown>>(
 accountCode: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSapphireSamlIdpMetadata>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSapphireSamlIdpMetadataQueryOptions(accountCode,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const generateSapphireSamlSso = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<SapphireSamlSsoResponseSchema>> => {
    
    
    return axios.default.post(
      `/api/Integrations/SapphireSaml/sso`,undefined,options
    );
  }



export const getGenerateSapphireSamlSsoMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateSapphireSamlSso>>, TError,void, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof generateSapphireSamlSso>>, TError,void, TContext> => {
    
const mutationKey = ['generateSapphireSamlSso'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof generateSapphireSamlSso>>, void> = () => {
          

          return  generateSapphireSamlSso(axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type GenerateSapphireSamlSsoMutationResult = NonNullable<Awaited<ReturnType<typeof generateSapphireSamlSso>>>
    
    export type GenerateSapphireSamlSsoMutationError = AxiosError<unknown>

    export const useGenerateSapphireSamlSso = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateSapphireSamlSso>>, TError,void, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof generateSapphireSamlSso>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getGenerateSapphireSamlSsoMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Gets manual check details by key
 */
export const getManualCheckDetails = (
    checkKey: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ManualCheckDetailsSchema>> => {
    
    
    return axios.default.get(
      `/api/ManualChecks/${checkKey}`,options
    );
  }


export const getGetManualCheckDetailsQueryKey = (checkKey: string,) => {
    return [`/api/ManualChecks/${checkKey}`] as const;
    }

    
export const getGetManualCheckDetailsQueryOptions = <TData = Awaited<ReturnType<typeof getManualCheckDetails>>, TError = AxiosError<unknown>>(checkKey: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getManualCheckDetails>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetManualCheckDetailsQueryKey(checkKey);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getManualCheckDetails>>> = ({ signal }) => getManualCheckDetails(checkKey, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(checkKey), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getManualCheckDetails>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetManualCheckDetailsQueryResult = NonNullable<Awaited<ReturnType<typeof getManualCheckDetails>>>
export type GetManualCheckDetailsQueryError = AxiosError<unknown>


export function useGetManualCheckDetails<TData = Awaited<ReturnType<typeof getManualCheckDetails>>, TError = AxiosError<unknown>>(
 checkKey: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getManualCheckDetails>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getManualCheckDetails>>,
          TError,
          Awaited<ReturnType<typeof getManualCheckDetails>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetManualCheckDetails<TData = Awaited<ReturnType<typeof getManualCheckDetails>>, TError = AxiosError<unknown>>(
 checkKey: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getManualCheckDetails>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getManualCheckDetails>>,
          TError,
          Awaited<ReturnType<typeof getManualCheckDetails>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetManualCheckDetails<TData = Awaited<ReturnType<typeof getManualCheckDetails>>, TError = AxiosError<unknown>>(
 checkKey: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getManualCheckDetails>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Gets manual check details by key
 */

export function useGetManualCheckDetails<TData = Awaited<ReturnType<typeof getManualCheckDetails>>, TError = AxiosError<unknown>>(
 checkKey: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getManualCheckDetails>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetManualCheckDetailsQueryOptions(checkKey,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getPaydeckSettings = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.default.get(
      `/api/PaydeckSettings`,options
    );
  }


export const getGetPaydeckSettingsQueryKey = () => {
    return [`/api/PaydeckSettings`] as const;
    }

    
export const getGetPaydeckSettingsQueryOptions = <TData = Awaited<ReturnType<typeof getPaydeckSettings>>, TError = AxiosError<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaydeckSettings>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPaydeckSettingsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPaydeckSettings>>> = ({ signal }) => getPaydeckSettings({ signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPaydeckSettings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPaydeckSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof getPaydeckSettings>>>
export type GetPaydeckSettingsQueryError = AxiosError<unknown>


export function useGetPaydeckSettings<TData = Awaited<ReturnType<typeof getPaydeckSettings>>, TError = AxiosError<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaydeckSettings>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPaydeckSettings>>,
          TError,
          Awaited<ReturnType<typeof getPaydeckSettings>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPaydeckSettings<TData = Awaited<ReturnType<typeof getPaydeckSettings>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaydeckSettings>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPaydeckSettings>>,
          TError,
          Awaited<ReturnType<typeof getPaydeckSettings>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPaydeckSettings<TData = Awaited<ReturnType<typeof getPaydeckSettings>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaydeckSettings>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPaydeckSettings<TData = Awaited<ReturnType<typeof getPaydeckSettings>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaydeckSettings>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPaydeckSettingsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const updatePaydeckSettings = (
    paydeckSettingsSchema: PaydeckSettingsSchema, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.default.post(
      `/api/PaydeckSettings`,
      paydeckSettingsSchema,options
    );
  }



export const getUpdatePaydeckSettingsMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePaydeckSettings>>, TError,{data: PaydeckSettingsSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof updatePaydeckSettings>>, TError,{data: PaydeckSettingsSchema}, TContext> => {
    
const mutationKey = ['updatePaydeckSettings'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updatePaydeckSettings>>, {data: PaydeckSettingsSchema}> = (props) => {
          const {data} = props ?? {};

          return  updatePaydeckSettings(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdatePaydeckSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof updatePaydeckSettings>>>
    export type UpdatePaydeckSettingsMutationBody = PaydeckSettingsSchema
    export type UpdatePaydeckSettingsMutationError = AxiosError<unknown>

    export const useUpdatePaydeckSettings = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePaydeckSettings>>, TError,{data: PaydeckSettingsSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof updatePaydeckSettings>>,
        TError,
        {data: PaydeckSettingsSchema},
        TContext
      > => {

      const mutationOptions = getUpdatePaydeckSettingsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Approves check issue by type
 */
export const approveCheckIssue = (
    payrollNumber: number,
    checkKey: string,
    issueType: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ApproveCheckIssueResultSchema>> => {
    
    
    return axios.default.post(
      `/api/PayrollAssistant/${payrollNumber}/Checks/${checkKey}/Issues/${issueType}`,undefined,options
    );
  }



export const getApproveCheckIssueMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveCheckIssue>>, TError,{payrollNumber: number;checkKey: string;issueType: string}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof approveCheckIssue>>, TError,{payrollNumber: number;checkKey: string;issueType: string}, TContext> => {
    
const mutationKey = ['approveCheckIssue'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof approveCheckIssue>>, {payrollNumber: number;checkKey: string;issueType: string}> = (props) => {
          const {payrollNumber,checkKey,issueType} = props ?? {};

          return  approveCheckIssue(payrollNumber,checkKey,issueType,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApproveCheckIssueMutationResult = NonNullable<Awaited<ReturnType<typeof approveCheckIssue>>>
    
    export type ApproveCheckIssueMutationError = AxiosError<unknown>

    /**
 * @summary Approves check issue by type
 */
export const useApproveCheckIssue = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveCheckIssue>>, TError,{payrollNumber: number;checkKey: string;issueType: string}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof approveCheckIssue>>,
        TError,
        {payrollNumber: number;checkKey: string;issueType: string},
        TContext
      > => {

      const mutationOptions = getApproveCheckIssueMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Gets payroll entry issues
 */
export const getPayrollEntryIssues = (
    payrollNumber: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PayrollEntryIssueSchema[]>> => {
    
    
    return axios.default.get(
      `/api/PayrollAssistant/${payrollNumber}/PayrollEntryIssues`,options
    );
  }


export const getGetPayrollEntryIssuesQueryKey = (payrollNumber: number,) => {
    return [`/api/PayrollAssistant/${payrollNumber}/PayrollEntryIssues`] as const;
    }

    
export const getGetPayrollEntryIssuesQueryOptions = <TData = Awaited<ReturnType<typeof getPayrollEntryIssues>>, TError = AxiosError<unknown>>(payrollNumber: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayrollEntryIssues>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPayrollEntryIssuesQueryKey(payrollNumber);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPayrollEntryIssues>>> = ({ signal }) => getPayrollEntryIssues(payrollNumber, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(payrollNumber), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPayrollEntryIssues>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPayrollEntryIssuesQueryResult = NonNullable<Awaited<ReturnType<typeof getPayrollEntryIssues>>>
export type GetPayrollEntryIssuesQueryError = AxiosError<unknown>


export function useGetPayrollEntryIssues<TData = Awaited<ReturnType<typeof getPayrollEntryIssues>>, TError = AxiosError<unknown>>(
 payrollNumber: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayrollEntryIssues>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPayrollEntryIssues>>,
          TError,
          Awaited<ReturnType<typeof getPayrollEntryIssues>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPayrollEntryIssues<TData = Awaited<ReturnType<typeof getPayrollEntryIssues>>, TError = AxiosError<unknown>>(
 payrollNumber: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayrollEntryIssues>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPayrollEntryIssues>>,
          TError,
          Awaited<ReturnType<typeof getPayrollEntryIssues>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPayrollEntryIssues<TData = Awaited<ReturnType<typeof getPayrollEntryIssues>>, TError = AxiosError<unknown>>(
 payrollNumber: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayrollEntryIssues>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Gets payroll entry issues
 */

export function useGetPayrollEntryIssues<TData = Awaited<ReturnType<typeof getPayrollEntryIssues>>, TError = AxiosError<unknown>>(
 payrollNumber: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayrollEntryIssues>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPayrollEntryIssuesQueryOptions(payrollNumber,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Updates warnings last review date
 */
export const updateWarningsLastReviewDate = (
    payrollNumber: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.default.post(
      `/api/PayrollAssistant/${payrollNumber}/PayrollEntryIssues/Warnings`,undefined,options
    );
  }



export const getUpdateWarningsLastReviewDateMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateWarningsLastReviewDate>>, TError,{payrollNumber: number}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof updateWarningsLastReviewDate>>, TError,{payrollNumber: number}, TContext> => {
    
const mutationKey = ['updateWarningsLastReviewDate'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateWarningsLastReviewDate>>, {payrollNumber: number}> = (props) => {
          const {payrollNumber} = props ?? {};

          return  updateWarningsLastReviewDate(payrollNumber,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateWarningsLastReviewDateMutationResult = NonNullable<Awaited<ReturnType<typeof updateWarningsLastReviewDate>>>
    
    export type UpdateWarningsLastReviewDateMutationError = AxiosError<unknown>

    /**
 * @summary Updates warnings last review date
 */
export const useUpdateWarningsLastReviewDate = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateWarningsLastReviewDate>>, TError,{payrollNumber: number}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof updateWarningsLastReviewDate>>,
        TError,
        {payrollNumber: number},
        TContext
      > => {

      const mutationOptions = getUpdateWarningsLastReviewDateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Gets payroll
 */
export const getPayroll = (
    payrollNumber: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PayrollSchema>> => {
    
    
    return axios.default.get(
      `/api/Payrolls/${payrollNumber}`,options
    );
  }


export const getGetPayrollQueryKey = (payrollNumber: number,) => {
    return [`/api/Payrolls/${payrollNumber}`] as const;
    }

    
export const getGetPayrollQueryOptions = <TData = Awaited<ReturnType<typeof getPayroll>>, TError = AxiosError<unknown>>(payrollNumber: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayroll>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPayrollQueryKey(payrollNumber);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPayroll>>> = ({ signal }) => getPayroll(payrollNumber, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(payrollNumber), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPayroll>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPayrollQueryResult = NonNullable<Awaited<ReturnType<typeof getPayroll>>>
export type GetPayrollQueryError = AxiosError<unknown>


export function useGetPayroll<TData = Awaited<ReturnType<typeof getPayroll>>, TError = AxiosError<unknown>>(
 payrollNumber: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayroll>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPayroll>>,
          TError,
          Awaited<ReturnType<typeof getPayroll>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPayroll<TData = Awaited<ReturnType<typeof getPayroll>>, TError = AxiosError<unknown>>(
 payrollNumber: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayroll>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPayroll>>,
          TError,
          Awaited<ReturnType<typeof getPayroll>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPayroll<TData = Awaited<ReturnType<typeof getPayroll>>, TError = AxiosError<unknown>>(
 payrollNumber: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayroll>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Gets payroll
 */

export function useGetPayroll<TData = Awaited<ReturnType<typeof getPayroll>>, TError = AxiosError<unknown>>(
 payrollNumber: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayroll>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPayrollQueryOptions(payrollNumber,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Adds check to payroll
 */
export const createChecks = (
    payrollNumber: number,
    createChecksPayloadSchema: CreateChecksPayloadSchema, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.default.post(
      `/api/Payrolls/${payrollNumber}/Checks`,
      createChecksPayloadSchema,options
    );
  }



export const getCreateChecksMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createChecks>>, TError,{payrollNumber: number;data: CreateChecksPayloadSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof createChecks>>, TError,{payrollNumber: number;data: CreateChecksPayloadSchema}, TContext> => {
    
const mutationKey = ['createChecks'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createChecks>>, {payrollNumber: number;data: CreateChecksPayloadSchema}> = (props) => {
          const {payrollNumber,data} = props ?? {};

          return  createChecks(payrollNumber,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateChecksMutationResult = NonNullable<Awaited<ReturnType<typeof createChecks>>>
    export type CreateChecksMutationBody = CreateChecksPayloadSchema
    export type CreateChecksMutationError = AxiosError<unknown>

    /**
 * @summary Adds check to payroll
 */
export const useCreateChecks = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createChecks>>, TError,{payrollNumber: number;data: CreateChecksPayloadSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof createChecks>>,
        TError,
        {payrollNumber: number;data: CreateChecksPayloadSchema},
        TContext
      > => {

      const mutationOptions = getCreateChecksMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Deletes payroll checks
 */
export const deleteChecks = (
    payrollNumber: number,
    params?: DeleteChecksParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.default.delete(
      `/api/Payrolls/${payrollNumber}/Checks`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getDeleteChecksMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteChecks>>, TError,{payrollNumber: number;params?: DeleteChecksParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof deleteChecks>>, TError,{payrollNumber: number;params?: DeleteChecksParams}, TContext> => {
    
const mutationKey = ['deleteChecks'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteChecks>>, {payrollNumber: number;params?: DeleteChecksParams}> = (props) => {
          const {payrollNumber,params} = props ?? {};

          return  deleteChecks(payrollNumber,params,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteChecksMutationResult = NonNullable<Awaited<ReturnType<typeof deleteChecks>>>
    
    export type DeleteChecksMutationError = AxiosError<unknown>

    /**
 * @summary Deletes payroll checks
 */
export const useDeleteChecks = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteChecks>>, TError,{payrollNumber: number;params?: DeleteChecksParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof deleteChecks>>,
        TError,
        {payrollNumber: number;params?: DeleteChecksParams},
        TContext
      > => {

      const mutationOptions = getDeleteChecksMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Updates checks
 */
export const updateChecks = (
    payrollNumber: number,
    updateChecksSchema: UpdateChecksSchema, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<CheckSchema[]>> => {
    
    
    return axios.default.put(
      `/api/Payrolls/${payrollNumber}/Checks`,
      updateChecksSchema,options
    );
  }



export const getUpdateChecksMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateChecks>>, TError,{payrollNumber: number;data: UpdateChecksSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof updateChecks>>, TError,{payrollNumber: number;data: UpdateChecksSchema}, TContext> => {
    
const mutationKey = ['updateChecks'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateChecks>>, {payrollNumber: number;data: UpdateChecksSchema}> = (props) => {
          const {payrollNumber,data} = props ?? {};

          return  updateChecks(payrollNumber,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateChecksMutationResult = NonNullable<Awaited<ReturnType<typeof updateChecks>>>
    export type UpdateChecksMutationBody = UpdateChecksSchema
    export type UpdateChecksMutationError = AxiosError<unknown>

    /**
 * @summary Updates checks
 */
export const useUpdateChecks = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateChecks>>, TError,{payrollNumber: number;data: UpdateChecksSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof updateChecks>>,
        TError,
        {payrollNumber: number;data: UpdateChecksSchema},
        TContext
      > => {

      const mutationOptions = getUpdateChecksMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Removes check from payroll
 */
export const removeCheck = (
    payrollNumber: number,
    checkKey: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<CheckSchema[]>> => {
    
    
    return axios.default.delete(
      `/api/Payrolls/${payrollNumber}/Checks/${checkKey}`,options
    );
  }



export const getRemoveCheckMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeCheck>>, TError,{payrollNumber: number;checkKey: string}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof removeCheck>>, TError,{payrollNumber: number;checkKey: string}, TContext> => {
    
const mutationKey = ['removeCheck'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof removeCheck>>, {payrollNumber: number;checkKey: string}> = (props) => {
          const {payrollNumber,checkKey} = props ?? {};

          return  removeCheck(payrollNumber,checkKey,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RemoveCheckMutationResult = NonNullable<Awaited<ReturnType<typeof removeCheck>>>
    
    export type RemoveCheckMutationError = AxiosError<unknown>

    /**
 * @summary Removes check from payroll
 */
export const useRemoveCheck = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeCheck>>, TError,{payrollNumber: number;checkKey: string}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof removeCheck>>,
        TError,
        {payrollNumber: number;checkKey: string},
        TContext
      > => {

      const mutationOptions = getRemoveCheckMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Updates checks column settings
 */
export const updateChecksColumnSettings = (
    payrollNumber: string,
    payrollChecksColumnSettingsSchema: PayrollChecksColumnSettingsSchema, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PayrollChecksColumnSettingsSchema>> => {
    
    
    return axios.default.post(
      `/api/Payrolls/${payrollNumber}/Checks/ColumnSettings`,
      payrollChecksColumnSettingsSchema,options
    );
  }



export const getUpdateChecksColumnSettingsMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateChecksColumnSettings>>, TError,{payrollNumber: string;data: PayrollChecksColumnSettingsSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof updateChecksColumnSettings>>, TError,{payrollNumber: string;data: PayrollChecksColumnSettingsSchema}, TContext> => {
    
const mutationKey = ['updateChecksColumnSettings'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateChecksColumnSettings>>, {payrollNumber: string;data: PayrollChecksColumnSettingsSchema}> = (props) => {
          const {payrollNumber,data} = props ?? {};

          return  updateChecksColumnSettings(payrollNumber,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateChecksColumnSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof updateChecksColumnSettings>>>
    export type UpdateChecksColumnSettingsMutationBody = PayrollChecksColumnSettingsSchema
    export type UpdateChecksColumnSettingsMutationError = AxiosError<unknown>

    /**
 * @summary Updates checks column settings
 */
export const useUpdateChecksColumnSettings = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateChecksColumnSettings>>, TError,{payrollNumber: string;data: PayrollChecksColumnSettingsSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof updateChecksColumnSettings>>,
        TError,
        {payrollNumber: string;data: PayrollChecksColumnSettingsSchema},
        TContext
      > => {

      const mutationOptions = getUpdateChecksColumnSettingsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Updates checks net override
 */
export const updateChecksNetOverride = (
    payrollNumber: number,
    updateChecksNetOverrideSchema: UpdateChecksNetOverrideSchema, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<CheckSchema[]>> => {
    
    
    return axios.default.put(
      `/api/Payrolls/${payrollNumber}/Checks/NetOverride`,
      updateChecksNetOverrideSchema,options
    );
  }



export const getUpdateChecksNetOverrideMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateChecksNetOverride>>, TError,{payrollNumber: number;data: UpdateChecksNetOverrideSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof updateChecksNetOverride>>, TError,{payrollNumber: number;data: UpdateChecksNetOverrideSchema}, TContext> => {
    
const mutationKey = ['updateChecksNetOverride'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateChecksNetOverride>>, {payrollNumber: number;data: UpdateChecksNetOverrideSchema}> = (props) => {
          const {payrollNumber,data} = props ?? {};

          return  updateChecksNetOverride(payrollNumber,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateChecksNetOverrideMutationResult = NonNullable<Awaited<ReturnType<typeof updateChecksNetOverride>>>
    export type UpdateChecksNetOverrideMutationBody = UpdateChecksNetOverrideSchema
    export type UpdateChecksNetOverrideMutationError = AxiosError<unknown>

    /**
 * @summary Updates checks net override
 */
export const useUpdateChecksNetOverride = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateChecksNetOverride>>, TError,{payrollNumber: number;data: UpdateChecksNetOverrideSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof updateChecksNetOverride>>,
        TError,
        {payrollNumber: number;data: UpdateChecksNetOverrideSchema},
        TContext
      > => {

      const mutationOptions = getUpdateChecksNetOverrideMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Updates checks sort settings
 */
export const updateChecksSortSettings = (
    payrollNumber: string,
    payrollChecksSortSettingsSchema: PayrollChecksSortSettingsSchema, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PayrollChecksSortSettingsSchema>> => {
    
    
    return axios.default.post(
      `/api/Payrolls/${payrollNumber}/Checks/SortSettings`,
      payrollChecksSortSettingsSchema,options
    );
  }



export const getUpdateChecksSortSettingsMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateChecksSortSettings>>, TError,{payrollNumber: string;data: PayrollChecksSortSettingsSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof updateChecksSortSettings>>, TError,{payrollNumber: string;data: PayrollChecksSortSettingsSchema}, TContext> => {
    
const mutationKey = ['updateChecksSortSettings'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateChecksSortSettings>>, {payrollNumber: string;data: PayrollChecksSortSettingsSchema}> = (props) => {
          const {payrollNumber,data} = props ?? {};

          return  updateChecksSortSettings(payrollNumber,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateChecksSortSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof updateChecksSortSettings>>>
    export type UpdateChecksSortSettingsMutationBody = PayrollChecksSortSettingsSchema
    export type UpdateChecksSortSettingsMutationError = AxiosError<unknown>

    /**
 * @summary Updates checks sort settings
 */
export const useUpdateChecksSortSettings = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateChecksSortSettings>>, TError,{payrollNumber: string;data: PayrollChecksSortSettingsSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof updateChecksSortSettings>>,
        TError,
        {payrollNumber: string;data: PayrollChecksSortSettingsSchema},
        TContext
      > => {

      const mutationOptions = getUpdateChecksSortSettingsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Updates type for checks in current payroll to direct deposit and activates direct deposit accounts for employee
 */
export const updateChecksTypeToDirectDeposit = (
    payrollNumber: number,
    employeeNumber: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<CheckSchema>> => {
    
    
    return axios.default.post(
      `/api/Payrolls/${payrollNumber}/Employees/${employeeNumber}/DirectDeposit`,undefined,options
    );
  }



export const getUpdateChecksTypeToDirectDepositMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateChecksTypeToDirectDeposit>>, TError,{payrollNumber: number;employeeNumber: number}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof updateChecksTypeToDirectDeposit>>, TError,{payrollNumber: number;employeeNumber: number}, TContext> => {
    
const mutationKey = ['updateChecksTypeToDirectDeposit'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateChecksTypeToDirectDeposit>>, {payrollNumber: number;employeeNumber: number}> = (props) => {
          const {payrollNumber,employeeNumber} = props ?? {};

          return  updateChecksTypeToDirectDeposit(payrollNumber,employeeNumber,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateChecksTypeToDirectDepositMutationResult = NonNullable<Awaited<ReturnType<typeof updateChecksTypeToDirectDeposit>>>
    
    export type UpdateChecksTypeToDirectDepositMutationError = AxiosError<unknown>

    /**
 * @summary Updates type for checks in current payroll to direct deposit and activates direct deposit accounts for employee
 */
export const useUpdateChecksTypeToDirectDeposit = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateChecksTypeToDirectDeposit>>, TError,{payrollNumber: number;employeeNumber: number}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof updateChecksTypeToDirectDeposit>>,
        TError,
        {payrollNumber: number;employeeNumber: number},
        TContext
      > => {

      const mutationOptions = getUpdateChecksTypeToDirectDepositMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Gets power grids
 */
export const getPowerGrids = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PowerGridAndImportSchema[]>> => {
    
    
    return axios.default.get(
      `/api/PowerGrids`,options
    );
  }


export const getGetPowerGridsQueryKey = () => {
    return [`/api/PowerGrids`] as const;
    }

    
export const getGetPowerGridsQueryOptions = <TData = Awaited<ReturnType<typeof getPowerGrids>>, TError = AxiosError<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPowerGrids>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPowerGridsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPowerGrids>>> = ({ signal }) => getPowerGrids({ signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPowerGrids>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPowerGridsQueryResult = NonNullable<Awaited<ReturnType<typeof getPowerGrids>>>
export type GetPowerGridsQueryError = AxiosError<unknown>


export function useGetPowerGrids<TData = Awaited<ReturnType<typeof getPowerGrids>>, TError = AxiosError<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPowerGrids>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPowerGrids>>,
          TError,
          Awaited<ReturnType<typeof getPowerGrids>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPowerGrids<TData = Awaited<ReturnType<typeof getPowerGrids>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPowerGrids>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPowerGrids>>,
          TError,
          Awaited<ReturnType<typeof getPowerGrids>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPowerGrids<TData = Awaited<ReturnType<typeof getPowerGrids>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPowerGrids>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Gets power grids
 */

export function useGetPowerGrids<TData = Awaited<ReturnType<typeof getPowerGrids>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPowerGrids>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPowerGridsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Processes power grids
 */
export const processPowerGrids = (
    payrollNumber: number,
    processPowerGridsSchema: ProcessPowerGridsSchema, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<CheckSchema[]>> => {
    
    
    return axios.default.post(
      `/api/Payrolls/${payrollNumber}/PowerGrids/Processed`,
      processPowerGridsSchema,options
    );
  }



export const getProcessPowerGridsMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof processPowerGrids>>, TError,{payrollNumber: number;data: ProcessPowerGridsSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof processPowerGrids>>, TError,{payrollNumber: number;data: ProcessPowerGridsSchema}, TContext> => {
    
const mutationKey = ['processPowerGrids'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof processPowerGrids>>, {payrollNumber: number;data: ProcessPowerGridsSchema}> = (props) => {
          const {payrollNumber,data} = props ?? {};

          return  processPowerGrids(payrollNumber,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ProcessPowerGridsMutationResult = NonNullable<Awaited<ReturnType<typeof processPowerGrids>>>
    export type ProcessPowerGridsMutationBody = ProcessPowerGridsSchema
    export type ProcessPowerGridsMutationError = AxiosError<unknown>

    /**
 * @summary Processes power grids
 */
export const useProcessPowerGrids = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof processPowerGrids>>, TError,{payrollNumber: number;data: ProcessPowerGridsSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof processPowerGrids>>,
        TError,
        {payrollNumber: number;data: ProcessPowerGridsSchema},
        TContext
      > => {

      const mutationOptions = getProcessPowerGridsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Unprocesses power grid
 */
export const unprocessPowerGrid = (
    payrollNumber: number,
    powerGridId: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<CheckSchema[]>> => {
    
    
    return axios.default.delete(
      `/api/Payrolls/${payrollNumber}/PowerGrids/Processed/${powerGridId}`,options
    );
  }



export const getUnprocessPowerGridMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unprocessPowerGrid>>, TError,{payrollNumber: number;powerGridId: string}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof unprocessPowerGrid>>, TError,{payrollNumber: number;powerGridId: string}, TContext> => {
    
const mutationKey = ['unprocessPowerGrid'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof unprocessPowerGrid>>, {payrollNumber: number;powerGridId: string}> = (props) => {
          const {payrollNumber,powerGridId} = props ?? {};

          return  unprocessPowerGrid(payrollNumber,powerGridId,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UnprocessPowerGridMutationResult = NonNullable<Awaited<ReturnType<typeof unprocessPowerGrid>>>
    
    export type UnprocessPowerGridMutationError = AxiosError<unknown>

    /**
 * @summary Unprocesses power grid
 */
export const useUnprocessPowerGrid = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unprocessPowerGrid>>, TError,{payrollNumber: number;powerGridId: string}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof unprocessPowerGrid>>,
        TError,
        {payrollNumber: number;powerGridId: string},
        TContext
      > => {

      const mutationOptions = getUnprocessPowerGridMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Processes time and labor power grid
 */
export const processTlmPowerGrid = (
    payrollNumber: number,
    timePeriodRpcSchema: TimePeriodRpcSchema, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<CheckSchema[]>> => {
    
    
    return axios.default.post(
      `/api/Payrolls/${payrollNumber}/PowerGrids/TimeAndLabor`,
      timePeriodRpcSchema,options
    );
  }



export const getProcessTlmPowerGridMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof processTlmPowerGrid>>, TError,{payrollNumber: number;data: TimePeriodRpcSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof processTlmPowerGrid>>, TError,{payrollNumber: number;data: TimePeriodRpcSchema}, TContext> => {
    
const mutationKey = ['processTlmPowerGrid'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof processTlmPowerGrid>>, {payrollNumber: number;data: TimePeriodRpcSchema}> = (props) => {
          const {payrollNumber,data} = props ?? {};

          return  processTlmPowerGrid(payrollNumber,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ProcessTlmPowerGridMutationResult = NonNullable<Awaited<ReturnType<typeof processTlmPowerGrid>>>
    export type ProcessTlmPowerGridMutationBody = TimePeriodRpcSchema
    export type ProcessTlmPowerGridMutationError = AxiosError<unknown>

    /**
 * @summary Processes time and labor power grid
 */
export const useProcessTlmPowerGrid = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof processTlmPowerGrid>>, TError,{payrollNumber: number;data: TimePeriodRpcSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof processTlmPowerGrid>>,
        TError,
        {payrollNumber: number;data: TimePeriodRpcSchema},
        TContext
      > => {

      const mutationOptions = getProcessTlmPowerGridMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Update payroll settings
 */
export const updatePayrollSettings = (
    payrollSettingsSchema: PayrollSettingsSchema, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PayrollSettingsSchema>> => {
    
    
    return axios.default.post(
      `/api/Payrolls/PayrollSettings`,
      payrollSettingsSchema,options
    );
  }



export const getUpdatePayrollSettingsMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePayrollSettings>>, TError,{data: PayrollSettingsSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof updatePayrollSettings>>, TError,{data: PayrollSettingsSchema}, TContext> => {
    
const mutationKey = ['updatePayrollSettings'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updatePayrollSettings>>, {data: PayrollSettingsSchema}> = (props) => {
          const {data} = props ?? {};

          return  updatePayrollSettings(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdatePayrollSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof updatePayrollSettings>>>
    export type UpdatePayrollSettingsMutationBody = PayrollSettingsSchema
    export type UpdatePayrollSettingsMutationError = AxiosError<unknown>

    /**
 * @summary Update payroll settings
 */
export const useUpdatePayrollSettings = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePayrollSettings>>, TError,{data: PayrollSettingsSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof updatePayrollSettings>>,
        TError,
        {data: PayrollSettingsSchema},
        TContext
      > => {

      const mutationOptions = getUpdatePayrollSettingsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Gets company payroll status
 */
export const getCompanyPayrollStatus = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PayrollStatusDataSchema>> => {
    
    
    return axios.default.get(
      `/api/Payrolls/Status`,options
    );
  }


export const getGetCompanyPayrollStatusQueryKey = () => {
    return [`/api/Payrolls/Status`] as const;
    }

    
export const getGetCompanyPayrollStatusQueryOptions = <TData = Awaited<ReturnType<typeof getCompanyPayrollStatus>>, TError = AxiosError<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanyPayrollStatus>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCompanyPayrollStatusQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCompanyPayrollStatus>>> = ({ signal }) => getCompanyPayrollStatus({ signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCompanyPayrollStatus>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCompanyPayrollStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getCompanyPayrollStatus>>>
export type GetCompanyPayrollStatusQueryError = AxiosError<unknown>


export function useGetCompanyPayrollStatus<TData = Awaited<ReturnType<typeof getCompanyPayrollStatus>>, TError = AxiosError<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanyPayrollStatus>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCompanyPayrollStatus>>,
          TError,
          Awaited<ReturnType<typeof getCompanyPayrollStatus>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCompanyPayrollStatus<TData = Awaited<ReturnType<typeof getCompanyPayrollStatus>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanyPayrollStatus>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCompanyPayrollStatus>>,
          TError,
          Awaited<ReturnType<typeof getCompanyPayrollStatus>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCompanyPayrollStatus<TData = Awaited<ReturnType<typeof getCompanyPayrollStatus>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanyPayrollStatus>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Gets company payroll status
 */

export function useGetCompanyPayrollStatus<TData = Awaited<ReturnType<typeof getCompanyPayrollStatus>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanyPayrollStatus>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCompanyPayrollStatusQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Creates new power grid
 */
export const createPowerGrid = (
    createPowerGridSchema: CreatePowerGridSchema, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<CreatePowerGridResponseSchema>> => {
    
    
    return axios.default.post(
      `/api/PowerGrids`,
      createPowerGridSchema,options
    );
  }



export const getCreatePowerGridMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPowerGrid>>, TError,{data: CreatePowerGridSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof createPowerGrid>>, TError,{data: CreatePowerGridSchema}, TContext> => {
    
const mutationKey = ['createPowerGrid'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createPowerGrid>>, {data: CreatePowerGridSchema}> = (props) => {
          const {data} = props ?? {};

          return  createPowerGrid(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreatePowerGridMutationResult = NonNullable<Awaited<ReturnType<typeof createPowerGrid>>>
    export type CreatePowerGridMutationBody = CreatePowerGridSchema
    export type CreatePowerGridMutationError = AxiosError<unknown>

    /**
 * @summary Creates new power grid
 */
export const useCreatePowerGrid = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPowerGrid>>, TError,{data: CreatePowerGridSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof createPowerGrid>>,
        TError,
        {data: CreatePowerGridSchema},
        TContext
      > => {

      const mutationOptions = getCreatePowerGridMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Updates power grid
 */
export const updatePowerGrid = (
    id: string,
    updatePowerGridSchema: UpdatePowerGridSchema, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.default.put(
      `/api/PowerGrids/${id}`,
      updatePowerGridSchema,options
    );
  }



export const getUpdatePowerGridMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePowerGrid>>, TError,{id: string;data: UpdatePowerGridSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof updatePowerGrid>>, TError,{id: string;data: UpdatePowerGridSchema}, TContext> => {
    
const mutationKey = ['updatePowerGrid'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updatePowerGrid>>, {id: string;data: UpdatePowerGridSchema}> = (props) => {
          const {id,data} = props ?? {};

          return  updatePowerGrid(id,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdatePowerGridMutationResult = NonNullable<Awaited<ReturnType<typeof updatePowerGrid>>>
    export type UpdatePowerGridMutationBody = UpdatePowerGridSchema
    export type UpdatePowerGridMutationError = AxiosError<unknown>

    /**
 * @summary Updates power grid
 */
export const useUpdatePowerGrid = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePowerGrid>>, TError,{id: string;data: UpdatePowerGridSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof updatePowerGrid>>,
        TError,
        {id: string;data: UpdatePowerGridSchema},
        TContext
      > => {

      const mutationOptions = getUpdatePowerGridMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Deletes power grid
 */
export const deletePowerGrid = (
    id: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.default.delete(
      `/api/PowerGrids/${id}`,options
    );
  }



export const getDeletePowerGridMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePowerGrid>>, TError,{id: string}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof deletePowerGrid>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['deletePowerGrid'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deletePowerGrid>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deletePowerGrid(id,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeletePowerGridMutationResult = NonNullable<Awaited<ReturnType<typeof deletePowerGrid>>>
    
    export type DeletePowerGridMutationError = AxiosError<unknown>

    /**
 * @summary Deletes power grid
 */
export const useDeletePowerGrid = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePowerGrid>>, TError,{id: string}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof deletePowerGrid>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeletePowerGridMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Gets power grid data
 */
export const getPowerGridData = (
    id: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PowerGridDataSchema>> => {
    
    
    return axios.default.get(
      `/api/PowerGrids/${id}/Data`,options
    );
  }


export const getGetPowerGridDataQueryKey = (id: string,) => {
    return [`/api/PowerGrids/${id}/Data`] as const;
    }

    
export const getGetPowerGridDataQueryOptions = <TData = Awaited<ReturnType<typeof getPowerGridData>>, TError = AxiosError<unknown>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPowerGridData>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPowerGridDataQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPowerGridData>>> = ({ signal }) => getPowerGridData(id, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPowerGridData>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPowerGridDataQueryResult = NonNullable<Awaited<ReturnType<typeof getPowerGridData>>>
export type GetPowerGridDataQueryError = AxiosError<unknown>


export function useGetPowerGridData<TData = Awaited<ReturnType<typeof getPowerGridData>>, TError = AxiosError<unknown>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPowerGridData>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPowerGridData>>,
          TError,
          Awaited<ReturnType<typeof getPowerGridData>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPowerGridData<TData = Awaited<ReturnType<typeof getPowerGridData>>, TError = AxiosError<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPowerGridData>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPowerGridData>>,
          TError,
          Awaited<ReturnType<typeof getPowerGridData>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPowerGridData<TData = Awaited<ReturnType<typeof getPowerGridData>>, TError = AxiosError<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPowerGridData>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Gets power grid data
 */

export function useGetPowerGridData<TData = Awaited<ReturnType<typeof getPowerGridData>>, TError = AxiosError<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPowerGridData>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPowerGridDataQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Gets distributed power grid rows
 */
export const getDistributedPowerGridRows = (
    id: string,
    params?: GetDistributedPowerGridRowsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetDistributedPowerGridResponseSchema>> => {
    
    
    return axios.default.get(
      `/api/PowerGrids/${id}/Distribution`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getGetDistributedPowerGridRowsQueryKey = (id: string,
    params?: GetDistributedPowerGridRowsParams,) => {
    return [`/api/PowerGrids/${id}/Distribution`, ...(params ? [params]: [])] as const;
    }

    
export const getGetDistributedPowerGridRowsQueryOptions = <TData = Awaited<ReturnType<typeof getDistributedPowerGridRows>>, TError = AxiosError<unknown>>(id: string,
    params?: GetDistributedPowerGridRowsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDistributedPowerGridRows>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDistributedPowerGridRowsQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDistributedPowerGridRows>>> = ({ signal }) => getDistributedPowerGridRows(id,params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDistributedPowerGridRows>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDistributedPowerGridRowsQueryResult = NonNullable<Awaited<ReturnType<typeof getDistributedPowerGridRows>>>
export type GetDistributedPowerGridRowsQueryError = AxiosError<unknown>


export function useGetDistributedPowerGridRows<TData = Awaited<ReturnType<typeof getDistributedPowerGridRows>>, TError = AxiosError<unknown>>(
 id: string,
    params: undefined |  GetDistributedPowerGridRowsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDistributedPowerGridRows>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDistributedPowerGridRows>>,
          TError,
          Awaited<ReturnType<typeof getDistributedPowerGridRows>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDistributedPowerGridRows<TData = Awaited<ReturnType<typeof getDistributedPowerGridRows>>, TError = AxiosError<unknown>>(
 id: string,
    params?: GetDistributedPowerGridRowsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDistributedPowerGridRows>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDistributedPowerGridRows>>,
          TError,
          Awaited<ReturnType<typeof getDistributedPowerGridRows>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDistributedPowerGridRows<TData = Awaited<ReturnType<typeof getDistributedPowerGridRows>>, TError = AxiosError<unknown>>(
 id: string,
    params?: GetDistributedPowerGridRowsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDistributedPowerGridRows>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Gets distributed power grid rows
 */

export function useGetDistributedPowerGridRows<TData = Awaited<ReturnType<typeof getDistributedPowerGridRows>>, TError = AxiosError<unknown>>(
 id: string,
    params?: GetDistributedPowerGridRowsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDistributedPowerGridRows>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDistributedPowerGridRowsQueryOptions(id,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Gets new power grid payee rows
 */
export const getNewPowerGridPayee = (
    id: string,
    params?: GetNewPowerGridPayeeParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PowerGridRowSchema[]>> => {
    
    
    return axios.default.get(
      `/api/PowerGrids/${id}/Payees/New`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getGetNewPowerGridPayeeQueryKey = (id: string,
    params?: GetNewPowerGridPayeeParams,) => {
    return [`/api/PowerGrids/${id}/Payees/New`, ...(params ? [params]: [])] as const;
    }

    
export const getGetNewPowerGridPayeeQueryOptions = <TData = Awaited<ReturnType<typeof getNewPowerGridPayee>>, TError = AxiosError<unknown>>(id: string,
    params?: GetNewPowerGridPayeeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNewPowerGridPayee>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetNewPowerGridPayeeQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getNewPowerGridPayee>>> = ({ signal }) => getNewPowerGridPayee(id,params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getNewPowerGridPayee>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetNewPowerGridPayeeQueryResult = NonNullable<Awaited<ReturnType<typeof getNewPowerGridPayee>>>
export type GetNewPowerGridPayeeQueryError = AxiosError<unknown>


export function useGetNewPowerGridPayee<TData = Awaited<ReturnType<typeof getNewPowerGridPayee>>, TError = AxiosError<unknown>>(
 id: string,
    params: undefined |  GetNewPowerGridPayeeParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNewPowerGridPayee>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNewPowerGridPayee>>,
          TError,
          Awaited<ReturnType<typeof getNewPowerGridPayee>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNewPowerGridPayee<TData = Awaited<ReturnType<typeof getNewPowerGridPayee>>, TError = AxiosError<unknown>>(
 id: string,
    params?: GetNewPowerGridPayeeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNewPowerGridPayee>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNewPowerGridPayee>>,
          TError,
          Awaited<ReturnType<typeof getNewPowerGridPayee>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNewPowerGridPayee<TData = Awaited<ReturnType<typeof getNewPowerGridPayee>>, TError = AxiosError<unknown>>(
 id: string,
    params?: GetNewPowerGridPayeeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNewPowerGridPayee>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Gets new power grid payee rows
 */

export function useGetNewPowerGridPayee<TData = Awaited<ReturnType<typeof getNewPowerGridPayee>>, TError = AxiosError<unknown>>(
 id: string,
    params?: GetNewPowerGridPayeeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNewPowerGridPayee>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetNewPowerGridPayeeQueryOptions(id,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Completes and/or reopens multiple payroll power grids in a single request
 */
export const setPowerGridsCompletion = (
    powerGridsCompletionRequestSchema: PowerGridsCompletionRequestSchema, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PowerGridAndImportSchema[]>> => {
    
    
    return axios.default.put(
      `/api/PowerGrids/Completion`,
      powerGridsCompletionRequestSchema,options
    );
  }



export const getSetPowerGridsCompletionMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setPowerGridsCompletion>>, TError,{data: PowerGridsCompletionRequestSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof setPowerGridsCompletion>>, TError,{data: PowerGridsCompletionRequestSchema}, TContext> => {
    
const mutationKey = ['setPowerGridsCompletion'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setPowerGridsCompletion>>, {data: PowerGridsCompletionRequestSchema}> = (props) => {
          const {data} = props ?? {};

          return  setPowerGridsCompletion(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SetPowerGridsCompletionMutationResult = NonNullable<Awaited<ReturnType<typeof setPowerGridsCompletion>>>
    export type SetPowerGridsCompletionMutationBody = PowerGridsCompletionRequestSchema
    export type SetPowerGridsCompletionMutationError = AxiosError<unknown>

    /**
 * @summary Completes and/or reopens multiple payroll power grids in a single request
 */
export const useSetPowerGridsCompletion = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setPowerGridsCompletion>>, TError,{data: PowerGridsCompletionRequestSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof setPowerGridsCompletion>>,
        TError,
        {data: PowerGridsCompletionRequestSchema},
        TContext
      > => {

      const mutationOptions = getSetPowerGridsCompletionMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Gets power grid schemas
 */
export const getPowerGridSchemas = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PowerGridSchemaSchema[]>> => {
    
    
    return axios.default.get(
      `/api/PowerGrids/Schemas`,options
    );
  }


export const getGetPowerGridSchemasQueryKey = () => {
    return [`/api/PowerGrids/Schemas`] as const;
    }

    
export const getGetPowerGridSchemasQueryOptions = <TData = Awaited<ReturnType<typeof getPowerGridSchemas>>, TError = AxiosError<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPowerGridSchemas>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPowerGridSchemasQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPowerGridSchemas>>> = ({ signal }) => getPowerGridSchemas({ signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPowerGridSchemas>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPowerGridSchemasQueryResult = NonNullable<Awaited<ReturnType<typeof getPowerGridSchemas>>>
export type GetPowerGridSchemasQueryError = AxiosError<unknown>


export function useGetPowerGridSchemas<TData = Awaited<ReturnType<typeof getPowerGridSchemas>>, TError = AxiosError<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPowerGridSchemas>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPowerGridSchemas>>,
          TError,
          Awaited<ReturnType<typeof getPowerGridSchemas>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPowerGridSchemas<TData = Awaited<ReturnType<typeof getPowerGridSchemas>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPowerGridSchemas>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPowerGridSchemas>>,
          TError,
          Awaited<ReturnType<typeof getPowerGridSchemas>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPowerGridSchemas<TData = Awaited<ReturnType<typeof getPowerGridSchemas>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPowerGridSchemas>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Gets power grid schemas
 */

export function useGetPowerGridSchemas<TData = Awaited<ReturnType<typeof getPowerGridSchemas>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPowerGridSchemas>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPowerGridSchemasQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getIntegrationLinks = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ThirdPartyIntegrationLinkSchema[]>> => {
    
    
    return axios.default.get(
      `/api/ThirdPartyIntegrations`,options
    );
  }


export const getGetIntegrationLinksQueryKey = () => {
    return [`/api/ThirdPartyIntegrations`] as const;
    }

    
export const getGetIntegrationLinksQueryOptions = <TData = Awaited<ReturnType<typeof getIntegrationLinks>>, TError = AxiosError<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIntegrationLinks>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetIntegrationLinksQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getIntegrationLinks>>> = ({ signal }) => getIntegrationLinks({ signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getIntegrationLinks>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetIntegrationLinksQueryResult = NonNullable<Awaited<ReturnType<typeof getIntegrationLinks>>>
export type GetIntegrationLinksQueryError = AxiosError<unknown>


export function useGetIntegrationLinks<TData = Awaited<ReturnType<typeof getIntegrationLinks>>, TError = AxiosError<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIntegrationLinks>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIntegrationLinks>>,
          TError,
          Awaited<ReturnType<typeof getIntegrationLinks>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetIntegrationLinks<TData = Awaited<ReturnType<typeof getIntegrationLinks>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIntegrationLinks>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIntegrationLinks>>,
          TError,
          Awaited<ReturnType<typeof getIntegrationLinks>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetIntegrationLinks<TData = Awaited<ReturnType<typeof getIntegrationLinks>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIntegrationLinks>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetIntegrationLinks<TData = Awaited<ReturnType<typeof getIntegrationLinks>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIntegrationLinks>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetIntegrationLinksQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getTwoFactorAuthDetails = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<TwoFactorAuthDetailsSchema>> => {
    
    
    return axios.default.get(
      `/api/TwoFactorAuth`,options
    );
  }


export const getGetTwoFactorAuthDetailsQueryKey = () => {
    return [`/api/TwoFactorAuth`] as const;
    }

    
export const getGetTwoFactorAuthDetailsQueryOptions = <TData = Awaited<ReturnType<typeof getTwoFactorAuthDetails>>, TError = AxiosError<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTwoFactorAuthDetails>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTwoFactorAuthDetailsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTwoFactorAuthDetails>>> = ({ signal }) => getTwoFactorAuthDetails({ signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTwoFactorAuthDetails>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTwoFactorAuthDetailsQueryResult = NonNullable<Awaited<ReturnType<typeof getTwoFactorAuthDetails>>>
export type GetTwoFactorAuthDetailsQueryError = AxiosError<unknown>


export function useGetTwoFactorAuthDetails<TData = Awaited<ReturnType<typeof getTwoFactorAuthDetails>>, TError = AxiosError<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTwoFactorAuthDetails>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTwoFactorAuthDetails>>,
          TError,
          Awaited<ReturnType<typeof getTwoFactorAuthDetails>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTwoFactorAuthDetails<TData = Awaited<ReturnType<typeof getTwoFactorAuthDetails>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTwoFactorAuthDetails>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTwoFactorAuthDetails>>,
          TError,
          Awaited<ReturnType<typeof getTwoFactorAuthDetails>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTwoFactorAuthDetails<TData = Awaited<ReturnType<typeof getTwoFactorAuthDetails>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTwoFactorAuthDetails>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetTwoFactorAuthDetails<TData = Awaited<ReturnType<typeof getTwoFactorAuthDetails>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTwoFactorAuthDetails>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTwoFactorAuthDetailsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const setUpTwoFactorAuthenticator = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<AuthenticatorSetupInfoSchema>> => {
    
    
    return axios.default.post(
      `/api/TwoFactorAuth/Authenticator/Setup`,undefined,options
    );
  }



export const getSetUpTwoFactorAuthenticatorMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setUpTwoFactorAuthenticator>>, TError,void, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof setUpTwoFactorAuthenticator>>, TError,void, TContext> => {
    
const mutationKey = ['setUpTwoFactorAuthenticator'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setUpTwoFactorAuthenticator>>, void> = () => {
          

          return  setUpTwoFactorAuthenticator(axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SetUpTwoFactorAuthenticatorMutationResult = NonNullable<Awaited<ReturnType<typeof setUpTwoFactorAuthenticator>>>
    
    export type SetUpTwoFactorAuthenticatorMutationError = AxiosError<unknown>

    export const useSetUpTwoFactorAuthenticator = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setUpTwoFactorAuthenticator>>, TError,void, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof setUpTwoFactorAuthenticator>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getSetUpTwoFactorAuthenticatorMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const verifyTwoFactorAuthenticator = (
    verifyCodeSchema: VerifyCodeSchema, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<AuthenticatorVerifyResultSchema>> => {
    
    
    return axios.default.post(
      `/api/TwoFactorAuth/Authenticator/Verify`,
      verifyCodeSchema,options
    );
  }



export const getVerifyTwoFactorAuthenticatorMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verifyTwoFactorAuthenticator>>, TError,{data: VerifyCodeSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof verifyTwoFactorAuthenticator>>, TError,{data: VerifyCodeSchema}, TContext> => {
    
const mutationKey = ['verifyTwoFactorAuthenticator'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof verifyTwoFactorAuthenticator>>, {data: VerifyCodeSchema}> = (props) => {
          const {data} = props ?? {};

          return  verifyTwoFactorAuthenticator(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type VerifyTwoFactorAuthenticatorMutationResult = NonNullable<Awaited<ReturnType<typeof verifyTwoFactorAuthenticator>>>
    export type VerifyTwoFactorAuthenticatorMutationBody = VerifyCodeSchema
    export type VerifyTwoFactorAuthenticatorMutationError = AxiosError<unknown>

    export const useVerifyTwoFactorAuthenticator = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verifyTwoFactorAuthenticator>>, TError,{data: VerifyCodeSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof verifyTwoFactorAuthenticator>>,
        TError,
        {data: VerifyCodeSchema},
        TContext
      > => {

      const mutationOptions = getVerifyTwoFactorAuthenticatorMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const regenerateTwoFactorRecoveryCodes = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<RecoveryCodesResultSchema>> => {
    
    
    return axios.default.post(
      `/api/TwoFactorAuth/RecoveryCodes/Regenerate`,undefined,options
    );
  }



export const getRegenerateTwoFactorRecoveryCodesMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof regenerateTwoFactorRecoveryCodes>>, TError,void, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof regenerateTwoFactorRecoveryCodes>>, TError,void, TContext> => {
    
const mutationKey = ['regenerateTwoFactorRecoveryCodes'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof regenerateTwoFactorRecoveryCodes>>, void> = () => {
          

          return  regenerateTwoFactorRecoveryCodes(axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RegenerateTwoFactorRecoveryCodesMutationResult = NonNullable<Awaited<ReturnType<typeof regenerateTwoFactorRecoveryCodes>>>
    
    export type RegenerateTwoFactorRecoveryCodesMutationError = AxiosError<unknown>

    export const useRegenerateTwoFactorRecoveryCodes = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof regenerateTwoFactorRecoveryCodes>>, TError,void, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof regenerateTwoFactorRecoveryCodes>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getRegenerateTwoFactorRecoveryCodesMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const sendTwoFactorAuthCode = (
    setUpTwoFactorAuthSchema: SetUpTwoFactorAuthSchema, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.default.post(
      `/api/TwoFactorAuth/SendCode`,
      setUpTwoFactorAuthSchema,options
    );
  }



export const getSendTwoFactorAuthCodeMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendTwoFactorAuthCode>>, TError,{data: SetUpTwoFactorAuthSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof sendTwoFactorAuthCode>>, TError,{data: SetUpTwoFactorAuthSchema}, TContext> => {
    
const mutationKey = ['sendTwoFactorAuthCode'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendTwoFactorAuthCode>>, {data: SetUpTwoFactorAuthSchema}> = (props) => {
          const {data} = props ?? {};

          return  sendTwoFactorAuthCode(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SendTwoFactorAuthCodeMutationResult = NonNullable<Awaited<ReturnType<typeof sendTwoFactorAuthCode>>>
    export type SendTwoFactorAuthCodeMutationBody = SetUpTwoFactorAuthSchema
    export type SendTwoFactorAuthCodeMutationError = AxiosError<unknown>

    export const useSendTwoFactorAuthCode = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendTwoFactorAuthCode>>, TError,{data: SetUpTwoFactorAuthSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof sendTwoFactorAuthCode>>,
        TError,
        {data: SetUpTwoFactorAuthSchema},
        TContext
      > => {

      const mutationOptions = getSendTwoFactorAuthCodeMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const verifyTwoFactorStepUp = (
    verifyCodeSchema: VerifyCodeSchema, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.default.post(
      `/api/TwoFactorAuth/StepUp/Verify`,
      verifyCodeSchema,options
    );
  }



export const getVerifyTwoFactorStepUpMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verifyTwoFactorStepUp>>, TError,{data: VerifyCodeSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof verifyTwoFactorStepUp>>, TError,{data: VerifyCodeSchema}, TContext> => {
    
const mutationKey = ['verifyTwoFactorStepUp'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof verifyTwoFactorStepUp>>, {data: VerifyCodeSchema}> = (props) => {
          const {data} = props ?? {};

          return  verifyTwoFactorStepUp(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type VerifyTwoFactorStepUpMutationResult = NonNullable<Awaited<ReturnType<typeof verifyTwoFactorStepUp>>>
    export type VerifyTwoFactorStepUpMutationBody = VerifyCodeSchema
    export type VerifyTwoFactorStepUpMutationError = AxiosError<unknown>

    export const useVerifyTwoFactorStepUp = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verifyTwoFactorStepUp>>, TError,{data: VerifyCodeSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof verifyTwoFactorStepUp>>,
        TError,
        {data: VerifyCodeSchema},
        TContext
      > => {

      const mutationOptions = getVerifyTwoFactorStepUpMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const verifyTwoFactorAuthCode = (
    verifyCodeSchema: VerifyCodeSchema, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<UserAuthorizationResultsSchema>> => {
    
    
    return axios.default.post(
      `/api/TwoFactorAuth/VerifyCode`,
      verifyCodeSchema,options
    );
  }



export const getVerifyTwoFactorAuthCodeMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verifyTwoFactorAuthCode>>, TError,{data: VerifyCodeSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof verifyTwoFactorAuthCode>>, TError,{data: VerifyCodeSchema}, TContext> => {
    
const mutationKey = ['verifyTwoFactorAuthCode'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof verifyTwoFactorAuthCode>>, {data: VerifyCodeSchema}> = (props) => {
          const {data} = props ?? {};

          return  verifyTwoFactorAuthCode(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type VerifyTwoFactorAuthCodeMutationResult = NonNullable<Awaited<ReturnType<typeof verifyTwoFactorAuthCode>>>
    export type VerifyTwoFactorAuthCodeMutationBody = VerifyCodeSchema
    export type VerifyTwoFactorAuthCodeMutationError = AxiosError<unknown>

    export const useVerifyTwoFactorAuthCode = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verifyTwoFactorAuthCode>>, TError,{data: VerifyCodeSchema}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof verifyTwoFactorAuthCode>>,
        TError,
        {data: VerifyCodeSchema},
        TContext
      > => {

      const mutationOptions = getVerifyTwoFactorAuthCodeMutationOptions(options);

      return useMutation(mutationOptions);
    }
